
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree364"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree364"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ksSD2", function(module, exports) {

$parcel$export(module.exports, "AdobeIMS", () => (parcelRequire("dFFsZ")).AdobeIMS);

var $dFFsZ = parcelRequire("dFFsZ");

});
parcelRegister("dFFsZ", function(module, exports) {
"use strict";
var $9f3f451e3e2c99c0$var$__assign = module.exports && module.exports.__assign || function() {
    $9f3f451e3e2c99c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f3f451e3e2c99c0$var$__assign.apply(this, arguments);
};
var $9f3f451e3e2c99c0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9f3f451e3e2c99c0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9f3f451e3e2c99c0$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9f3f451e3e2c99c0$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9f3f451e3e2c99c0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdobeIMS = void 0;

var $ggFBI = parcelRequire("ggFBI");

var $9f3f451e3e2c99c0$var$Log_1 = $9f3f451e3e2c99c0$var$__importDefault((parcelRequire("62W4m")));

var $l7sfa = parcelRequire("l7sfa");

var $4CAMl = parcelRequire("4CAMl");

var $fbARu = parcelRequire("fbARu");

var $8bNRG = parcelRequire("8bNRG");

var $5ccdI = parcelRequire("5ccdI");

var $4Murb = parcelRequire("4Murb");

var $98trQ = parcelRequire("98trQ");

var $6eKgv = parcelRequire("6eKgv");

var $gJKR4 = parcelRequire("gJKR4");

var $9f3f451e3e2c99c0$var$UrlHelper_1 = $9f3f451e3e2c99c0$var$__importDefault((parcelRequire("elOOj")));

var $9f3f451e3e2c99c0$var$FragmentHelper_1 = $9f3f451e3e2c99c0$var$__importDefault((parcelRequire("8iphV")));

var $kKZ0Z = parcelRequire("kKZ0Z");

var $3qDJh = parcelRequire("3qDJh");

var $17lxq = parcelRequire("17lxq");

var $3s2dW = parcelRequire("3s2dW");

var $9f3f451e3e2c99c0$var$TokenAutoRefresh_1 = $9f3f451e3e2c99c0$var$__importDefault((parcelRequire("cMYyL")));

var $5Qrtd = parcelRequire("5Qrtd");

var $9f3f451e3e2c99c0$var$Environment_1 = $9f3f451e3e2c99c0$var$__importDefault((parcelRequire("4eyaY")));

var $b1rY6 = parcelRequire("b1rY6");

var $Dph68 = parcelRequire("Dph68");

var $8a1xD = parcelRequire("8a1xD");

var $hovA1 = parcelRequire("hovA1");

var $cal07 = parcelRequire("cal07");

var $75WTM = parcelRequire("75WTM");

var $ejqaF = parcelRequire("ejqaF");

var $7RVR2 = parcelRequire("7RVR2");

var $5yTWj = parcelRequire("5yTWj");
/**
 * Class used as a facade for ims library in order to provide public access to library functionalities
 *
 */ var $9f3f451e3e2c99c0$var$AdobeIMS = /** @class */ function() {
    /**
     * @constructor adobeData {AdobeIdData}
     * If adobeData is not null, the adobeIdData instance will be created based on these values
     *
     * if no adobeData, the imsLibrary try to read these values from window.adobeid
     *
     * After this AdobeIms class is created, it can be accessed by window[{adobeData.clientId}]
     */ function AdobeIMS(adobeData, instanceKey) {
        if (adobeData === void 0) adobeData = null;
        var _this = this;
        /**
         * flag used to block the access to signin, signout functions in case the library is not fully initialized
         * { Boolean }; true if library is initialized, otherwise false
         */ this.initialized = false;
        /**
         * The key in the window scope where the IMSLib instance is defined (if using the CDN version)
         * This key is used to prefix certain storage keys, such as the CSRF nonce
         */ this.instanceKey = $5Qrtd.AdobeIMSKey;
        /**
         *
         * @param authUrlRedirectResponse {String} represents the authorization redirect response
         */ this.onPopupMessage = function(authUrlRedirectResponse) {
            if (!!authUrlRedirectResponse && !!_this.adobeIdData.onModalModeSignInComplete) {
                var response = _this.tokenService.getTokenFromFragment(authUrlRedirectResponse);
                if (response instanceof $hovA1.TokenFields) {
                    _this.tokenService.addTokenToStorage(response);
                    if (_this.adobeIdData.onModalModeSignInComplete(response)) return Promise.resolve();
                }
            }
            $9f3f451e3e2c99c0$var$UrlHelper_1.default.replaceUrl(authUrlRedirectResponse);
            return _this.initialize();
        };
        /**
         * Method used to redirect the user to signin url
         *
         * <uml>
         * start
         * :SignIn;
         * :Create the state object by using appCode, appVersion (used on server side) from adobeId.analytics and contextToBePassedOnRedirect;
         * :Create the redirect url using external parameters. state object will be part of redirect url;
         * :user must enter the credentials and after that is redirected to initial uri;
         * :initialize method is used which will trigger the onAccessToken;
         * end
         * </uml>
         *
         *
         * @param externalParameters {Object} object sent from outside in order to have the possibility to override the default values when the redirect uri is created
         * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
         * @param grantType {IGrantTypes} represents the grant type used for sign in flow
         *
         */ this.signIn = function() {
            var args_1 = [];
            for(var _i = 0; _i < arguments.length; _i++)args_1[_i] = arguments[_i];
            return $9f3f451e3e2c99c0$var$__awaiter(_this, $9f3f451e3e2c99c0$var$__spreadArray([], $9f3f451e3e2c99c0$var$__read(args_1), false), void 0, function(externalParameters, contextToBePassedOnRedirect, grantType) {
                var _a, adobeIdData, csrfService, nonce, authorizeRequestData;
                if (externalParameters === void 0) externalParameters = {};
                if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
                return $9f3f451e3e2c99c0$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.checkInitialized();
                            _a = this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
                            nonce = csrfService.initialize();
                            return [
                                4 /*yield*/ ,
                                adobeIdData.createRedirectRequest(externalParameters, contextToBePassedOnRedirect, nonce, grantType)
                            ];
                        case 1:
                            authorizeRequestData = _b.sent();
                            this.signInservice.signIn(authorizeRequestData);
                            return [
                                2 /*return*/ ,
                                Promise.resolve()
                            ];
                    }
                });
            });
        };
        /**
         * method used to sign in using an external token
         * @param token { String } token used for authorize; if the token is empty, the user will be redirected to the sign in screen
         * @param externalParameters {Object} object sent from outside in order to have the possibility to override the default values when the redirect uri is created
         * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
         */ this.authorizeToken = function(token, externalParameters, contextToBePassedOnRedirect, grantType) {
            if (token === void 0) token = "";
            if (externalParameters === void 0) externalParameters = {};
            if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
            var _a = _this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
            var nonce = csrfService.initialize();
            return adobeIdData.createRedirectRequest(externalParameters, contextToBePassedOnRedirect, nonce, grantType).then(function(authorizeRequestData) {
                new $l7sfa.SignInService().authorizeToken(token, authorizeRequestData);
            });
        };
        /**
         * Method used to reAuthenticate the user
         *
         * <uml>
         * start
         * :Create the state object by using appCode, appVersion (used on server side) from adobeId.analytics and contextToBePassedOnRedirect;
         * :Create the redirect url using external parameters. state object will be part of redirect url;
         * :SignIn;
         * :user must enter the credentials and after that is redirected to initial uri;
         * :initialize method is used which will trigger the token and profile;
         * end
         *
         * </uml>
         *
         * @param requestedParameters object sent from outside in order to use diferent values for reAuthenticate
         * @param contextToBePassedOnRedirect {Object | undefined} represents the context which is passed during redirect
         * @param reauth {string}; represents the re authenticate value. available values are: check and force. default value is "check"
         *
         */ this.reAuthenticate = function(requestedParameters, reauth, contextToBePassedOnRedirect, grantType) {
            if (requestedParameters === void 0) requestedParameters = {};
            if (reauth === void 0) reauth = $4Murb.IReauth.check;
            if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
            _this.checkInitialized();
            var _a = _this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
            var nonce = csrfService.initialize();
            return adobeIdData.createReAuthenticateRedirectRequest(requestedParameters, contextToBePassedOnRedirect, nonce, reauth, grantType).then(function(authorizeRequestData) {
                _this.signInservice.signIn(authorizeRequestData);
            });
        };
        /**
         * sign in with social providers
         * @param providerName provider name used for sign in
         * @param externalParameters external parameters sent by developer
         * @param contextToBePassedOnRedirect {Object} state of the application
         */ this.signInWithSocialProvider = function(providerName, externalParameters, contextToBePassedOnRedirect, grantType) {
            if (externalParameters === void 0) externalParameters = {};
            if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
            _this.checkInitialized();
            if (!providerName) throw new Error("please provide the provider name");
            var _a = _this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
            var nonce = csrfService.initialize();
            adobeIdData.createSocialProviderRedirectRequest(providerName, externalParameters, contextToBePassedOnRedirect, nonce, grantType).then(function(authorizeRequestData) {
                _this.signInservice.signIn(authorizeRequestData);
            });
        };
        /**
         *  Method used for sign out the user
         *
         * <uml>
         * start
         * :Signout;
         * :Create the redirect url;
         * :remove the token and profile from storage;
         * :initialize method is used which will redirect the app to initial url;
         * end
         * </uml>
         *
         * @param externalParameters {Object} object sent from outside in order to have the possibility to override the default values when the redirect uri is created
         *
         */ this.signOut = function(externalParameters) {
            if (externalParameters === void 0) externalParameters = {};
            _this.checkInitialized();
            _this.tokenService.purge();
            _this.profileService.removeProfile();
            var _a = _this.adobeIdData, _b = _a.api_parameters, apiParameters = _b === void 0 ? {} : _b, clientId = _a.client_id, adobeIdRedirectUri = _a.redirect_uri;
            var redirectRequest = {
                adobeIdRedirectUri: adobeIdRedirectUri,
                apiParameters: apiParameters,
                clientId: clientId,
                externalParameters: externalParameters
            };
            var signoutBroadcastChannel = window["signoutBroadcastChannel"];
            if (signoutBroadcastChannel) {
                signoutBroadcastChannel.postMessage({
                    clientId: clientId,
                    instanceId: _this.instanceId
                });
                signoutBroadcastChannel.close();
            }
            var signOutService = new $fbARu.SignOutService();
            signOutService.signOut(redirectRequest);
        };
        /**
         * Retrieve the access token that satisfies the provided PBA policy, with a validity of at least [given] millis.
         * If the current access token in Storage satisfies the policy and is valid for at least the required time,
         * it will be returned.
         *
         * Otherwise, we will call the /check/token API with the pba_policy as parameter.
         *
         * The API will either return a token, if the current user session knobs satisfy the policy, or it will return a
         * PBA ride error, with a jump url, so the user performs the required actions for the session to become compliant
         * with the policy.
         *
         *
         * @param pbaPolicy - policy identifier (name)
         * @param validAtLeastMillis - value in millis. If the current token's expiry time is sooner than this, the token will
         * be considered unusable
         * @param contextToBePassedOnRedirect - in case a PBA ride error is thrown, this will be sent on the redirect back to
         * the lib
         * @param externalParameters - any other parameters to be sent to the check/token API
         */ this.getTokenForPBAPolicy = function(pbaPolicy, validAtLeastMillis, contextToBePassedOnRedirect, externalParameters) {
            var _a;
            if (pbaPolicy === void 0) pbaPolicy = "";
            if (validAtLeastMillis === void 0) validAtLeastMillis = 10000;
            if (externalParameters === void 0) externalParameters = {};
            var tokenInfo = _this.getAccessToken();
            // if this access token can be used, return it
            if (tokenInfo && Date.now() + validAtLeastMillis < tokenInfo.expire.getTime() && (!pbaPolicy || ((_a = tokenInfo.pbaSatisfiedPolicies) === null || _a === void 0 ? void 0 : _a.includes(pbaPolicy)))) return Promise.resolve(tokenInfo);
            // otherwise we need to call check token to obtain a new one
            var _b = _this, adobeIdData = _b.adobeIdData, csrfService = _b.csrfService;
            var nonce = csrfService.initialize();
            externalParameters.state = adobeIdData.createRedirectState(contextToBePassedOnRedirect, nonce);
            externalParameters.redirect_uri = $cal07.RedirectHelper.createRedirectUrl(adobeIdData.redirect_uri, adobeIdData.client_id, externalParameters, "check_token", adobeIdData.scope);
            if (pbaPolicy) externalParameters.pba_policy = pbaPolicy;
            return _this.refreshToken(externalParameters);
        };
        /**
         * Refresh the existing token.
         *
         * <uml>
         * start
         * :refreshToken;
         * :call backend: ims/check/v4/token?client_id;
         * :read the token and profile;
         * :triggerOnAccessToken;
         * if (profile) then (yes)
         * else (nothing)
         * :call backend to get the profile ;
         * endif
         * end
         * </uml>
         *
         * @param externalParameters {Object} external parameters sent from outside of the library
         * @param autoRefresh {boolean} undocumented flag signaling that the call was made from auto-refresh context. do not set!
         * Note: if refresh token API fails, the triggerOnAccessTokenHasExpired will be triggered
         */ this.refreshToken = function(externalParameters, autoRefresh) {
            if (externalParameters === void 0) externalParameters = {};
            if (autoRefresh === void 0) autoRefresh = false;
            // It is possible that the client app has better user activity detection (eg. frames)
            // in which case it may call refreshToken with userInactiveSince. If that is the case,
            // TokenAutoRefresh should be updated with the new data, to be used when auto-refreshing.
            if (!autoRefresh && externalParameters.userInactiveSince) {
                var userInactiveSince = externalParameters.userInactiveSince;
                var lastUserInteraction = Date.now() - userInactiveSince * 1000;
                if (lastUserInteraction > $9f3f451e3e2c99c0$var$TokenAutoRefresh_1.default.lastUserInteraction) $9f3f451e3e2c99c0$var$TokenAutoRefresh_1.default.lastUserInteraction = lastUserInteraction;
            }
            return _this.tokenService.refreshToken(externalParameters).then(function(tokenResponse) {
                return _this.onTokenProfileReceived(tokenResponse);
            }).catch(function(ex) {
                $9f3f451e3e2c99c0$var$Log_1.default.error("refresh token error", ex);
                if (ex instanceof $3s2dW.HttpErrorResponse) return Promise.reject(ex);
                var rideResult = _this.verifyRideErrorExceptionStrict(ex);
                if (rideResult) return rideResult;
                _this.profileService.removeProfile();
                _this.onTokenExpired(ex);
                return Promise.reject(ex);
            });
        };
        /**
         * retreive a new token and profile for the input user id
         * @param externalParameters {Object} external parameters sent from outside of the library
         * @param userId {String} represents the user id used to get the new token and profile
         */ this.switchProfile = function(userId, externalParameters) {
            if (externalParameters === void 0) externalParameters = {};
            if (!userId) return Promise.reject(new Error("Please provide the user id for switchProfile"));
            return _this.tokenService.switchProfile(userId, externalParameters).then(function(tokenResponse) {
                return _this.onTokenProfileReceived(tokenResponse);
            }).catch(function(ex) {
                return _this.verifyRideErrorException(ex);
            });
        };
        this.executeErrorCallback = function(ex) {
            $9f3f451e3e2c99c0$var$Log_1.default.info("initialize exception ended", ex);
            // do not invoke error callback on logout
            if (ex && ex.type === $75WTM.IFragmentExceptionType.LOGOUT) return;
            var onError = _this.adobeIdData.onError;
            onError && onError($kKZ0Z.IErrorType.HTTP, "Initialization error", (0, $7RVR2.sanitizeException)(ex));
        };
        /**
         *
         * @param instance { AdobeIMS } instance of AdobeIMS
         */ this.triggerOnImsInstance = function(instance) {
            var evt = document.createEvent("CustomEvent");
            var evtData = {
                clientId: _this.adobeIdData.client_id,
                instance: instance
            };
            evt.initCustomEvent($5Qrtd.ON_IMSLIB_INSTANCE, false, false, evtData);
            window.dispatchEvent(evt);
        };
        /**
         * process the initialize exception;
         * this method is the first method called in case there was an error during initialize flow;
         * check if the exception type is TokenExpiredException and pass the flow to the verifyCsrfException
         * @param initializeException represent the exception received during the initialize
         */ this.processInitializeException = function(initializeException) {
            if (initializeException === void 0) initializeException = {};
            $9f3f451e3e2c99c0$var$Log_1.default.warn("initialize", initializeException);
            _this.restoreHash();
            return Promise.reject(initializeException);
        };
        this.verifyModalSignInEvent = function(ex) {
            if (ex instanceof $Dph68.ModalSignInEvent) // this happens when popup window redirects and the state from fragment contains imslibmodal property as true
            return _this.notifyParentAboutModalSignIn(ex);
            return Promise.reject(ex);
        };
        this.verifyTokenExpiredException = function(ex) {
            if (ex instanceof $3qDJh.TokenExpiredException) {
                _this.adobeIdData.handlers.triggerOnAccessTokenHasExpired(ex);
                return Promise.resolve();
            } else return Promise.reject(ex);
        };
        /**
         * method called in case of exception on initialize.
         * if error is RideError, it redirects to the jump url from RideException.jump.
         * @return a rejected promise with the given ex
         */ this.verifyRideErrorException = function(ex) {
            return $9f3f451e3e2c99c0$var$__awaiter(_this, void 0, void 0, function() {
                return $9f3f451e3e2c99c0$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(ex instanceof $17lxq.RideException)) return [
                                3 /*break*/ ,
                                4
                            ];
                            if (!!this.adobeIdData.overrideErrorHandler && !this.adobeIdData.overrideErrorHandler(ex)) return [
                                2 /*return*/ ,
                                Promise.reject(ex)
                            ];
                            if (!ex.isPbaExpiredIdleSessionWorkaround) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.signIn()
                            ];
                        case 1:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 2:
                            if (!ex.jump) return [
                                3 /*break*/ ,
                                4
                            ];
                            this.purgeCredentialsAndProfile();
                            return [
                                4 /*yield*/ ,
                                $9f3f451e3e2c99c0$var$UrlHelper_1.default.replaceUrlAndWait(ex.jump, 10000)
                            ];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            return [
                                2 /*return*/ ,
                                Promise.reject(ex)
                            ];
                    }
                });
            });
        };
        /**
         * Same as verifyRideErrorExceptionStrict, but returns null if ex is not RideException
         */ this.verifyRideErrorExceptionStrict = function(ex) {
            if (!(ex instanceof $17lxq.RideException)) return null;
            return _this.verifyRideErrorException(ex);
        };
        /**
         * method called in case of exception on initialize.  if error type is CSRF, it calls the signOut methods
         */ this.verifyCsrfException = function(ex) {
            var errorType = ex.type;
            if (errorType && errorType === $kKZ0Z.IErrorType.CSRF) _this.signOut();
            return Promise.reject(ex);
        };
        /**
         * method called after a successful call to the getTokenAndProfile method in order to process the token response
         * tokenProfile: TokenProfileResponse - contains the token fields and eventually the user profile
         * @returns Promise
         */ this.processTokenResponse = function(tokenProfile) {
            var handlers = _this.adobeIdData.handlers;
            var tokenFields = tokenProfile.tokenFields, profile = tokenProfile.profile;
            var token = tokenFields.tokenValue, state = tokenFields.state, expire = tokenFields.expire, sid = tokenFields.sid, userId = tokenFields.user_id, _a = tokenFields.other, other = _a === void 0 ? {} : _a, impersonatorId = tokenFields.impersonatorId, isImpersonatedSession = tokenFields.isImpersonatedSession, pbaSatisfiedPolicies = tokenFields.pbaSatisfiedPolicies, isGuestToken = tokenFields.isGuestToken, gse = tokenFields.gse, fdi = tokenFields.fdi;
            $9f3f451e3e2c99c0$var$Log_1.default.info("token", token);
            if (other.from_ims) $9f3f451e3e2c99c0$var$UrlHelper_1.default.setHash(other.old_hash || "");
            _this.profileService.removeProfileIfOtherUser(userId);
            var notificationData = {
                token: token,
                expire: expire,
                sid: sid,
                impersonatorId: impersonatorId,
                isImpersonatedSession: isImpersonatedSession,
                pbaSatisfiedPolicies: pbaSatisfiedPolicies,
                isGuestToken: isGuestToken,
                gse: gse,
                fdi: fdi
            };
            tokenFields.isReauth() ? handlers.triggerOnReauthAccessToken(notificationData) : _this.tokenReceived(notificationData);
            if (profile) _this.profileService.saveProfileToStorage(profile);
            return Promise.resolve(state);
        };
        /**
         * method used during initialization in order to get a ijt token
         * https://wiki.corp.adobe.com/display/ims/Implicit+Jump+Tokens
         * @returns {Promise<any>} ijt response
         * @param {string} ijt value used for token excahnge (other than the one from adobeid)
         * @usage adobeIMS.adobeIdData.ijt = 'ijtValue' followed by adobeIMS.initialize()
         */ this.exchangeIjt = function(ijt) {
            var adobeIjt = _this.adobeIdData.ijt;
            if (!ijt && !adobeIjt) return Promise.reject(new Error("please set the adobeid.ijt value"));
            return _this.tokenService.exchangeIjt(ijt || adobeIjt).then(function(resp) {
                if (resp.profile) _this.profileService.saveProfileToStorage(resp.profile);
                else _this.profileService.removeProfile();
                return Promise.resolve(resp);
            });
        };
        this.adobeIdData = new $8bNRG.AdobeIdData(adobeData);
        if (instanceKey) this.instanceKey = instanceKey;
        this.instanceId = "imslib-".concat(Math.random().toString(36).substring(2, 9));
        var _a = this.adobeIdData, _b = _a.api_parameters, apiParameters = _b === void 0 ? {} : _b, clientId = _a.client_id, scope = _a.scope, useLocalStorage = _a.useLocalStorage, autoValidateToken = _a.autoValidateToken, modalMode = _a.modalMode, modalSettings = _a.modalSettings, ignoreUrlToken = _a.ignoreUrlToken;
        this.imsApis = new $5ccdI.ImsApis(apiParameters);
        this.csrfService = new $ggFBI.CsrfService(clientId, this.instanceKey);
        this.serviceRequest = {
            clientId: clientId,
            scope: scope,
            imsApis: this.imsApis
        };
        this.tokenService = new $gJKR4.TokenService($9f3f451e3e2c99c0$var$__assign($9f3f451e3e2c99c0$var$__assign({}, this.serviceRequest), {
            useLocalStorage: useLocalStorage,
            autoValidateToken: autoValidateToken,
            ignoreUrlToken: ignoreUrlToken
        }), this.csrfService);
        this.profileService = new $6eKgv.ProfileService(this.serviceRequest);
        this.organizationsService = new $5yTWj.OrganizationsService(this.serviceRequest);
        this.signInservice = modalMode ? new $4CAMl.SignInModalService(this.onPopupMessage, modalSettings) : new $l7sfa.SignInService();
        var signoutBroadcastChannel = new BroadcastChannel("imslib-signout");
        signoutBroadcastChannel.addEventListener('message', this.onSignOutEventReceived.bind(this));
        window["signoutBroadcastChannel"] = signoutBroadcastChannel;
    }
    Object.defineProperty(AdobeIMS.prototype, "version", {
        /**
         * represents the adobe ims library version
         */ get: function() {
            return $9f3f451e3e2c99c0$var$Environment_1.default.jslibver;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdobeIMS.prototype, "adobeid", {
        /**
         * AdobeIdData
         * the values for adobeId are read from window.adobeid or passed by using the constructor
         */ get: function() {
            return $9f3f451e3e2c99c0$var$__assign({}, this.adobeIdData);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * enable the logging mechanism
     */ AdobeIMS.prototype.enableLogging = function() {
        $9f3f451e3e2c99c0$var$Log_1.default.enableLogging();
    };
    /**
     * disable the logging mechanism
     */ AdobeIMS.prototype.disableLogging = function() {
        $9f3f451e3e2c99c0$var$Log_1.default.disableLogging();
    };
    /**
     * function used to check is initialized; in case of false, an error is triggered
     */ AdobeIMS.prototype.checkInitialized = function() {
        if (this.initialized) return;
    //   throw new Error( 'the imslib is not yet initialized' );
    };
    /**
     * Method used to redirect the user to the signup screen
     *
     * <uml>
     * start
     * :Create the state object by using appCode, appVersion (used on server side) from adobeId.analytics and contextToBePassedOnRedirect;
     * :Create the redirect url using external parameters. state object will be part of redirect url;
     * :SignUp;
     * :initialize method is used which will trigger the token and profile;
     * end
     *
     * </uml>
     *
     * @param requestedParameters object sent from outside in order to use diferent values for signUp
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     *
     */ AdobeIMS.prototype.signUp = function(requestedParameters, contextToBePassedOnRedirect) {
        var _this = this;
        if (requestedParameters === void 0) requestedParameters = {};
        this.checkInitialized();
        var _a = this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
        if (!adobeIdData) throw new Error("no adobeId on reAuthenticate");
        var nonce = csrfService.initialize();
        return adobeIdData.createSignUpRedirectRequest(requestedParameters, contextToBePassedOnRedirect, nonce).then(function(authorizeRequestData) {
            _this.signInservice.signIn(authorizeRequestData);
        });
    };
    /**
     * @function Method used to check if the user is signed in or not.
     * if local storage contains a token and is validated (only against expiration), the result is true
     * returns {boolean}
     */ AdobeIMS.prototype.isSignedInUser = function() {
        var tokenInfo = this.getAccessToken();
        if (tokenInfo && tokenInfo.isGuestToken) return false;
        return tokenInfo || this.getReauthAccessToken() ? true : false;
    };
    /**
     * @function Method used to get the user profile in case the user is logged)
     * returns {IDictionary | null}  representing the user profile or null
     */ AdobeIMS.prototype.getProfile = function() {
        var _this = this;
        var profile = this.profileService.getProfileFromStorage();
        if (profile) return Promise.resolve(profile);
        var tokenInfo = this.getAccessToken() || this.getReauthAccessToken();
        if (!tokenInfo) {
            var profileException = "please login before getting the profile";
            return Promise.reject(new $98trQ.ProfileException(profileException));
        }
        if (tokenInfo.isGuestToken) {
            var profileException = "guest account does not have a profile";
            return Promise.reject(new $98trQ.ProfileException(profileException));
        }
        return this.profileService.getProfile(tokenInfo.token).then(function(profile) {
            return Promise.resolve(profile);
        }).catch(function(ex) {
            $9f3f451e3e2c99c0$var$Log_1.default.error("get profile exception ", ex);
            if (!(ex instanceof $3s2dW.HttpErrorResponse)) return Promise.reject(new $98trQ.ProfileException(ex.message || ex));
            return _this.refreshToken().then(function(tokenResponse) {
                return Promise.resolve(tokenResponse.profile);
            });
        });
    };
    /**
     * Get the user's IMS organizations
     * Requires read_organizations scope in the client configuration
     *
     * @returns Promise<INormalizedOrganizations> - Normalized organizations data
     *
     * @example
     * ```typescript
     * adobeIMS.getOrganizations()
     *   .then(orgs => {
     *     console.log(`User has ${orgs.count} organizations`);
     *     orgs.organizations.forEach(org => {
     *       console.log(`${org.orgName} (${org.orgId})`);
     *     });
     *   })
     *   .catch(err => console.error('Failed to get organizations', err));
     * ```
     *
     * @remarks
     * - Requires 'read_organizations' scope in adobeid.scope configuration
     * - Returns cached data if available and not expired (15 minute TTL)
     * - Handles both single-org (T2E) and multi-org responses
     * - Returns empty array if scope is missing or user has no orgs
     * - For T3 (federated) users, may return empty if not provisioned
     */ AdobeIMS.prototype.getOrganizations = function() {
        var tokenInfo = this.getAccessToken() || this.getReauthAccessToken();
        if (!tokenInfo) {
            $9f3f451e3e2c99c0$var$Log_1.default.warn("getOrganizations: please login before getting organizations");
            return Promise.reject(new Error("No access token available. Please login before getting organizations."));
        }
        if (tokenInfo.isGuestToken) {
            $9f3f451e3e2c99c0$var$Log_1.default.warn("getOrganizations: guest account does not have organizations");
            return Promise.reject(new Error("Guest accounts do not have organizations."));
        }
        return this.organizationsService.getOrganizations(tokenInfo.token).then(function(organizations) {
            return Promise.resolve(organizations);
        }).catch(function(ex) {
            $9f3f451e3e2c99c0$var$Log_1.default.error("get organizations exception", ex);
            return Promise.reject(ex);
        });
    };
    /**
     * @function Returns the URL of the user avatar
     * @param {UserId} userId
     */ AdobeIMS.prototype.avatarUrl = function(userId) {
        return this.imsApis.avatarUrl(userId);
    };
    /**
     * method used to retrieve the token release flags
     */ AdobeIMS.prototype.getReleaseFlags = function(decode) {
        if (decode === void 0) decode = false;
        return decode ? this.tokenService.getDecodedReleaseFlags() : this.tokenService.getReleaseFlags();
    };
    /**
     *
     * Returns the access token value from the local storage
     *
     * <uml>
     * start
     * :getAccessToken;
     * :check the local storage;
     * :if token exists, it is validated against expiration;
     * :if valid the token is returned otherwise an empty token;
     * end
     * </uml>
     *
     */ AdobeIMS.prototype.getAccessToken = function() {
        return this.getTokenFromStorage(false);
    };
    AdobeIMS.prototype.getOrFetchAccessToken = function() {
        var token = this.getAccessToken();
        if (token) return Promise.resolve(token);
        return this.refreshToken().then(function(tokenResponse) {
            return tokenResponse.tokenInfo;
        });
    };
    /**
     *
     * Returns the reauth access token value from the local storage
     *
     * <uml>
     * start
     * :getReauthAccessToken;
     * :check the local storage;
     * :if token exists, it is validated against expiration;
     * :if valid the token is returned otherwise an empty token;
     * end
     * </uml>
     *
     */ AdobeIMS.prototype.getReauthAccessToken = function() {
        return this.getTokenFromStorage(true);
    };
    AdobeIMS.prototype.getTokenFromStorage = function(isReauth) {
        var tokenFields = this.tokenService.getTokenFieldsFromStorage(isReauth);
        if (!tokenFields) return null;
        var token = tokenFields.tokenValue, expire = tokenFields.expire, sid = tokenFields.sid, impersonatorId = tokenFields.impersonatorId, isImpersonatedSession = tokenFields.isImpersonatedSession, pbaSatisfiedPolicies = tokenFields.pbaSatisfiedPolicies, isGuestToken = tokenFields.isGuestToken, gse = tokenFields.gse, fdi = tokenFields.fdi;
        return {
            token: token,
            expire: expire,
            sid: sid,
            impersonatorId: impersonatorId,
            isImpersonatedSession: isImpersonatedSession,
            pbaSatisfiedPolicies: pbaSatisfiedPolicies,
            isGuestToken: isGuestToken,
            gse: gse,
            fdi: fdi
        };
    };
    /**
     * method used to get the social providers.
     * returns Promise - can be used to determine when the call has been ended and read the social providers response
     */ AdobeIMS.prototype.listSocialProviders = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var client_id = _this.adobeIdData.client_id;
            _this.imsApis.listSocialProviders({
                client_id: client_id
            }).then(function(response) {
                resolve(response);
            }).catch(function(ex) {
                reject(ex);
            });
        });
    };
    /**
     *
     * @param token {string} represents the access token
     * @param expire {Date} the date when the token will expire
     */ AdobeIMS.prototype.tokenReceived = function(tokenInfo) {
        var handlers = this.adobeIdData.handlers;
        handlers.triggerOnAccessToken(tokenInfo);
        $9f3f451e3e2c99c0$var$TokenAutoRefresh_1.default.startAutoRefreshFlow({
            expire: tokenInfo.expire,
            refreshTokenMethod: this.refreshToken
        });
    };
    /**
     * method used to process the token and profile
     * @param tokenResponse {IRefreshTokenResponse} represents the token and profile received from back-end
     */ AdobeIMS.prototype.onTokenProfileReceived = function(tokenResponse) {
        var tokenInfo = tokenResponse.tokenInfo, profile = tokenResponse.profile;
        $9f3f451e3e2c99c0$var$Log_1.default.info("token", tokenInfo);
        this.tokenReceived(tokenInfo);
        this.profileService.saveProfileToStorage(profile);
        return Promise.resolve(tokenResponse);
    };
    /**
     * @returns a promise which is resolved as true in case the token is valid otherwise false
     * validate the existing token;
     */ AdobeIMS.prototype.validateToken = function() {
        var _this = this;
        return this.tokenService.validateToken().then(function() {
            return Promise.resolve(true);
        }).catch(function(ex) {
            $9f3f451e3e2c99c0$var$Log_1.default.warn("validate token exception", ex);
            if (ex instanceof $3s2dW.HttpErrorResponse) return Promise.reject(false);
            _this.profileService.removeProfile();
            return Promise.reject(false);
        });
    };
    /**
     * method used in case the existent token has expired
     */ AdobeIMS.prototype.onTokenExpired = function(ex) {
        var handlers = this.adobeIdData.handlers;
        this.tokenService.purge();
        handlers.triggerOnAccessTokenHasExpired(ex);
    };
    /**
     * set a new token into the local storage
     * @param tokenInfo {tokenInfo} represents the token/ expire information used by library
     */ AdobeIMS.prototype.setStandAloneToken = function(standaloneToken) {
        return this.tokenService.setStandAloneToken(standaloneToken);
    };
    /**
     * Method called on library initialization or page reloading
     * <uml>
     * start
     * :initialize method;
     * :get token;
     * if (fragment) then (yes)
     * :returns the token from fragment;
     * else (check local storage)
     * :returns the token from local storage;
     * endif
     * :if no token: return triggerOnAccessTokenHasExpired;
     * :triggerOnAccessToken;
     * :back-end: calls getProfile ;
     * :triggerOnReady ;
     * end
     * </uml>
     *
     * Note: this method is automatically called on every page reload;
     */ AdobeIMS.prototype.initialize = function() {
        var _this = this;
        var _a = this.adobeIdData, handlers = _a.handlers, standalone = _a.standalone, ijt = _a.ijt, alwaysRemoveTokenFromUrl = _a.alwaysRemoveTokenFromUrl, enableGuestAccounts = _a.enableGuestAccounts, enableGuestTokenForceRefresh = _a.enableGuestTokenForceRefresh, enableGuestBotDetection = _a.enableGuestBotDetection, guestBotDetectionProvider = _a.guestBotDetectionProvider;
        var state = null;
        if (standalone) this.setStandAloneToken(standalone);
        var initializationMethod;
        switch(true){
            case !!ijt:
                initializationMethod = this.exchangeIjt;
                break;
            case enableGuestAccounts:
                initializationMethod = this.tokenService.getGuestToken.bind(this.tokenService, {}, {
                    enableGuestAccounts: enableGuestAccounts,
                    enableGuestTokenForceRefresh: enableGuestTokenForceRefresh,
                    enableGuestBotDetection: enableGuestBotDetection,
                    guestBotDetectionProvider: guestBotDetectionProvider
                });
                break;
            default:
                initializationMethod = this.tokenService.getTokenAndProfile;
        }
        return initializationMethod().then(this.processTokenResponse, this.processError.apply(this)).then(function(stateValue) {
            state = stateValue;
        }).finally(function() {
            $9f3f451e3e2c99c0$var$Log_1.default.info("onReady initialization");
            window.addEventListener($5Qrtd.ASK_FOR_IMSLIB_INSTANCE_DOM_EVENT_NAME, function() {
                _this.triggerOnImsInstance(_this);
            }, false);
            if (alwaysRemoveTokenFromUrl) $9f3f451e3e2c99c0$var$UrlHelper_1.default.setHash($9f3f451e3e2c99c0$var$FragmentHelper_1.default.removeAccessToken());
            handlers.triggerOnReady(state ? state.context : null);
            _this.triggerOnImsInstance(_this);
            _this.initialized = true;
        });
    };
    /**
     * Purge the credentials and profile from the local storage
     */ AdobeIMS.prototype.purgeCredentialsAndProfile = function() {
        this.tokenService.purge();
        this.profileService.removeProfile();
    };
    AdobeIMS.prototype.processError = function() {
        var _this = this;
        return function(ex) {
            return _this.verifyModalSignInEvent(ex).catch(_this.processInitializeException).catch(_this.verifyTokenExpiredException).catch(_this.verifyRideErrorException).catch(_this.verifyCsrfException).catch(_this.executeErrorCallback);
        };
    };
    /**
     * pass the redirect url from the popup window to parent
     * @param modalSignInEvent {ModalSignInEvent} represents the redirect url after user has signed in
     */ AdobeIMS.prototype.notifyParentAboutModalSignIn = function(modalSignInEvent) {
        var href = window.location.href.replace("imslibmodal", "wasmodal");
        if (window.opener) {
            window.opener.postMessage(href, window.location.origin);
            window.close();
        } else {
            var broadcastChannel = new BroadcastChannel("imslib");
            broadcastChannel.postMessage(href);
            broadcastChannel.close();
            window.close();
        }
        return Promise.reject("popup");
    };
    /**
     * restore the window hash value to the initial one
     */ AdobeIMS.prototype.restoreHash = function() {
        var fragmentValues = $9f3f451e3e2c99c0$var$FragmentHelper_1.default.fragmentToObject();
        if (!fragmentValues || !fragmentValues.from_ims) return;
        $9f3f451e3e2c99c0$var$UrlHelper_1.default.setHash(fragmentValues.old_hash || "");
    };
    /**
     * Exchange the user's access_token for a Transitory Access Code (TAC) for target client and scope
     * @see {@link https://wiki.corp.adobe.com/display/ims/Transitory+Authorization+Codes |Transitory Authorization Codes}
     * @param tacRequest {ITransitoryAuthorizationRequest}
     * @param externalParameters {IDictionary} object used in order to update the default api values
     */ AdobeIMS.prototype.getTransitoryAuthorizationCode = function(tacRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        tacRequest = tacRequest || {};
        tacRequest.response_type = tacRequest.response_type || "code";
        tacRequest.target_client_id = tacRequest.target_client_id || this.adobeIdData.client_id;
        tacRequest.target_scope = tacRequest.target_scope || this.adobeIdData.scope;
        return this.imsApis.getTransitoryAuthorizationCode(tacRequest, externalParameters, this.adobeIdData.client_id);
    };
    /**
     * Allows a client to launch a system-browser and arrive at another IMS-integrated application
     * https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=ims&title=IMS+API+-+jumptoken
     * @param jumpTokenRequest {IJumpTokenRequest}
     * @param externalParameters {object} object used to override the default request values
     * @returns IJumpTokenResponse
     */ AdobeIMS.prototype.jumpToken = function(jumpTokenRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        jumpTokenRequest.target_client_id = jumpTokenRequest.target_client_id || this.adobeIdData.client_id;
        jumpTokenRequest.target_scope = jumpTokenRequest.target_scope || this.adobeIdData.scope;
        return this.imsApis.jumpToken(jumpTokenRequest, externalParameters, this.adobeIdData.client_id);
    };
    AdobeIMS.prototype.getVerifierByKey = function(nonce) {
        return new $8a1xD.CodeChallenge().getVerifierByKey(nonce);
    };
    /**
     * The purpose is to sign in with a social account without navigating outside the page (i.e. via Ajax calls only)
     * @see {@link https://wiki.corp.adobe.com/pages/viewpage.action?pageId=1106020498} Social Headless API
     * @param socialHeadlessSignInRequest {ISocialHeadlessSignInRequest} containing the social provider and the token obtained
     * @param externalParameters {object} object used to override the default request values
     * @returns TokenProfileResponse with the response from the IJT exchange
     * Will initiate a signIn flow if the response is a ride error of type 'ride_AdobeID_social`
     */ AdobeIMS.prototype.socialHeadlessSignIn = function(socialHeadlessSignInRequest_1) {
        return $9f3f451e3e2c99c0$var$__awaiter(this, arguments, void 0, function(socialHeadlessSignInRequest, externalParameters) {
            var _this = this;
            if (externalParameters === void 0) externalParameters = {};
            return $9f3f451e3e2c99c0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.imsApis.socialHeadlessSignIn(socialHeadlessSignInRequest, externalParameters).then(function(ijtResponse) {
                        return _this.exchangeIjt(ijtResponse.token);
                    }).catch(function(err) {
                        if (err.error === "ride_AdobeID_social") _this.signIn({
                            idp_flow: "social.native",
                            provider_id: socialHeadlessSignInRequest.provider_id,
                            idp_token: socialHeadlessSignInRequest.idp_token
                        });
                        return Promise.reject(err);
                    })
                ];
            });
        });
    };
    /**
     * Returns the account type from the stored profile.
     * If the profile is not available, it will throw an error.
     *
     * For guest accounts we don't have a profile, so it will always return 'guest'.
     */ AdobeIMS.prototype.getAccountType = function() {
        var tokenInfo = this.getAccessToken();
        if (!tokenInfo) throw new Error("please login before getting the account type");
        if (tokenInfo.isGuestToken) return $ejqaF.IAccountType.GUEST;
        var profile = this.profileService.getProfileFromStorage();
        if (!profile) throw new Error("you need to first get the profile before getting the account type");
        return profile.account_type;
    };
    /**
     * Returns the guest session expiration time.
     * The format is the number of seconds from Epoch.
     */ AdobeIMS.prototype.getSessionExpiration = function() {
        var tokenInfo = this.getAccessToken();
        if (!tokenInfo) throw new Error("please obtain a token before getting the session expiration");
        return tokenInfo.gse;
    };
    /**
     * Users can jump between a web browser and a mobile/desktop application and must be able to do that seamlessly
     * without entering the authorization flow in the desktop application again.
     * https://wiki.corp.adobe.com/x/hEsEtw
     * @param jumpTokenToDeviceRequest {IJumpTokenToDeviceRequest}
     * @param externalParameters {object} object used to override the default request values
     * @returns IJumpTokenToDeviceResponse
     */ AdobeIMS.prototype.jumpTokenToDevice = function(jumpTokenToDeviceRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        var tokenFields = this.tokenService.getTokenFieldsFromStorage();
        var userId = tokenFields ? tokenFields.user_id : null;
        return this.imsApis.jumpTokenToDevice(jumpTokenToDeviceRequest, externalParameters, this.adobeIdData.client_id, userId);
    };
    AdobeIMS.prototype.onSignOutEventReceived = function(event) {
        if (event.data.clientId !== this.adobeIdData.client_id || event.data.instanceId === this.instanceId) return;
        this.tokenService.purge();
        this.profileService.removeProfile();
        if (typeof this.adobeIdData.onSignOutEventReceived === "function") this.adobeIdData.onSignOutEventReceived();
    };
    return AdobeIMS;
}();
module.exports.AdobeIMS = $9f3f451e3e2c99c0$var$AdobeIMS;

});
parcelRegister("ggFBI", function(module, exports) {
"use strict";
var $bd7e6a5337fc387f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CsrfService = module.exports.ONE_HOUR = void 0;

var $bd7e6a5337fc387f$var$StorageFactory_1 = $bd7e6a5337fc387f$var$__importDefault((parcelRequire("kk2tv")));

var $17GWb = parcelRequire("17GWb");

var $5Qrtd = parcelRequire("5Qrtd");
/**
 * nonce key used for store the Csrf nonce value
 */ var $bd7e6a5337fc387f$var$NONCE = 'nonce';
var $bd7e6a5337fc387f$var$NONCE_LENGTH = 16;
module.exports.ONE_HOUR = 12960000;
var $bd7e6a5337fc387f$var$CSRF_VERIFIED = 'csrf_verified';
/**
 * class used for the CSRF process
 */ var $bd7e6a5337fc387f$var$CsrfService = /** @class */ function() {
    /**
     *
     * @param clientId {String} the client id used for Csrf
     */ function CsrfService(clientId, instanceKey) {
        if (instanceKey === void 0) instanceKey = $5Qrtd.AdobeIMSKey;
        /**
         * represents the Storage instance used during Csrf flow
         */ this.storageInstance = null;
        /**
         * represents the storage key used to save the nonce values for current client Id
         */ this.nonceStorageKey = '';
        this.nonceStorageKey = "".concat($bd7e6a5337fc387f$var$NONCE).concat(instanceKey).concat(clientId);
    }
    Object.defineProperty(CsrfService.prototype, "storage", {
        get: function() {
            if (!this.storageInstance) this.storageInstance = $bd7e6a5337fc387f$var$StorageFactory_1.default.getAvailableStorage();
            return this.storageInstance;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts the CSRF process by trying to save a random string value to available storage
     * @returns the nonce value
     */ CsrfService.prototype.initialize = function() {
        window[$bd7e6a5337fc387f$var$CSRF_VERIFIED] = false;
        if (!this.isStorageAvailable()) return '';
        var nonce = CsrfService.generateNonce();
        var nonceStorageValue = this.getNonceFromStorage() || {};
        nonceStorageValue = this.clearOlderNonceKeys(nonceStorageValue);
        this.addNonceToObject(nonceStorageValue, nonce);
        this.saveNonceValuesToStorage(nonceStorageValue);
        return nonce.value;
    };
    /**
     *
     * @param nonceStorageValue represents the object used to store the nonce values
     * @param nonce represents the nonce value
     */ CsrfService.prototype.addNonceToObject = function(nonceStorageValue, nonce) {
        nonceStorageValue[nonce.value] = nonce.expiry;
    };
    /**
     * clears the local storage keys older than 1h
     * @param nonceStorageValue local storage object used to store nonce
     */ CsrfService.prototype.clearOlderNonceKeys = function(nonceStorageValue, olderThan) {
        if (olderThan === void 0) olderThan = module.exports.ONE_HOUR;
        var oneHourAgo = Date.now() - olderThan;
        var expiry = 0;
        Object.keys(nonceStorageValue).forEach(function(key) {
            expiry = parseInt(nonceStorageValue[key]);
            if (expiry < oneHourAgo) delete nonceStorageValue[key];
        });
        return nonceStorageValue;
    };
    /**
     * @param fragmentNonce represents the nonce value received after redirect from ims
     * @returns {boolean} true if nonce is valid, otherwise false
     */ CsrfService.prototype.verify = function(fragmentNonce) {
        if (window[$bd7e6a5337fc387f$var$CSRF_VERIFIED] === true) return true;
        window[$bd7e6a5337fc387f$var$CSRF_VERIFIED] = true;
        if (!this.isStorageAvailable()) return true;
        var storageNonce = this.getNonceFromStorage();
        if (!storageNonce) return false;
        var nonceStorageValue = this.clearOlderNonceKeys(storageNonce);
        var isValidCsrf = (nonceStorageValue[fragmentNonce] || null) !== null;
        if (isValidCsrf) this.clearNonceValueFromStorage(nonceStorageValue, fragmentNonce);
        return isValidCsrf;
    };
    /**
     *
     * @param nonceStorageValue represents the saved nonce values into the Storage
     * @param fragmentNonce is nonce value which will be removed from Storage
     */ CsrfService.prototype.clearNonceValueFromStorage = function(nonceStorageValue, fragmentNonce) {
        delete nonceStorageValue[fragmentNonce];
        this.saveNonceValuesToStorage(nonceStorageValue);
    };
    /**
     * Returns the nonce values from storage as an Object or null
     * @returns {IDictionary | null}
     */ CsrfService.prototype.getNonceFromStorage = function() {
        var nonce = this.storage.getItem(this.nonceStorageKey);
        return nonce ? JSON.parse(nonce) : null;
    };
    /**
   * @param nonceValues the nonce values which will be saved to Storage
   */ CsrfService.prototype.saveNonceValuesToStorage = function(nonceValues) {
        this.storage.setItem(this.nonceStorageKey, JSON.stringify(nonceValues));
    };
    /**
     * function used to check if the local or session storage is available
     */ CsrfService.prototype.isStorageAvailable = function() {
        return !(this.storage instanceof $17GWb.MemoryStorage);
    };
    /**
     * generate random string based on crypto object
     */ CsrfService.cryptoRndomString = function() {
        if (!window.crypto) return '';
        var array = new Uint32Array(3);
        window.crypto.getRandomValues(array);
        return array.join('').substr(0, $bd7e6a5337fc387f$var$NONCE_LENGTH);
    };
    /**
     * @function randomString
     * used to generate a random string during the initialization of Csrf process
     */ CsrfService.randomString = function() {
        var cryptorandomString = CsrfService.cryptoRndomString();
        if (cryptorandomString) return cryptorandomString;
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for(var i = 0; i < $bd7e6a5337fc387f$var$NONCE_LENGTH; i++)text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    };
    /**
     * generate a key value pair used for nonce
     * @returns INonce object
     */ CsrfService.generateNonce = function() {
        return {
            value: CsrfService.randomString(),
            expiry: new Date().getTime().toString()
        };
    };
    return CsrfService;
}();
module.exports.CsrfService = $bd7e6a5337fc387f$var$CsrfService;

});
parcelRegister("kk2tv", function(module, exports) {
"use strict";
var $ecb7985963a8f009$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $17GWb = parcelRequire("17GWb");

var $5Qrtd = parcelRequire("5Qrtd");

var $ecb7985963a8f009$var$Log_1 = $ecb7985963a8f009$var$__importDefault((parcelRequire("62W4m")));

var $9js2d = parcelRequire("9js2d");
/**
 * A cross-browser way to use `sessionStorage`
 *
 * @exports storage
 * @requires MemoryStorage
 */ var $ecb7985963a8f009$var$StorageFactory = /** @class */ function() {
    function StorageFactory() {
        this.memoryStorageInstance = null;
    }
    Object.defineProperty(StorageFactory.prototype, "memoryStorage", {
        get: function() {
            if (!this.memoryStorageInstance) this.memoryStorageInstance = new $17GWb.MemoryStorage();
            return this.memoryStorageInstance;
        },
        enumerable: false,
        configurable: true
    });
    /**
    *
    * @param storageName represents the storage name
    * @returns the local or session storage; in case there is a problem with storage, the memory storage is returned
    */ StorageFactory.prototype.getStorageByName = function(storageName) {
        var storageInstance = this.getStorageInstanceByName(storageName);
        if (!storageInstance) return this.memoryStorage;
        if (storageName === $5Qrtd.STORAGE_MODE.MemoryStorage) return this.memoryStorage;
        return this.verifyStorage(storageInstance) ? new $9js2d.StorageWithFallback(storageInstance, this.memoryStorage) : this.memoryStorage;
    };
    /**
     * method used to get the avilable storage and to give the possibility to mock the behaviour
     * @param storageName the storage name used to get the storage
     * @returns Storage or null
     */ StorageFactory.prototype.getStorageInstanceByName = function(storageName) {
        if (storageName === $5Qrtd.STORAGE_MODE.MemoryStorage) return this.memoryStorage;
        try {
            return storageName === $5Qrtd.STORAGE_MODE.LocalStorage ? window.localStorage : window.sessionStorage;
        } catch (ex) {
            $ecb7985963a8f009$var$Log_1.default.warn('Please change your cookies settings in order to allow local data to be set');
            return null;
        }
    };
    /**
     * returns the available storage; the priority is local storage and after that the session storage
     * if no local or session storage is available, the Memory Storage is returned
     */ StorageFactory.prototype.getAvailableStorage = function() {
        var storage = this.getStorageByName($5Qrtd.STORAGE_MODE.LocalStorage);
        if (storage instanceof $17GWb.MemoryStorage) return this.getStorageByName($5Qrtd.STORAGE_MODE.SessionStorage);
        return storage;
    };
    /**
     *
     * @param storage represents the storage instance
     * @returns true if storage is working as expected otherwise false
     */ StorageFactory.prototype.verifyStorage = function(storage) {
        var storageKey = 'test';
        try {
            storage.setItem(storageKey, 'true');
            var storageValue = storage.getItem(storageKey);
            if (storageValue !== 'true') return false;
            storage.removeItem(storageKey);
            return true;
        } catch (ex) {
            return false;
        }
    };
    return StorageFactory;
}();
module.exports.default = new $ecb7985963a8f009$var$StorageFactory();

});
parcelRegister("17GWb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MemoryStorage = void 0;
/**
 * In-Memory polyFill for localStorage and sessionStorage.
 *
 * @constructor
 * @description Needed for Mac and iOS Safari (v <= 10) in Private Mode. Note that this object doesn't actually
 * persist data across refresh, it just implements the [Storage]{@link external:Storage} interface.
 * @exports memoryStorage
 */ var $0d17c05b2f864397$var$MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        /**
         * @type {!Object}
         */ this.data = {};
        /**
         * property added in order to be compatible with Storage class
         */ this.length = 0;
    }
    /**
     * clear the memory data
     */ MemoryStorage.prototype.clear = function() {
        this.data = {};
        this.length = 0;
    };
    /**
     * @param key {String} represents the used key to get a value
     * @returns {Object} the value associated with the input key
     */ MemoryStorage.prototype.getItem = function(key) {
        var value = this.data[key];
        return value ? value : null;
    };
    /**
     *
     * @param key {string} represent the key which will be removed from memory
     * @returns {boolean} true if the key is removed otherwise false
     */ MemoryStorage.prototype.removeItem = function(key) {
        if (!this.data[key]) return false;
        delete this.data[key];
        --this.length;
        return true;
    };
    /**
     * @key {String} - the used key to store a value into memory
     * @value {any} - value associated with the input key
     */ MemoryStorage.prototype.setItem = function(key, value) {
        if (!this.data[key]) ++this.length;
        this.data[key] = value;
    };
    MemoryStorage.prototype.key = function(index) {
        var keys = Object.keys(this.data);
        return keys[index] || null;
    };
    return MemoryStorage;
}();
module.exports.MemoryStorage = $0d17c05b2f864397$var$MemoryStorage;

});

parcelRegister("5Qrtd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BFP_X_API_KEY = module.exports.BFP_JS_ENDPOINT = module.exports.ARKOSE_JS_ENDPOINT = module.exports.ARKOSE_PUBLIC_KEY = module.exports.SETUP_ARKOSE = module.exports.ASK_FOR_IMSLIB_INSTANCE_DOM_EVENT_NAME = module.exports.ON_IMSLIB_INSTANCE = module.exports.TOKEN_STORAGE_KEY = module.exports.PROFILE_STORAGE_KEY = module.exports.HEADERS = module.exports.STORAGE_MODE = module.exports.DEFAULT_LANGUAGE = module.exports.AdobeImsFactory = module.exports.AdobeIMSKey = module.exports.AdobeIdKey = void 0;
module.exports.AdobeIdKey = 'adobeid';
module.exports.AdobeIMSKey = 'adobeIMS';
module.exports.AdobeImsFactory = 'adobeImsFactory';
module.exports.DEFAULT_LANGUAGE = 'en_US';
var $44171e1522c1d8af$var$STORAGE_MODE;
(function(STORAGE_MODE) {
    STORAGE_MODE["LocalStorage"] = "local";
    STORAGE_MODE["SessionStorage"] = "session";
    STORAGE_MODE["MemoryStorage"] = "memory";
})($44171e1522c1d8af$var$STORAGE_MODE || (module.exports.STORAGE_MODE = $44171e1522c1d8af$var$STORAGE_MODE = {}));
module.exports.HEADERS = {
    AUTHORIZATION: 'Authorization',
    X_IMS_CLIENT_ID: 'X-IMS-ClientId',
    RETRY_AFTER: 'Retry-after'
};
module.exports.PROFILE_STORAGE_KEY = 'adobeid_ims_profile';
module.exports.TOKEN_STORAGE_KEY = 'adobeid_ims_access_token';
module.exports.ON_IMSLIB_INSTANCE = 'onImsLibInstance';
module.exports.ASK_FOR_IMSLIB_INSTANCE_DOM_EVENT_NAME = 'getImsLibInstance';
module.exports.SETUP_ARKOSE = "setupArkose";
module.exports.ARKOSE_PUBLIC_KEY = "BBCC314C-4937-4CCD-B0A3-FDF0F0F7603C";
module.exports.ARKOSE_JS_ENDPOINT = "//adobe-api.arkoselabs.com/v2/".concat(module.exports.ARKOSE_PUBLIC_KEY, "/api.js");
module.exports.BFP_JS_ENDPOINT = 'https://bfp.adobe.com/bfp/v1/bfp.min.js';
module.exports.BFP_X_API_KEY = 'genuine-bfp-ims-guest';

});

parcelRegister("62W4m", function(module, exports) {
"use strict";
var $466ff95b007c4950$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $466ff95b007c4950$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Wrapper for <code>console</code>. Checks <code>console</code> is available and <code>debug</code> Mode is enabled.
 *
 * @exports log
 *
 */ var $466ff95b007c4950$var$Log = /** @class */ function() {
    function Log() {
        var _this = this;
        this.logEnabled = false;
        /**
         * Wrapper function.
         *
         * @param {String} method - Which <code>console</code> method to use.
         * @param {*} args - Arguments object
         *
         * @private
         */ this.print = function(method, args) {
            if (!_this.logEnabled) return;
            method.apply(void 0, $466ff95b007c4950$var$__spreadArray([], $466ff95b007c4950$var$__read(args), false));
        };
        /**
         * Writes an error to the console when the evaluated expression is false.
         *
         * @example
         * log.assert(1 == 2, "Counting is hard.");
         *
         * @param {Boolean} expression - Expression to evaluate.
         * @param {String} message - Message to print if <code>epxression</code> is <code>false</code>.
         *
         * @static
         */ this.assert = function(val, message) {
            _this.print(console.assert, [
                val,
                message
            ]);
        };
        /**
         * Writes an error to the console when the evaluated expression is false.
         *
         * @example
         * log.assert(1 == 2, "Counting is hard.");
         *
         * @param {Boolean} expression - Expression to evaluate.
         * @param {String} message - Message to print if <code>epxression</code> is <code>false</code>.
         *
         * @static
         */ this.assertCondition = function(condition, message) {
            if (!condition()) _this.print(console.error, [
                message
            ]);
        };
        /**
         * Prints a message similar to <code>console.log()</code>, styles the message like an error, and includes a stack
         * trace from where the method wasval, called.
         *
         * @see {@link https://developers.google.com/web/tools/chrome-devtools/console/#filtering_the_console_output | Filtering the Console output}
         *
         * @example
         * log.error("Define window.adobeid", "would you?!");
         * @param {String} message - Message to print.
         */ this.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.print(console.error, args);
        };
        /**
         * logs a warnig message
         */ this.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.print(console.warn, args);
        };
        /**
         * Prints a message like <code>console.log()</code> but also shows an icon (blue circle with white "i") next to the
         * output.
         *
         * <code>console.info()</code> can be filtered in the Console, whereas <code>console.log()</code> can not.
         *
         * @example
         * log.info("Imslib.js Ready", "to Rumble");
         *
         * @param {String} message - Message to print.
         *
         * @static
         */ this.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.print(console.info, args);
        };
    }
    Log.prototype.enableLogging = function() {
        this.logEnabled = true;
    };
    Log.prototype.disableLogging = function() {
        this.logEnabled = false;
    };
    return Log;
}();
module.exports.default = new $466ff95b007c4950$var$Log();

});

parcelRegister("9js2d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StorageWithFallback = void 0;
/** https://jira.corp.adobe.com/browse/SUSI-23884
 * This class is used to fallback to the memory storage in case the storage is not available,
 * which sometimes happens in Chrome when a web worker is used to prefetch the page
 */ var $6c7ba28567add2a6$var$StorageWithFallback = /** @class */ function() {
    function StorageWithFallback(storage, fallback) {
        this.storage = storage;
        this.fallback = fallback;
    }
    StorageWithFallback.prototype.clear = function() {
        this.storage.clear();
        this.fallback.clear();
    };
    StorageWithFallback.prototype.getItem = function(key) {
        var value = this.storage.getItem(key);
        if (value) return value;
        value = this.fallback.getItem(key);
        if (value) this.storage.setItem(key, value);
        return value;
    };
    StorageWithFallback.prototype.key = function(index) {
        var key = this.storage.key(index);
        if (key) return key;
        key = this.fallback.key(index);
        if (key) this.storage.setItem(key, this.fallback.getItem(key));
        return key;
    };
    StorageWithFallback.prototype.removeItem = function(key) {
        this.storage.removeItem(key);
        this.fallback.removeItem(key);
    };
    StorageWithFallback.prototype.setItem = function(key, value) {
        this.storage.setItem(key, value);
        this.fallback.setItem(key, value);
    };
    Object.defineProperty(StorageWithFallback.prototype, "primaryStorage", {
        get: function() {
            return this.storage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StorageWithFallback.prototype, "fallbackStorage", {
        get: function() {
            return this.fallback;
        },
        enumerable: false,
        configurable: true
    });
    return StorageWithFallback;
}();
module.exports.StorageWithFallback = $6c7ba28567add2a6$var$StorageWithFallback;

});



parcelRegister("l7sfa", function(module, exports) {
"use strict";
var $f60028fe3de007fd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f60028fe3de007fd$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f60028fe3de007fd$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f60028fe3de007fd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignInService = void 0;

var $f60028fe3de007fd$var$UrlHelper_1 = $f60028fe3de007fd$var$__importDefault((parcelRequire("elOOj")));

var $f60028fe3de007fd$var$Environment_1 = $f60028fe3de007fd$var$__importDefault((parcelRequire("4eyaY")));

var $8hO2F = parcelRequire("8hO2F");
/**
 * command responsable for user sign in
 */ var $f60028fe3de007fd$var$SignInService = /** @class */ function(_super) {
    $f60028fe3de007fd$var$__extends(SignInService, _super);
    function SignInService() {
        var _this = _super.apply(this, $f60028fe3de007fd$var$__spreadArray([], $f60028fe3de007fd$var$__read(arguments), false)) || this;
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         */ _this.signIn = function(redirectRequest) {
            var url = _this.createRedirectUrl(redirectRequest);
            $f60028fe3de007fd$var$UrlHelper_1.default.setHrefUrl(url);
        };
        /**
         *
         * @param token { String } value used to authorize a user based on this token value
         * @param redirectRequest { IRedirectRequest } contains the object properties which are passed to the authorize api
         */ _this.authorizeToken = function(token, redirectRequest) {
            var parameters = _this.composeRedirectUrl(redirectRequest);
            if (token) {
                parameters.user_assertion = token;
                parameters.user_assertion_type = 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer';
            }
            var postForm = _this.createAuthorizeForm(parameters);
            postForm.submit();
        };
        return _this;
    }
    /**
     * returns a html form containing all the properties from the parameter object
     * @param parameters {object} contains the properties which will be passed to authorize api (as form submit post action)
     */ SignInService.prototype.createAuthorizeForm = function(parameters) {
        var formAction = "".concat($f60028fe3de007fd$var$Environment_1.default.baseUrlAdobe, "/ims/authorize/v1");
        var form = document.createElement("form");
        form.style.display = "none";
        form.setAttribute("method", "post");
        form.setAttribute("action", formAction);
        var formEl = null;
        var paramValue = null;
        var paramValueAsString = '';
        for(var propertyName in parameters){
            paramValue = parameters[propertyName];
            if (typeof paramValue === 'object') {
                if (Object.keys(paramValue).length === 0) continue;
                paramValueAsString = JSON.stringify(paramValue);
            } else paramValueAsString = paramValue;
            if (paramValueAsString !== '') {
                formEl = this.createFormElement('input', 'text', propertyName, paramValueAsString);
                form.appendChild(formEl);
            }
        }
        document.getElementsByTagName("body")[0].appendChild(form);
        return form;
    };
    /**
     * create a new html form element; this element will be added to the form
     * @param inputType {String} input html element type
     * @param type {String} type of the input element
     * @param name {String} name of the input element
     * @param value {String} value for the element
     */ SignInService.prototype.createFormElement = function(inputType, type, name, value) {
        var formElement = document.createElement(inputType);
        formElement.setAttribute("type", type);
        formElement.setAttribute("name", name);
        formElement.setAttribute("value", value);
        return formElement;
    };
    return SignInService;
}($8hO2F.BaseSignInService);
module.exports.SignInService = $f60028fe3de007fd$var$SignInService;

});
parcelRegister("elOOj", function(module, exports) {
"use strict";
var $a72a70bd47377e9c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a72a70bd47377e9c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to implement the main functions used for query strings
 */ var $a72a70bd47377e9c$var$UrlHelper = /** @class */ function() {
    function UrlHelper() {}
    /**
   * Encodes data as a query string.
   * @param {Object} data - The data.
   * @returns {string} - The encoded string.
    * @example
    * encoded = uriEncodeData({
    *   first: true,
    *   foo: {
    *     bar: 'foobar'
    *   }
    * }) // -> first=true&foo=%7B%22bar%22%3A%22foobar%22%7D
    */ UrlHelper.prototype.uriEncodeData = function(data) {
        if (typeof data !== 'object') return '';
        var encodings = [];
        var encodedValue = '';
        var keyValue;
        for(var key in data){
            keyValue = data[key];
            if (keyValue === undefined) continue;
            encodedValue = this.encodeValue(keyValue);
            encodings.push(encodeURIComponent(key) + "=" + encodedValue);
        }
        return encodings.join("&");
    };
    /**
   * @param value : any; represents the value which will be encoded
   * @returns string.
   */ UrlHelper.prototype.encodeValue = function(value) {
        if (value === null) return 'null';
        if (typeof value === 'object') return encodeURIComponent(JSON.stringify(value));
        return encodeURIComponent(value);
    };
    /**
   * Opens the URL in the current page
   *
   * @param {!string} url
   */ UrlHelper.prototype.replaceUrl = function(url) {
        if (!url) return;
        window.location.replace(url);
    };
    UrlHelper.prototype.sleep = function(timeout) {
        return $a72a70bd47377e9c$var$__awaiter(this, void 0, void 0, function() {
            return $a72a70bd47377e9c$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    })
                ];
            });
        });
    };
    UrlHelper.prototype.replaceUrlAndWait = function(url, timeout) {
        return $a72a70bd47377e9c$var$__awaiter(this, void 0, void 0, function() {
            return $a72a70bd47377e9c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!url) return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        window.location.replace(url);
                        return [
                            4 /*yield*/ ,
                            this.sleep(timeout)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    /**
   * Opens the URL in the current page
   * @param {!string} url
   */ UrlHelper.prototype.setHrefUrl = function(url) {
        if (!url) return;
        window.location.href = url;
    };
    /**
  * Change the hash from url to a new value without reloading the page
  * @param hash {String} represents the new hash value
  *
  */ UrlHelper.prototype.setHash = function(hash) {
        if (hash === void 0) hash = '';
        window.location.hash = hash;
    };
    return UrlHelper;
}();
module.exports.default = new $a72a70bd47377e9c$var$UrlHelper();

});

parcelRegister("4eyaY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $isdGM = parcelRequire("isdGM");

var $1Zle9 = parcelRequire("1Zle9");
/**
 * class used to store the variables used for ims flow
 */ var $3152fad9ef34926b$var$Environment = /** @class */ function() {
    function Environment() {
        /**
         * @property {String} Represents the base url used on api (back-end) call in case of getProfile, getUserInfo and validateToken;
         */ this.baseUrlAdobe = '';
        /**
         * @property {string} Represents the base url used on api (back-end) call in case of logoutToken, checkStatus, listSocialProviders and exchangeIjt;
         */ this.baseUrlServices = '';
        /**
         * @property {object} Represents the base url used on api (back-end) call in case of checkToken;
         */ this.checkTokenEndpoint = new $1Zle9.CheckTokenEndpoint();
        /**
         * @property {string} this parameter is passed to redirect uri during a sign in or sign out operation
         */ this.jslibver = 'v2-v0.57.0-1-g5b0a59c';
    }
    Environment.prototype.loadEnvironment = function(environment, useProxy, hostname) {
        if (useProxy === void 0) useProxy = false;
        if (hostname === void 0) hostname = '';
        var isStage = environment === $isdGM.IEnvironment.STAGE;
        if (isStage) {
            this.baseUrlAdobe = 'https://ims-na1-stg1.adobelogin.com';
            this.baseUrlServices = 'https://adobeid-na1-stg1.services.adobe.com';
        } else {
            this.baseUrlAdobe = 'https://ims-na1.adobelogin.com';
            this.baseUrlServices = 'https://adobeid-na1.services.adobe.com';
        }
        this.checkTokenEndpoint = $1Zle9.CheckTokenEndpoint.computeEndpoint(useProxy, hostname, isStage, this.baseUrlServices);
    };
    return Environment;
}();
module.exports.default = new $3152fad9ef34926b$var$Environment();

});
parcelRegister("isdGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IEnvironment = void 0;
/**
 * Enumeration values for available environments
 */ var $d6f575dece47c1e3$var$IEnvironment;
(function(IEnvironment) {
    /**
     * Stage environment
     */ IEnvironment["STAGE"] = "stg1";
    /**
     * Prod environment
     */ IEnvironment["PROD"] = "prod";
})($d6f575dece47c1e3$var$IEnvironment || (module.exports.IEnvironment = $d6f575dece47c1e3$var$IEnvironment = {}));

});

parcelRegister("1Zle9", function(module, exports) {
"use strict";
var $172bf4421948dc94$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckTokenEndpoint = void 0;
var $172bf4421948dc94$var$CheckTokenEndpoint = /** @class */ function() {
    function CheckTokenEndpoint(proxied, url, fallbackUrl) {
        if (proxied === void 0) proxied = false;
        if (url === void 0) url = '';
        if (fallbackUrl === void 0) fallbackUrl = '';
        this.proxied = proxied;
        this.url = url;
        this.fallbackUrl = fallbackUrl;
    }
    CheckTokenEndpoint.computeEndpoint = function(useProxy, hostname, isStage, servicesUrl) {
        var e_1, _a;
        if (useProxy) {
            var domainMap = isStage ? CheckTokenEndpoint.THIRD_PARTY_DOMAINS_STAGE : CheckTokenEndpoint.THIRD_PARTY_DOMAINS_PROD;
            try {
                for(var _b = $172bf4421948dc94$var$__values(Object.keys(domainMap)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var domain = _c.value;
                    if (hostname === domain || hostname.endsWith('.' + domain)) return new CheckTokenEndpoint(true, domainMap[domain], servicesUrl);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        return new CheckTokenEndpoint(false, servicesUrl);
    };
    CheckTokenEndpoint.prototype.shouldFallbackToAdobe = function(e) {
        if (!this.proxied) return false;
        return e.error === 'feature_disabled' && e.error_description === 'cdsc';
    };
    // The /check/v*/token API is proxied on some third party domains and
    // imslib should use those endpoints when running on those domains.
    CheckTokenEndpoint.THIRD_PARTY_DOMAINS_PROD = {
        'behance.net': 'https://sso.behance.net'
    };
    CheckTokenEndpoint.THIRD_PARTY_DOMAINS_STAGE = {
        's2stagehance.com': 'https://sso.s2stagehance.com'
    };
    return CheckTokenEndpoint;
}();
module.exports.CheckTokenEndpoint = $172bf4421948dc94$var$CheckTokenEndpoint;

});


parcelRegister("8hO2F", function(module, exports) {
"use strict";
var $6086ba9698c38c8e$var$__assign = module.exports && module.exports.__assign || function() {
    $6086ba9698c38c8e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6086ba9698c38c8e$var$__assign.apply(this, arguments);
};
var $6086ba9698c38c8e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseSignInService = void 0;

var $6086ba9698c38c8e$var$UrlHelper_1 = $6086ba9698c38c8e$var$__importDefault((parcelRequire("elOOj")));

var $6086ba9698c38c8e$var$Environment_1 = $6086ba9698c38c8e$var$__importDefault((parcelRequire("4eyaY")));

var $cal07 = parcelRequire("cal07");

var $4z9UM = parcelRequire("4z9UM");
/**
 * command responsable for user sign in
 */ var $6086ba9698c38c8e$var$BaseSignInService = /** @class */ function() {
    function BaseSignInService() {
        var _this = this;
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         */ this.composeRedirectUrl = function(redirectRequest) {
            var apiName = "authorize";
            var apiParameters = redirectRequest.apiParameters, _a = redirectRequest.externalParameters, externalParameters = _a === void 0 ? {} : _a, _b = redirectRequest.adobeIdRedirectUri, adobeIdRedirectUri = _b === void 0 ? "" : _b, clientId = redirectRequest.clientId, localeAdobeId = redirectRequest.locale, _c = redirectRequest.state, state = _c === void 0 ? {} : _c;
            var _d = redirectRequest.scope, scope = _d === void 0 ? externalParameters["scope"] || apiParameters["scope"] || "" : _d;
            var apiExternalParams = $cal07.RedirectHelper.mergeApiParamsWithExternalParams(apiParameters, externalParameters, apiName);
            if (state) apiExternalParams.state = (0, $4z9UM.merge)(apiExternalParams.state || {}, state);
            var redirectUrl = $cal07.RedirectHelper.createRedirectUrl(adobeIdRedirectUri, clientId, apiExternalParams, apiName, scope);
            var locale = externalParameters.locale || localeAdobeId || '';
            var // eslint-disable-next-line @typescript-eslint/camelcase
            _e = redirectRequest.response_type, // eslint-disable-next-line @typescript-eslint/camelcase
            response_type = _e === void 0 ? apiExternalParams["response_type"] || '' : _e;
            var parameters = $6086ba9698c38c8e$var$__assign($6086ba9698c38c8e$var$__assign({}, apiExternalParams), {
                client_id: clientId,
                scope: scope,
                locale: locale,
                response_type: response_type,
                jslVersion: $6086ba9698c38c8e$var$Environment_1.default.jslibver,
                redirect_uri: redirectUrl
            });
            return parameters;
        };
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         */ this.createRedirectUrl = function(redirectRequest) {
            var parameters = _this.composeRedirectUrl(redirectRequest);
            var queryStrings = $6086ba9698c38c8e$var$UrlHelper_1.default.uriEncodeData(parameters);
            var url = "".concat($6086ba9698c38c8e$var$Environment_1.default.baseUrlAdobe, "/ims/authorize/v1?").concat(queryStrings);
            return url;
        };
    }
    return BaseSignInService;
}();
module.exports.BaseSignInService = $6086ba9698c38c8e$var$BaseSignInService;

});
parcelRegister("cal07", function(module, exports) {
"use strict";
var $8db6b58d9095c046$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedirectHelper = void 0;

var $8db6b58d9095c046$var$ApiHelpers_1 = $8db6b58d9095c046$var$__importDefault((parcelRequire("3zfSA")));

var $4z9UM = parcelRequire("4z9UM");

var $8db6b58d9095c046$var$FragmentHelper_1 = $8db6b58d9095c046$var$__importDefault((parcelRequire("8iphV")));
var $8db6b58d9095c046$var$RedirectHelper = /** @class */ function() {
    function RedirectHelper() {}
    /**
    * returns the initial redirect url; the priority value is redirect_uri from external parameters, adobeId and finally the href value from browsers
    * @param externalParameters
    * @param adobeIdRedirectUri
    */ RedirectHelper.getInitialRedirectUri = function(externalParameters, adobeIdRedirectUri) {
        var redirectParam = externalParameters["redirect_uri"] || adobeIdRedirectUri || window.location.href;
        var redirectValue = typeof redirectParam === 'function' ? redirectParam() : redirectParam;
        var fromImsIndex = redirectValue.indexOf('from_ims');
        if (fromImsIndex === -1) return redirectValue;
        if (redirectValue[fromImsIndex - 1] === '#') fromImsIndex--;
        return redirectValue.substr(0, fromImsIndex);
    };
    /**
    * create the return url which it will be passed to authorize or logout endpoint
    * @param adobeIdRedirectUri {string} - represents the redirect_uri? set on AdobeId;
    * @param clientId {string} - represents the client id from AdobeId
    * @param externalParameters {Object} external parameters passed to library
    * @param apiName {string} api name
    *
    * @returns {string} final redirect url used for sign-in or reauth (authorize) or logout
    */ RedirectHelper.createDefaultRedirectUrl = function(adobeIdRedirectUri, clientId, externalParameters, apiName) {
        var initialRedirectUri = this.getInitialRedirectUri(externalParameters, adobeIdRedirectUri);
        //encode the hash in case that exists
        var redirectUri = this.createOldHash(initialRedirectUri);
        return redirectUri.indexOf('?') > 0 ? "".concat(redirectUri, "&client_id=").concat(clientId, "&api=").concat(apiName) : "".concat(redirectUri, "?client_id=").concat(clientId, "&api=").concat(apiName);
    };
    /**
     * <uml>
     * start
     * :CreateDefaultRedirectUrl ;
     * :merge api parameters with external parameters
     * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
     * end
     * </uml>
     *
     * create the return url which it will be passed to authorization endpoint
     * @param redirectUri {string} - represents the base url href value
     * @param clientId {string} - represents the client id
     * @param externalParameters {Object} external parameters passed to library
     * @param apiName {string} api name
     * @parm scope {string} scope of sign in
     * @returns {string} final redirect url used for sign in
     */ RedirectHelper.createRedirectUrl = function(adobeIdRedirectUri, clientId, externalParameters, apiName, scope) {
        if (scope === void 0) scope = '';
        var redirectUri = this.createDefaultRedirectUrl(adobeIdRedirectUri, clientId, externalParameters, apiName);
        scope = scope || externalParameters["scope"] || '';
        if (scope) redirectUri = "".concat(redirectUri, "&scope=").concat(scope);
        var reauth = externalParameters["reauth"] || '';
        if (reauth) redirectUri = "".concat(redirectUri, "&reauth=").concat(reauth);
        return redirectUri;
    };
    /**
     * @param source {string} represent the url value
     * @returns {string} the url with hash
     */ RedirectHelper.createOldHash = function(source) {
        var index = source.indexOf("#");
        if (index < 0) return "".concat(source, "#old_hash=&from_ims=true");
        var baseUrl = source.substring(0, index);
        var hash = $8db6b58d9095c046$var$FragmentHelper_1.default.removeAccessToken(source.substring(index + 1));
        return "".concat(baseUrl, "#old_hash=").concat(hash, "&from_ims=true");
    };
    RedirectHelper.mergeApiParamsWithExternalParams = function(apiParameters, externalParameters, apiName) {
        return (0, $4z9UM.merge)($8db6b58d9095c046$var$ApiHelpers_1.default.getCustomApiParameters(apiParameters, apiName), externalParameters);
    };
    return RedirectHelper;
}();
module.exports.RedirectHelper = $8db6b58d9095c046$var$RedirectHelper;

});
parcelRegister("3zfSA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4z9UM = parcelRequire("4z9UM");
/**
 * class used to store the helper functions
 */ var $2990f54ca681b06e$var$ApiHelpers = /** @class */ function() {
    function ApiHelpers() {
        /**
       * Checks [adobeid.api_parameters]{@link adobeid} for custom parameters for an API.
       * @param apiName - represents the used api name
       * @param apiParameters - represents the parameters set from outside for api endpoints read from adobeId
       * @returns {!Object}
       */ this.getCustomApiParameters = function(apiParameters, apiName) {
            return apiParameters[apiName] || {};
        };
    }
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @param apiParameters the api parameters from AdobeId data
     * @param apiName api name
     * @returns IDictionary representing the merged properties
     */ ApiHelpers.prototype.mergeExternalParameters = function(externalParameters, apiParameters, apiName) {
        return (0, $4z9UM.merge)(this.getCustomApiParameters(apiParameters, apiName), externalParameters);
    };
    /***
     * @param value {String} represents the
     */ ApiHelpers.prototype.toJson = function(value) {
        try {
            if (typeof value !== 'string') return value;
            return JSON.parse(value);
        } catch (_a) {
            return null;
        }
    };
    return ApiHelpers;
}();
module.exports.default = new $2990f54ca681b06e$var$ApiHelpers();

});
parcelRegister("4z9UM", function(module, exports) {
"use strict";
// proudly found here: https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObject = $35321f33906abc27$var$isObject;
module.exports.merge = $35321f33906abc27$var$merge;
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */ function $35321f33906abc27$var$isObject(item) {
    return item !== null && item !== undefined && typeof item === 'object' && !Array.isArray(item);
}
/**
   * Deep merge two objects.
   * @param target
   * @param source
   */ function $35321f33906abc27$var$merge(target, source) {
    if (target === null || target === undefined) return source;
    if (target === source) return target;
    if (!$35321f33906abc27$var$isObject(target)) return target;
    var output = Object.assign({}, target);
    if ($35321f33906abc27$var$isObject(source)) Object.keys(source).forEach(function(key) {
        var _a, _b;
        if ($35321f33906abc27$var$isObject(source[key])) {
            if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            else output[key] = $35321f33906abc27$var$merge(target[key], source[key]);
        } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
    });
    return output;
}

});


parcelRegister("8iphV", function(module, exports) {
"use strict";
var $60a39ede17eb0f99$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $60a39ede17eb0f99$var$ApiHelpers_1 = $60a39ede17eb0f99$var$__importDefault((parcelRequire("3zfSA")));
/**
 * class used to implement the main functions used for fragment
 */ var $60a39ede17eb0f99$var$FragmentHelper = /** @class */ function() {
    function FragmentHelper() {}
    FragmentHelper.prototype.fragmentToObject = function(urlArg) {
        var currentHash = this.getHashFromURL(urlArg);
        if (!currentHash) return null;
        var url = this.processHashUrl(currentHash);
        var oldHash = this.getOldHash(url);
        // fragment values should contain only values starting with old_hash
        //this is in case when hash route is used: e.g.: https://localhost.corp.adobe.com:9000/#/cdn#old_hash=...
        //#/cdn# should be ignored when getQueryParamsAsMap is called;
        var urlWithoutRoute = oldHash ? url.slice(url.indexOf('old_hash')) : url;
        var urlWithoutOldHash = this.removeOldHash(urlWithoutRoute);
        var imsResponseAsMap = this.getQueryParamsAsMap(urlWithoutOldHash);
        if (oldHash) imsResponseAsMap['old_hash'] = oldHash;
        var stateAsString = imsResponseAsMap['state'];
        if (stateAsString) imsResponseAsMap['state'] = $60a39ede17eb0f99$var$ApiHelpers_1.default.toJson(stateAsString);
        return imsResponseAsMap;
    };
    /**
     * function used to determine the old_hash value contained into the source
     * @param source {String} represents the input source used to determine the old_hash
     * @returns {String}
     */ FragmentHelper.prototype.getOldHash = function(source) {
        if (!source) return '';
        var match = source.match('old_hash=(.*?)&from_ims=true');
        if (!match) return '';
        return match[1];
    };
    /**
     * remove the old hash value from the input string
     * @param source {String} represents the input source
     */ FragmentHelper.prototype.removeOldHash = function(source) {
        if (!source) return source;
        return source.replace(/old_hash=(.*?)&from_ims=true/gi, 'from_ims=true');
    };
    FragmentHelper.prototype.removeAccessToken = function(source) {
        if (source === void 0) source = window.location.hash;
        if (!source && source.length < 1) return source;
        if (source.startsWith('#')) return '#' + this.removeAccessToken(source.substring(1));
        return source.replace(/(^access_token=[^&]+&?)|(&access_token=[^&]+)/g, '');
    };
    /**
   * Gets the hash from an url.
   * @param {string=} url The URL from which to get the hash.
   * If missing use the current page's URL.
   * @Note: the # is not returned from url
   * @returns {string}
   */ FragmentHelper.prototype.getHashFromURL = function(url) {
        if (url === void 0) url = window.location.href;
        var index = url.indexOf("#");
        return index !== -1 ? url.substring(index + 1) : "";
    };
    /**
   * Parses a query string to a JSON.
   * @NOTE Sometimes, the query string is actually a hash, due to inconsistent servers
   * @param source {String}; represents the inpt strring value wich will be transformed to object
   * @returns {!Object}
   */ FragmentHelper.prototype.getQueryParamsAsMap = function(source) {
        if (!source) return {};
        var paramMap = {};
        //in case the source starts with #, ? or &, the first character is removed. 
        source = source.replace(/^(#\/|\/|#|\?|&)/, "");
        source.split("&").forEach(function(keyValuePair) {
            if (keyValuePair.length) {
                var arr = keyValuePair.split("=");
                paramMap[arr[0]] = decodeURIComponent(arr[1]);
            }
        });
        return paramMap;
    };
    /**
   * @param source {string} represent the input source wich will be processed
   * The backend appends a second "#" sign to redirect_uri, even if it already contains one.
   * @see https://jira.corp.adobe.com/browse/IMSB-4107554
   */ FragmentHelper.prototype.processHashUrl = function(source) {
        return source.replace("?error", "#error").replace(/#/gi, '&').replace('from_ims=true?', 'from_ims=true&');
    };
    return FragmentHelper;
}();
module.exports.default = new $60a39ede17eb0f99$var$FragmentHelper();

});




parcelRegister("4CAMl", function(module, exports) {
"use strict";
var $35d73d867132450e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $35d73d867132450e$var$__assign = module.exports && module.exports.__assign || function() {
    $35d73d867132450e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35d73d867132450e$var$__assign.apply(this, arguments);
};
var $35d73d867132450e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignInModalService = void 0;

var $35d73d867132450e$var$PopupOpener_1 = $35d73d867132450e$var$__importDefault((parcelRequire("clbzM")));

var $8hO2F = parcelRequire("8hO2F");
/**
 * command responsable for user sign in
 */ var $35d73d867132450e$var$SignInModalService = /** @class */ function(_super) {
    $35d73d867132450e$var$__extends(SignInModalService, _super);
    /**
     * constructor of the SignInModalService
     */ function SignInModalService(onPopupMessage, popupSettings) {
        var _this = _super.call(this) || this;
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         * @param onPopupMessage {Function} represents the function used, as a hook, to be triggered when a message comes from popup
         */ _this.signIn = function(redirectRequest) {
            redirectRequest.state = $35d73d867132450e$var$__assign($35d73d867132450e$var$__assign({}, redirectRequest.state), {
                imslibmodal: true
            });
            var nonce = redirectRequest.state.nonce;
            var url = _this.createRedirectUrl(redirectRequest);
            $35d73d867132450e$var$PopupOpener_1.default.openSignInWindow(url, nonce, _this.popupSettings, _this.onPopupMessage);
        };
        _this.onPopupMessage = onPopupMessage;
        _this.popupSettings = popupSettings;
        return _this;
    }
    return SignInModalService;
}($8hO2F.BaseSignInService);
module.exports.SignInModalService = $35d73d867132450e$var$SignInModalService;

});
parcelRegister("clbzM", function(module, exports) {
"use strict";
var $8fc06cf989c7905f$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8fc06cf989c7905f$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8fc06cf989c7905f$var$URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
var $8fc06cf989c7905f$var$ALLOWED_ORIGINS = [
    'https://auth.services.adobe.com',
    'https://auth-stg1.services.adobe.com',
    'https://localhost.corp.adobe.com:9000'
];
/**
 * class used to open a new authorization popup
 */ var $8fc06cf989c7905f$var$PopupOpener = /** @class */ function() {
    function PopupOpener() {
        var _this = this;
        /**
         * refernce of the window object
         */ this.windowObjectReference = null;
        /**
         * represents the previous url used to open the popup window
         */ this.previousUrl = '';
        /**
         * open the popup window used for authorization
         * @param url {String} url of the popup window
         * @param popupSettings {object} contains the popup setting as height and width
         * @param onPopupMessage {Function} function used to transfer the data from popup
         */ this.openSignInWindow = function(url, popupHaspProp, popupSettings, onPopupMessage) {
            _this.onProcessLocation = onPopupMessage;
            _this.allowOrigin = popupSettings.allowOrigin;
            if (_this.timerId) clearInterval(_this.timerId);
            // remove any existing event listeners
            window.removeEventListener('message', _this.receiveMessage);
            // add the listener for receiving a message from the popup
            window.addEventListener('message', _this.receiveMessage);
            _this.broadcastChannel && _this.broadcastChannel.close();
            _this.broadcastChannel = new BroadcastChannel("imslib");
            _this.broadcastChannel.onmessage = _this.receiveMessage;
            // window features
            var strWindowFeatures = "popup=yes, width=".concat(popupSettings.width, ", height=").concat(popupSettings.height, ", top=").concat(popupSettings.top, ", left=").concat(popupSettings.left);
            if (!_this.windowObjectReference || _this.windowObjectReference && _this.windowObjectReference.closed) /* if the pointer to the window object in memory does not exist or if such pointer exists but the window was closed */ _this.windowObjectReference = window.open(url, popupSettings.title, strWindowFeatures);
            else if (_this.previousUrl !== url) {
                /* if the resource to load is different, then we load it in the already opened secondary window and then  we bring such window back on top/in front of its parent window. */ _this.windowObjectReference = window.open(url, popupSettings.title, strWindowFeatures);
                _this.windowObjectReference && _this.windowObjectReference.focus();
            } else /* else the window reference must exist and the window is not closed; therefore, we can bring it back on top of any other window with the focus() method. There would be no need to re-create
                    the window or to reload the referenced resource. */ _this.windowObjectReference.focus();
            // assign the previous URL
            _this.previousUrl = url;
        };
        /**
         * function used to receive the message from the popup window
         * @param event {window event} contains the dom event passed by popup window
         */ this.receiveMessage = function(event) {
            if (!$8fc06cf989c7905f$var$__spreadArray($8fc06cf989c7905f$var$__spreadArray([], $8fc06cf989c7905f$var$__read($8fc06cf989c7905f$var$ALLOWED_ORIGINS), false), [
                _this.allowOrigin
            ], false).includes(event.origin)) {
                console.warn("refused to receive message from origin not whitelisted", event.origin);
                return;
            }
            try {
                if (!$8fc06cf989c7905f$var$URL_REGEX.test(event.data)) {
                    console.warn("refused to receive message containing unknown data format", event.data);
                    return;
                }
            } catch (err) {
                console.error(err);
                return;
            }
            _this.broadcastChannel && _this.broadcastChannel.close();
            _this.onProcessLocation && _this.onProcessLocation(event.data);
        };
    }
    return PopupOpener;
}();
module.exports.default = new $8fc06cf989c7905f$var$PopupOpener();

});


parcelRegister("fbARu", function(module, exports) {
"use strict";
var $b0e47a16ea706734$var$__assign = module.exports && module.exports.__assign || function() {
    $b0e47a16ea706734$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b0e47a16ea706734$var$__assign.apply(this, arguments);
};
var $b0e47a16ea706734$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignOutService = void 0;

var $cal07 = parcelRequire("cal07");

var $b0e47a16ea706734$var$UrlHelper_1 = $b0e47a16ea706734$var$__importDefault((parcelRequire("elOOj")));

var $b0e47a16ea706734$var$Environment_1 = $b0e47a16ea706734$var$__importDefault((parcelRequire("4eyaY")));

var $8q1XP = parcelRequire("8q1XP");
function $b0e47a16ea706734$var$doSignOut(redirectRequest, probingResults) {
    if (probingResults === void 0) probingResults = undefined;
    var apiName = 'logout';
    var apiParameters = redirectRequest.apiParameters, externalParameters = redirectRequest.externalParameters, _a = redirectRequest.adobeIdRedirectUri, adobeIdRedirectUri = _a === void 0 ? '' : _a, clientId = redirectRequest.clientId;
    var apiExternalParams = $cal07.RedirectHelper.mergeApiParamsWithExternalParams(apiParameters, externalParameters, apiName);
    var redirectUrl = $cal07.RedirectHelper.createDefaultRedirectUrl(adobeIdRedirectUri, clientId, apiExternalParams, apiName);
    var parameters = $b0e47a16ea706734$var$__assign($b0e47a16ea706734$var$__assign({}, apiExternalParams), {
        client_id: clientId,
        redirect_uri: redirectUrl,
        jslVersion: $b0e47a16ea706734$var$Environment_1.default.jslibver
    });
    if (probingResults) parameters = Object.assign(parameters, {
        'probing_results': probingResults
    });
    var queryStrings = $b0e47a16ea706734$var$UrlHelper_1.default.uriEncodeData(parameters);
    var url = "".concat($b0e47a16ea706734$var$Environment_1.default.baseUrlAdobe, "/ims/logout/v1?").concat(queryStrings);
    $b0e47a16ea706734$var$UrlHelper_1.default.replaceUrl(url);
}
/**
 * command responsible for user sign out
 */ var $b0e47a16ea706734$var$SignOutService = /** @class */ function() {
    function SignOutService() {
        /**
         * @param {IRedirectRequest} redirectRequest. contains all the necessary properties necessary for sign out
         */ this.signOut = function(redirectRequest) {
            var clientId = redirectRequest.clientId;
            // To support the Cross-Domain Session Cookies, the third party domains
            // should be probed before logging-out, so they can be included in the
            // cookie-deleting redirect chain
            if ($b0e47a16ea706734$var$Environment_1.default.checkTokenEndpoint.proxied) new $8q1XP.ThirdPartyProbingService().probe([
                $b0e47a16ea706734$var$Environment_1.default.checkTokenEndpoint.url
            ], clientId).then(function(probingResults) {
                $b0e47a16ea706734$var$doSignOut(redirectRequest, probingResults);
            })// Shunt third party domains if any errors occur
            .catch(function() {
                $b0e47a16ea706734$var$doSignOut(redirectRequest);
            });
            else $b0e47a16ea706734$var$doSignOut(redirectRequest);
        };
    }
    return SignOutService;
}();
module.exports.SignOutService = $b0e47a16ea706734$var$SignOutService;

});
parcelRegister("8q1XP", function(module, exports) {
"use strict";
var $621246732f67657d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThirdPartyProbingService = void 0;

var $621246732f67657d$var$UrlHelper_1 = $621246732f67657d$var$__importDefault((parcelRequire("elOOj")));

var $621246732f67657d$var$Xhr_1 = $621246732f67657d$var$__importDefault((parcelRequire("kfei5")));
var $621246732f67657d$var$ThirdPartyProbingService = /** @class */ function() {
    function ThirdPartyProbingService() {
        this.probe = function(urls, clientId, timeout) {
            if (timeout === void 0) timeout = 2000;
            if (!urls || urls.length === 0) return Promise.resolve([]);
            var headers = {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': 0,
                'X-IMS-CLIENTID': clientId
            };
            var probePath = '/ims/cdsc_probe?' + $621246732f67657d$var$UrlHelper_1.default.uriEncodeData({
                client_id: clientId
            });
            var results = [];
            var promises = [];
            var _loop_1 = function(i) {
                var url = urls[i] + probePath;
                promises.push($621246732f67657d$var$Xhr_1.default.post(url, {}, headers, false, timeout).then(function(response) {
                    return response.status == 200 && results.push(i);
                }).catch(function() {
                // avoid unhandled promise warnings
                }));
            };
            for(var i = 0; i < urls.length; i++)_loop_1(i);
            return Promise.all(promises).then(function() {
                return results;
            });
        };
    }
    return ThirdPartyProbingService;
}();
module.exports.ThirdPartyProbingService = $621246732f67657d$var$ThirdPartyProbingService;

});
parcelRegister("kfei5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eXDO2 = parcelRequire("eXDO2");
module.exports.default = new /** @class */ (function() {
    function Xhr() {}
    Xhr.prototype.http = function(options) {
        return new Promise(function(resolve, reject) {
            var xmlHttpObject = window.XMLHttpRequest;
            var xhr = new xmlHttpObject();
            if (typeof options.withCredentials === 'boolean') xhr.withCredentials = options.withCredentials;
            else xhr.withCredentials = true;
            if (typeof options.timeout === 'number') xhr.timeout = options.timeout;
            xhr.open(options.method, options.url, true);
            var addHeaders = function(headers) {
                if (!headers) return;
                Object.keys(headers).forEach(function(key) {
                    xhr.setRequestHeader(key, headers[key]);
                });
            };
            xhr.onload = function onload() {
                if (this.status >= 200 && this.status < 300) return resolve(new $eXDO2.ApiResponse(this.status, this.response));
                return reject(new $eXDO2.ApiResponse(this.status, this.response));
            };
            xhr.onerror = function onerror() {
                var error = new $eXDO2.ApiResponse(this.status, this.response);
                return reject(error);
            };
            xhr.ontimeout = function onerror() {
                var error = new $eXDO2.ApiResponse(0, 'timeout');
                return reject(error);
            };
            xhr.onabort = function onerror() {
                var error = new $eXDO2.ApiResponse(0, 'aborted');
                return reject(error);
            };
            addHeaders(options.headers);
            xhr.send(options.data);
        });
    };
    Xhr.prototype.post = function(url, data, headers, withCredentials, timeout) {
        if (headers === void 0) headers = {};
        return this.http({
            headers: headers,
            method: 'POST',
            url: url,
            data: data,
            withCredentials: withCredentials,
            timeout: timeout
        });
    };
    Xhr.prototype.get = function(url, headers, withCredentials, timeout) {
        if (headers === void 0) headers = {};
        return this.http({
            headers: headers,
            method: 'GET',
            url: url,
            withCredentials: withCredentials,
            timeout: timeout
        });
    };
    return Xhr;
}());

});
parcelRegister("eXDO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApiResponse = void 0;
/**
 * class used to store the xhr error response
 */ var $ae45740884767731$var$ApiResponse = /** @class */ function() {
    function ApiResponse(status, message) {
        this.status = 0;
        this.data = '';
        this.status = status;
        this.data = this.toJson(message);
    }
    ApiResponse.prototype.toJson = function(value) {
        try {
            if (typeof value !== 'string') return value;
            return JSON.parse(value);
        } catch (_a) {
            return value;
        }
    };
    return ApiResponse;
}();
module.exports.ApiResponse = $ae45740884767731$var$ApiResponse;

});




parcelRegister("8bNRG", function(module, exports) {
"use strict";
var $5f6607ee856cab49$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5f6607ee856cab49$var$__assign = module.exports && module.exports.__assign || function() {
    $5f6607ee856cab49$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5f6607ee856cab49$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdobeIdData = void 0;

var $5Qrtd = parcelRequire("5Qrtd");

var $aHGkm = parcelRequire("aHGkm");

var $b45IL = parcelRequire("b45IL");

var $4Murb = parcelRequire("4Murb");

var $b1rY6 = parcelRequire("b1rY6");

var $3pcdl = parcelRequire("3pcdl");
/**
 *  Class used to store the adobe data values.
 *
 *  Ims library will use these values for all operations
 */ var $5f6607ee856cab49$var$AdobeIdData = /** @class */ function(_super) {
    $5f6607ee856cab49$var$__extends(AdobeIdData, _super);
    /**
     * @constructor Create the adobeIdData object with all necessary properties from adobeData input paramater
     *
     * It uses the input adobeData parameter or the object stored in window.adobeid
     */ function AdobeIdData(adobeData) {
        if (adobeData === void 0) adobeData = null;
        var _this = _super.call(this, adobeData) || this;
        /** @function {adobeid.onAccessTokenHasExpired} onAccessTokenHasExpired
         *  Function to be executed if the 'access_token' is invalid.
         */ _this.onAccessTokenHasExpired = null;
        /**  @function {adobeid.onAccessToken} - Function to be executed once imslib.js has acquired
         * an `access_token`.
         */ _this.onAccessToken = null;
        /**
         * @function {adobeid.onReauthAccessToken} Function used to trigger the reauth access token
         */ _this.onReauthAccessToken = null;
        /**
         * @function {adobeid.onError}
         * Function used to notify external libraries for ims errors
         */ _this.onError = null;
        _this.onSignOutEventReceived = null;
        /**
         * Handlers object is used to invoke the adobe id data events.
         *
         * When a token, profile is aquired, or token is expired and library is fully intialized, an event is triggered
         */ _this.handlers = {
            triggerOnAccessToken: function(data) {
                _this.onAccessToken && _this.onAccessToken(data);
            },
            triggerOnReauthAccessToken: function(data) {
                _this.onReauthAccessToken && _this.onReauthAccessToken(data);
            },
            triggerOnAccessTokenHasExpired: function(ex) {
                _this.onAccessTokenHasExpired && _this.onAccessTokenHasExpired(ex);
            },
            triggerOnReady: function(context) {
                if (context === void 0) context = null;
                _this.onReady && _this.onReady(context);
            },
            triggerOnError: function(errorType, error, exception) {
                _this.onError && _this.onError(errorType, error, exception);
            }
        };
        var adobeid = adobeData ? adobeData : window[$5Qrtd.AdobeIdKey];
        if (!adobeid || !adobeid.client_id) throw new Error("Please provide required adobeId, client_id information");
        var standalone = adobeid.standalone, autoValidateToken = adobeid.autoValidateToken, _a = adobeid.modalSettings, modalSettings = _a === void 0 ? {} : _a, _b = adobeid.modalMode, modalMode = _b === void 0 ? false : _b, onAccessToken = adobeid.onAccessToken, onReauthAccessToken = adobeid.onReauthAccessToken, onAccessTokenHasExpired = adobeid.onAccessTokenHasExpired, onSignOutEventReceived = adobeid.onSignOutEventReceived, onReady = adobeid.onReady, onError = adobeid.onError, overrideErrorHandler = adobeid.overrideErrorHandler, onModalModeSignInComplete = adobeid.onModalModeSignInComplete, alwaysRemoveTokenFromUrl = adobeid.alwaysRemoveTokenFromUrl, enableGuestAccounts = adobeid.enableGuestAccounts, enableGuestTokenForceRefresh = adobeid.enableGuestTokenForceRefresh, enableGuestBotDetection = adobeid.enableGuestBotDetection, guestBotDetectionProvider = adobeid.guestBotDetectionProvider;
        if (standalone && standalone.token) _this.standalone = new $b45IL.StandaloneToken(standalone);
        _this.modalSettings = new $aHGkm.PopupSettings(modalSettings);
        _this.modalMode = modalMode;
        _this.autoValidateToken = !!autoValidateToken;
        _this.onAccessToken = onAccessToken ? onAccessToken : null;
        _this.onReauthAccessToken = onReauthAccessToken ? onReauthAccessToken : null;
        _this.onAccessTokenHasExpired = onAccessTokenHasExpired ? onAccessTokenHasExpired : null;
        _this.onReady = onReady ? onReady : null;
        _this.onError = onError ? onError : null;
        _this.overrideErrorHandler = overrideErrorHandler;
        _this.onModalModeSignInComplete = onModalModeSignInComplete;
        _this.alwaysRemoveTokenFromUrl = alwaysRemoveTokenFromUrl;
        _this.enableGuestAccounts = !!enableGuestAccounts;
        _this.enableGuestTokenForceRefresh = !!enableGuestTokenForceRefresh;
        _this.enableGuestBotDetection = !!enableGuestBotDetection;
        _this.guestBotDetectionProvider = guestBotDetectionProvider;
        _this.onSignOutEventReceived = onSignOutEventReceived;
        return _this;
    }
    /**
     * Function used by IMSLib to use only the neccesarry properties from AdobeIdData for social provider
     * @param providerName provider name used for sign in
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdData.prototype.createSocialProviderRedirectRequest = function(providerName, requestedParameters, contextToBePassedOnRedirect, nonce, grantType) {
        if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
        var params = {
            idp_flow: requestedParameters.idp_flow ? "social.deep_link.web.".concat(requestedParameters.idp_flow) : 'social.deep_link.web',
            provider_id: providerName
        };
        var signInParams = $5f6607ee856cab49$var$__assign($5f6607ee856cab49$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(signInParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     * @param nonce {string} - string representing the nonce value used for CSRF
     * @param reauth {string}; represents the re authenticate value. available values are: check and force. default value is "check"
     */ AdobeIdData.prototype.createReAuthenticateRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce, reauth, grantType) {
        if (reauth === void 0) reauth = $4Murb.IReauth.check;
        if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
        var params = {
            reauth: reauth
        };
        var reauthParams = $5f6607ee856cab49$var$__assign($5f6607ee856cab49$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(reauthParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdData.prototype.createSignUpRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce, grantType) {
        if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
        var signupParams = $5f6607ee856cab49$var$__assign($5f6607ee856cab49$var$__assign({}, requestedParameters), {
            idp_flow: requestedParameters.idp_flow ? "create_account.".concat(requestedParameters.idp_flow) : "create_account"
        });
        return this.createRedirectRequest(signupParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    return AdobeIdData;
}($3pcdl.AdobeIdThinData);
module.exports.AdobeIdData = $5f6607ee856cab49$var$AdobeIdData;

});
parcelRegister("aHGkm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupSettings = void 0;
/**
 * class used to store the modal settings
 */ var $7caec0df0bc274a5$var$PopupSettings = /** @class */ function() {
    function PopupSettings(data) {
        if (data === void 0) data = {};
        this.title = 'Adobe ID';
        this.width = 600;
        this.top = 100;
        this.left = 100;
        var _a = data.title, title = _a === void 0 ? 'Adobe ID' : _a, _b = data.width, width = _b === void 0 ? 600 : _b, _c = data.height, height = _c === void 0 ? 700 : _c, _d = data.top, top = _d === void 0 ? 100 : _d, _e = data.left, left = _e === void 0 ? 100 : _e, allowedOrigin = data.allowedOrigin;
        this.title = title;
        this.width = width;
        this.height = height;
        this.top = top;
        this.left = left;
        this.allowOrigin = allowedOrigin;
    }
    return PopupSettings;
}();
module.exports.PopupSettings = $7caec0df0bc274a5$var$PopupSettings;

});

parcelRegister("b45IL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StandaloneToken = void 0;
/**
 * class used to encapsulate the token and expiration ms;
 * this values are passed from outside of the library by using adobeid
 */ var $80e48180d0bc7b28$var$StandaloneToken = /** @class */ function() {
    function StandaloneToken(data) {
        this.token = '';
        /**
         * representing the session identifier
         */ this.sid = '';
        this.expirems = 0;
        var token = data.token, expirems = data.expirems;
        this.token = token;
        this.expirems = expirems;
    }
    return StandaloneToken;
}();
module.exports.StandaloneToken = $80e48180d0bc7b28$var$StandaloneToken;

});

parcelRegister("4Murb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IReauth = void 0;
/**
 * Enumeration values used for reAuthenticate method
 *
 * Default value is check
 */ var $37b3415febf3ad45$var$IReauth;
(function(IReauth) {
    /**
     * Forces the reauth process to show the credentials screen to the user
     */ IReauth["force"] = "force";
    /**
     * Starts the reauthentication check flow. Which won't prompt the user for reauthentication if the user already performed an authentication in a period of time configured on the client id.
     */ IReauth["check"] = "check";
})($37b3415febf3ad45$var$IReauth || (module.exports.IReauth = $37b3415febf3ad45$var$IReauth = {}));

});

parcelRegister("b1rY6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IGrantTypes = void 0;
/**
 * Enumeration values used for available grant types
 *
 * Default value is token
 */ var $80657ba402efbe9a$var$IGrantTypes;
(function(IGrantTypes) {
    /**
     * token
     */ IGrantTypes["token"] = "token";
    /**
     * authorization code
     */ IGrantTypes["code"] = "code";
})($80657ba402efbe9a$var$IGrantTypes || (module.exports.IGrantTypes = $80657ba402efbe9a$var$IGrantTypes = {}));

});

parcelRegister("3pcdl", function(module, exports) {
"use strict";
var $27ad2e60dac523c5$var$__assign = module.exports && module.exports.__assign || function() {
    $27ad2e60dac523c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27ad2e60dac523c5$var$__assign.apply(this, arguments);
};
var $27ad2e60dac523c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdobeIdThinData = void 0;

var $5Qrtd = parcelRequire("5Qrtd");

var $isdGM = parcelRequire("isdGM");

var $27ad2e60dac523c5$var$Environment_1 = $27ad2e60dac523c5$var$__importDefault((parcelRequire("4eyaY")));

var $6M6t4 = parcelRequire("6M6t4");

var $27ad2e60dac523c5$var$Log_1 = $27ad2e60dac523c5$var$__importDefault((parcelRequire("62W4m")));

var $4Murb = parcelRequire("4Murb");

var $b1rY6 = parcelRequire("b1rY6");

var $8a1xD = parcelRequire("8a1xD");
/**
 *  Class used to store the adobe data values.
 *
 *  Ims library will use these values for all operations
 */ var $27ad2e60dac523c5$var$AdobeIdThinData = /** @class */ function() {
    /**
     * @constructor Create the adobeIdData object with all necessary properties from adobeData input paramater
     *
     * It uses the input adobeData parameter or the object stored in window.adobeid
     */ function AdobeIdThinData(adobeData) {
        if (adobeData === void 0) adobeData = null;
        /**
         * represents the class used to store the analytics parameters
         */ this.analyticsParameters = new $6M6t4.AnalyticsParameters();
        /**
          @property Object containing various custom parameters for IMS.
          This object is used in case a custom API parameter is desired to be sent to the back-end.
      
          E.G. { logout: 'your_custom_value' }
      
          The list of api's which can be customized are: authorize, validate_token, profile, userinfo, logout, logout_token, check, providers, ijt, jumptoken_to_device
        */ this.api_parameters = {};
        /**
          @property {string} Localization value used by ims library.
      
          Default value is `en_US`
        */ this.locale = "";
        /**
         * @property {string} - The scopes used to acquire access tokens. A comma separated list of client scopes.
         * No whitespace.
         * Default scopes: AdobeID
         */ this.scope = "AdobeID";
        /**
         * @property {string} - The client id used by ims library
         */ this.client_id = "";
        /**
         * represents the used environment; default is prod and in case the value is stg1, the stage environment is used
         */ this.environment = $isdGM.IEnvironment.PROD;
        /**
         *  use the local storage for token management; default value is false;
         */ this.useLocalStorage = false;
        this.alwaysRemoveTokenFromUrl = false;
        /**
         * @property {boolean} If enabled, the library will ignore any access token received in the URL fragment during initialization
         */ this.ignoreUrlToken = false;
        /** @function {adobeid.onReady} [onReady] - Function to be executed once imslib.js has been fully
         * initialized.
         */ this.onReady = null;
        this.onModalModeSignInComplete = null;
        this.proxiedCheckToken = false;
        var adobeid = adobeData ? adobeData : window[$5Qrtd.AdobeIdKey];
        if (!adobeid || !adobeid.client_id) throw new Error("Please provide required adobeId, client_id information");
        var api_parameters = adobeid.api_parameters, client_id = adobeid.client_id, locale = adobeid.locale, scope = adobeid.scope, ijt = adobeid.ijt, _a = adobeid.environment, environment = _a === void 0 ? $isdGM.IEnvironment.PROD : _a, redirect_uri = adobeid.redirect_uri, useLocalStorage = adobeid.useLocalStorage, logsEnabled = adobeid.logsEnabled, onReady = adobeid.onReady, rideRedirectUri = adobeid.rideRedirectUri, proxiedCheckToken = adobeid.proxiedCheckToken, ignoreUrlToken = adobeid.ignoreUrlToken;
        this.environment = environment;
        this.api_parameters = api_parameters ? api_parameters : {};
        this.client_id = client_id;
        this.locale = locale || $5Qrtd.DEFAULT_LANGUAGE;
        this.scope = scope ? scope.replace(/\s/gi, '') : '';
        this.redirect_uri = redirect_uri;
        this.ijt = ijt;
        this.useLocalStorage = useLocalStorage;
        if (logsEnabled) $27ad2e60dac523c5$var$Log_1.default.enableLogging();
        else $27ad2e60dac523c5$var$Log_1.default.disableLogging();
        this.onReady = onReady ? onReady : null;
        this.rideRedirectUri = rideRedirectUri;
        this.proxiedCheckToken = proxiedCheckToken;
        this.ignoreUrlToken = !!ignoreUrlToken;
        this.fillAnalyticsParameters(adobeid);
        $27ad2e60dac523c5$var$Environment_1.default.loadEnvironment(environment, proxiedCheckToken, window.location.hostname);
    }
    /**
     * fill the analytic parameters with the values provided by adobeid data
     * @param adobeid represents the adobeid data provided to library
     */ AdobeIdThinData.prototype.fillAnalyticsParameters = function(adobeid) {
        var _a = adobeid.analytics, _b = _a === void 0 ? {} : _a, _c = _b.appCode, appCode = _c === void 0 ? "" : _c, _d = _b.appVersion, appVersion = _d === void 0 ? "" : _d;
        var analyticsParameters = this.analyticsParameters;
        analyticsParameters.appCode = appCode;
        analyticsParameters.appVersion = appVersion;
    };
    /**
     * Function used by IMSLib to use only the neccesarry properties from AdobeIdData for social provider
     * @param providerName provider name used for sign in
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdThinData.prototype.createSocialProviderRedirectRequest = function(providerName, requestedParameters, contextToBePassedOnRedirect, nonce, grantType) {
        var params = {
            idp_flow: requestedParameters.idp_flow ? "social.deep_link.web.".concat(requestedParameters.idp_flow) : 'social.deep_link.web',
            provider_id: providerName
        };
        var signInParams = $27ad2e60dac523c5$var$__assign($27ad2e60dac523c5$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(signInParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     * @param nonce {string} - string representing the nonce value used for CSRF
     * @param reauth {string}; represents the re authenticate value. available values are: check and force. default value is "check"
     */ AdobeIdThinData.prototype.createReAuthenticateRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce, reauth, grantType) {
        if (reauth === void 0) reauth = $4Murb.IReauth.check;
        if (grantType === void 0) grantType = $b1rY6.IGrantTypes.token;
        var params = {
            reauth: reauth
        };
        var reauthParams = $27ad2e60dac523c5$var$__assign($27ad2e60dac523c5$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(reauthParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdThinData.prototype.createSignUpRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce) {
        var signupParams = $27ad2e60dac523c5$var$__assign($27ad2e60dac523c5$var$__assign({}, requestedParameters), {
            idp_flow: requestedParameters.idp_flow ? "create_account.".concat(requestedParameters.idp_flow) : 'create_account'
        });
        return this.createRedirectRequest(signupParams, contextToBePassedOnRedirect, nonce, $b1rY6.IGrantTypes.token);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param externalParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     * @param nonce {string} - string representing the nonce value used for CSRF
     * @param grantType {IGrantTypes} represents the grant type used for sign in flow
     */ AdobeIdThinData.prototype.createRedirectRequest = function(externalParameters, contextToBePassedOnRedirect, nonce, grantType) {
        var _this = this;
        var _a = this, _b = _a.api_parameters, apiParameters = _b === void 0 ? {} : _b, clientId = _a.client_id, _c = _a.redirect_uri, adobeIdRedirectUri = _c === void 0 ? '' : _c, scope = _a.scope, locale = _a.locale;
        var state = this.createRedirectState(contextToBePassedOnRedirect, nonce);
        var redirectRequest = {
            adobeIdRedirectUri: adobeIdRedirectUri,
            apiParameters: apiParameters,
            clientId: clientId,
            externalParameters: externalParameters,
            scope: scope,
            locale: locale,
            response_type: grantType,
            state: state
        };
        if (grantType === $b1rY6.IGrantTypes.token) return Promise.resolve(redirectRequest);
        var codeChallenge = new $8a1xD.CodeChallenge();
        return codeChallenge.createCodeChallenge(nonce).then(function(challengeResponse) {
            externalParameters.code_challenge = challengeResponse.challenge;
            externalParameters.code_challenge_method = 'S256';
            var codeState = _this.createRedirectState(contextToBePassedOnRedirect, nonce);
            redirectRequest.state = codeState;
            return Promise.resolve(redirectRequest);
        });
    };
    /**
     * create the stae object used during redirect; if the adobeid.context is empty and no analytics parameters, the state will ne null
     * @param context represents the external parameters
     */ AdobeIdThinData.prototype.createRedirectState = function(context, nonce) {
        var _a = this.analyticsParameters, _b = _a.appCode, appCode = _b === void 0 ? "" : _b, _c = _a.appVersion, appVersion = _c === void 0 ? "" : _c;
        var state = context === undefined ? {} : {
            context: context
        };
        if (appCode) state["ac"] = appCode;
        if (appVersion) state["av"] = appVersion;
        state["jslibver"] = $27ad2e60dac523c5$var$Environment_1.default.jslibver;
        state["nonce"] = nonce;
        return Object.keys(state).length ? state : null;
    };
    AdobeIdThinData.prototype.triggerOnReady = function() {
        this.onReady && this.onReady(undefined);
    };
    AdobeIdThinData.prototype.computeRideRedirectUri = function(code) {
        if (!this.rideRedirectUri) return window.location.href;
        if (typeof this.rideRedirectUri === "string") return this.rideRedirectUri === "DEFAULT" ? null : this.rideRedirectUri;
        return this.rideRedirectUri(code);
    };
    return AdobeIdThinData;
}();
module.exports.AdobeIdThinData = $27ad2e60dac523c5$var$AdobeIdThinData;

});
parcelRegister("6M6t4", function(module, exports) {
"use strict";
/**
 * class used to store the analytics parameters
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnalyticsParameters = void 0;
var $4eec3e2631222d5b$var$AnalyticsParameters = /** @class */ function() {
    function AnalyticsParameters() {
        /**
        * represents the application code value;
        * this value (if exists) will be sent to the server.
        */ this.appCode = '';
        /**
         * represents the application version value;
         * this value (if exists) will be sent to the server.
         */ this.appVersion = '';
    }
    return AnalyticsParameters;
}();
module.exports.AnalyticsParameters = $4eec3e2631222d5b$var$AnalyticsParameters;

});

parcelRegister("8a1xD", function(module, exports) {
"use strict";
var $5f107404b2091470$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5f107404b2091470$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $5f107404b2091470$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeChallenge = module.exports.ONE_HOUR = void 0;

var $5f107404b2091470$var$StorageFactory_1 = $5f107404b2091470$var$__importDefault((parcelRequire("kk2tv")));
module.exports.ONE_HOUR = 12960000;
var $5f107404b2091470$var$CodeChallenge = /** @class */ function() {
    function CodeChallenge() {
        this.storage = $5f107404b2091470$var$StorageFactory_1.default.getAvailableStorage();
    }
    CodeChallenge.prototype.b64Uri = function(r) {
        return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    };
    /**
     *
     * @param nonce {String} represents the key used to store the code verifier
     * @param verifierLength {number} represents the verifier length
     * @returns {ICodeChallenge} verifier and challenge codes
     */ CodeChallenge.prototype.createCodeChallenge = function(nonce, verifierLength) {
        var _this = this;
        if (verifierLength === void 0) verifierLength = 43;
        var cryptoObj = window['msCrypto'] || window.crypto;
        var verifier = this.b64Uri(Array.prototype.map.call(cryptoObj.getRandomValues(new Uint8Array(verifierLength)), function(r) {
            return String.fromCharCode(r);
        }).join("")).substring(0, verifierLength);
        var uintVerifierArr = new Uint8Array(verifier.length);
        for(var i = 0; i < verifier.length; i++)uintVerifierArr[i] = verifier.charCodeAt(i);
        var cryptoDigest = cryptoObj.subtle.digest('SHA-256', uintVerifierArr);
        return new Promise(function(resolve, reject) {
            if (window['CryptoOperation']) {
                cryptoDigest.onerror = function(err) {
                    return reject(err);
                };
                cryptoDigest.oncomplete = function(response) {
                    var uintArr = new Uint8Array(response.target.result);
                    var challenge = _this.b64Uri(String.fromCharCode.apply(String, $5f107404b2091470$var$__spreadArray([], $5f107404b2091470$var$__read(uintArr), false)));
                    return resolve(_this.saveVerifierAndReturn(nonce, {
                        verifier: verifier,
                        challenge: challenge
                    }));
                };
            } else cryptoDigest.then(function(response) {
                var uintArr = new Uint8Array(response);
                var challenge = _this.b64Uri(String.fromCharCode.apply(String, $5f107404b2091470$var$__spreadArray([], $5f107404b2091470$var$__read(uintArr), false)));
                return resolve(_this.saveVerifierAndReturn(nonce, {
                    verifier: verifier,
                    challenge: challenge
                }));
            });
        });
    };
    /**
     *
     * @param nonce {String} represents the key used to store the code verifier
     * @param challengeAndVerifier {ICodeChallenge} represents the code challenge and code verifier
     * @returns ICodeChallenge
     */ CodeChallenge.prototype.saveVerifierAndReturn = function(nonce, challengeAndVerifier) {
        var verifiers = this.getVerifierValuesFromStorage();
        var storageValue = {
            verifier: challengeAndVerifier.verifier || '',
            expiry: new Date().getTime().toString()
        };
        verifiers[nonce] = storageValue;
        this.storage.setItem('verifiers', JSON.stringify(verifiers));
        return Promise.resolve(challengeAndVerifier);
    };
    /**
   * Returns the nonce values from storage as an Object or null
   * @returns {IDictionary | null}
   */ CodeChallenge.prototype.getVerifierValuesFromStorage = function() {
        var storageVerifiers = this.storage.getItem('verifiers');
        var verifiers = storageVerifiers ? JSON.parse(storageVerifiers) : {};
        return this.clearOlderVerifiers(verifiers);
    };
    CodeChallenge.prototype.clearOlderVerifiers = function(verifiers, olderThan) {
        if (olderThan === void 0) olderThan = module.exports.ONE_HOUR;
        var oneHourAgo = Date.now() - olderThan;
        var expiry = 0;
        Object.keys(verifiers).forEach(function(key) {
            expiry = parseInt(verifiers[key]);
            if (expiry < oneHourAgo) delete verifiers[key];
        });
        return verifiers;
    };
    /**
     * rerturns the verifier from storage
     * @param key {String} represents the key used to stora the verfier
     */ CodeChallenge.prototype.getVerifierByKey = function(key) {
        var verifiers = this.getVerifierValuesFromStorage();
        var verifierObj = verifiers ? verifiers[key] : {};
        delete verifiers[key];
        this.storage.setItem('verifiers', JSON.stringify(verifiers));
        return verifierObj ? verifierObj['verifier'] : '';
    };
    return CodeChallenge;
}();
module.exports.CodeChallenge = $5f107404b2091470$var$CodeChallenge;

});



parcelRegister("5ccdI", function(module, exports) {
"use strict";
var $3c878d6dda721bc0$var$__assign = module.exports && module.exports.__assign || function() {
    $3c878d6dda721bc0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c878d6dda721bc0$var$__assign.apply(this, arguments);
};
var $3c878d6dda721bc0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3c878d6dda721bc0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImsApis = void 0;

var $5Qrtd = parcelRequire("5Qrtd");

var $3c878d6dda721bc0$var$UrlHelper_1 = $3c878d6dda721bc0$var$__importDefault((parcelRequire("elOOj")));

var $3c878d6dda721bc0$var$ApiHelpers_1 = $3c878d6dda721bc0$var$__importDefault((parcelRequire("3zfSA")));

var $3c878d6dda721bc0$var$Environment_1 = $3c878d6dda721bc0$var$__importDefault((parcelRequire("4eyaY")));

var $3c878d6dda721bc0$var$ImsXhr_1 = $3c878d6dda721bc0$var$__importDefault((parcelRequire("dBbpE")));
/**
 * class used as a entry point for Ims api's
 * @todo discuss rate limit --> code 429 on http response.
 */ var $3c878d6dda721bc0$var$ImsApis = /** @class */ function() {
    /**
     * imsApis constructor;
     */ function ImsApis(apiParameters) {
        if (apiParameters === void 0) apiParameters = {};
        this.CONTENT_FORM_ENCODED = 'application/x-www-form-urlencoded;charset=utf-8';
        this.apiParameters = apiParameters;
    }
    /**
     * validate the input token
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.validateToken = function(request) {
        var token = request.token, client_id = request.client_id, type = request.type;
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'validate_token')), {
            type: type || 'access_token',
            client_id: client_id,
            token: token
        }));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlAdobe, "/ims/validate_token/v1?jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var config = this.formEncoded();
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
     * retrieve the profile based on the input token
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.getProfile = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'profile'));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlAdobe, "/ims/profile/v1?").concat(queryStrings, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(url, config);
    };
    /**
     * @returns the user info based on the input token
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.getUserInfo = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'userinfo'));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlAdobe, "/ims/userinfo/v1?").concat(queryStrings, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(url, config);
    };
    /**
      * invalidate the input token
      * @param request IAuthorizedApiRequest contains clientId and token information
      */ ImsApis.prototype.logoutToken = function(apiRequest) {
        var client_id = apiRequest.client_id, access_token = apiRequest.token;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'logout_token'));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/logout/v1?jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var config = this.addClientIdInHeader(client_id);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post(url, $3c878d6dda721bc0$var$__assign({
            client_id: client_id,
            access_token: access_token
        }, additionalParams), config);
    };
    /**
     * Does an API to check the cookie status of the browser.
     */ ImsApis.prototype.checkStatus = function() {
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/check/v1/status");
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(url);
    };
    /**
     * @returns a new token
     * @param request ICheckTokenApiRequest contains clientId information
     * @param userId { string } represents the user id associated with logged user
     * @todo We will probably need also check token v5
     */ ImsApis.prototype.checkToken = function(apiRequest, externalParameters, userId) {
        var client_id = apiRequest.client_id, scope = apiRequest.scope;
        var arkoseSessionToken = externalParameters.arkoseSessionToken, fingerprintRequestId = externalParameters.fingerprintRequestId, restExternalParameters = $3c878d6dda721bc0$var$__rest(externalParameters, [
            "arkoseSessionToken",
            "fingerprintRequestId"
        ]);
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(restExternalParameters, this.apiParameters, 'check_token'));
        var apiBody = $3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), {
            client_id: client_id,
            scope: scope
        });
        if (arkoseSessionToken) apiBody.arkose_session_token = arkoseSessionToken;
        if (fingerprintRequestId) apiBody.fingerprint_request_id = fingerprintRequestId;
        if (userId) apiBody.user_id = userId;
        return this.callCheckToken($3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData(apiBody), "/check/v6/token?jslVersion=".concat($3c878d6dda721bc0$var$Environment_1.default.jslibver));
    };
    /**
     * @returns a new token and profile for the existing user
     * @param request IUnAuthorizedApiRequest contains clientId information
     * @param userId contains the user id of the logged user
     * https://wiki.corp.adobe.com/display/ims/IMS+API+-+check+token#IMSAPIchecktoken-Version6
     */ ImsApis.prototype.switchProfile = function(apiRequest, externalParameters, userId) {
        if (userId === void 0) userId = '';
        var client_id = apiRequest.client_id, _a = apiRequest.scope, scope = _a === void 0 ? '' : _a;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, 'check_token'));
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), {
            client_id: client_id,
            scope: scope,
            user_id: userId
        }));
        return this.callCheckToken(data, "/check/v6/token?jslVersion=".concat($3c878d6dda721bc0$var$Environment_1.default.jslibver));
    };
    /**
     * @returns list of api providers
     * @param request IUnAuthorizedApiRequest contains clientId information
     */ ImsApis.prototype.listSocialProviders = function(apiRequest) {
        var client_id = apiRequest.client_id;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'providers'));
        var queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/social/v2/providers?").concat(queryStrings, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var config = this.addClientIdInHeader(client_id);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(url, config);
    };
    /**
    * @see {@link https://wiki.corp.adobe.com/display/ims/Implicit+Jump+Tokens |Implicit Jump Tokens}
    * @param request IUnAuthorizedApiRequest contains clientId and token information
    * @param ijt {string}
    */ ImsApis.prototype.exchangeIjt = function(apiRequest, ijt) {
        var client_id = apiRequest.client_id;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'ijt'));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/jump/implicit/").concat(ijt);
        var queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign({
            client_id: client_id
        }, additionalParams));
        var apiUrl = "".concat(url, "?").concat(queryStrings, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        if (apiUrl.length > 2048) {
            delete additionalParams['redirect_uri'];
            queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData(additionalParams);
            apiUrl = "".concat(url, "?").concat(queryStrings);
        }
        var config = this.addClientIdInHeader(client_id);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(apiUrl, config);
    };
    /**
     * Returns the URL to the avatar of a user
     * @param {UserId} userId
     * @returns {String}
     */ ImsApis.prototype.avatarUrl = function(userId) {
        return "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlAdobe, "/ims/avatar/download/").concat(userId);
    };
    /**
     * Retrieve the user's IMS organizations
     * Requires read_organizations scope in the access token
     * @param request IOrganizationsRequest contains clientId and token information
     * @returns Promise<IOrganizationsResponse> - Can be a single org object or array of orgs
     */ ImsApis.prototype.getOrganizations = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'organizations'));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlAdobe, "/ims/organizations/v6?").concat(queryStrings, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(url, config);
    };
    /**
     * Makes a request to IMS to get the Floodgate release flags.
     * Optionally accepts an access token from which to decode the release flags.
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.getReleaseFlags = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, 'fg_value'));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlAdobe, "/ims/fg/value/v1?").concat(queryStrings, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.get(url, config);
    };
    /**
     * Exchange the user's access_token for a Transitory Access Code (TAC) for target client and scope
     * @param tacRequest {ITransitoryAuthorizationRequest} - contains the request parameters
     * @param externalParameters {object} - contains the possible parameters used to override the api parameters
     * @param clientId {string} - the adobeid.client_id value
     */ ImsApis.prototype.getTransitoryAuthorizationCode = function(tacRequest, externalParameters, clientId) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, 'check_token'));
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), tacRequest));
        return this.callCheckToken(data, "/check/v6/token?client_id=".concat(clientId, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver));
    };
    /**
     * returns an access token from a authorization or device code
     * @param authorizationRequest {AuthorizationCode} contains the authorization request parameters
     * @param externalParameters {object} - contains the possible parameters used to override the api parameters
     */ ImsApis.prototype.getTokenFromCode = function(authorizationRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, 'token'));
        additionalParams.grant_type = 'authorization_code';
        delete authorizationRequest.other;
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/token/v3?jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), authorizationRequest));
        var config = this.formEncoded();
        this.addClientIdInHeader(authorizationRequest.client_id, config);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
     * Allows a client to launch a system-browser and arrive at another IMS-integrated application
     * @see {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=ims&title=IMS+API+-+jumptoken }
     * @param jumpTokenRequest {JumpTokenRequest}
     * @param externalParameters {IDictionary}
     * @returns JumpTokenResponse
     */ ImsApis.prototype.jumpToken = function(jumpTokenRequest, externalParameters, clientId) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, 'jumptoken'));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/jumptoken/v1?client_id=").concat(clientId, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), jumpTokenRequest));
        var config = this.formEncoded();
        this.addClientIdInHeader(clientId, config);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
     * Users can jump between a web browser and a mobile/desktop application and must be able to do that seamlessly
     * without entering the authorization flow in the desktop application again.
     * @see {@link https://wiki.corp.adobe.com/x/hEsEtw }
     * @param jumpTokenToDeviceRequest {IJumpTokenToDeviceRequest}
     * @param externalParameters {IDictionary}
     * @returns IJumpTokenToDeviceResponse
     */ ImsApis.prototype.jumpTokenToDevice = function(jumpTokenToDeviceRequest, externalParameters, clientId, userId) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, 'jumptoken_to_device'));
        // Override user_id with the passed userId if it's not already present in additionalParams
        if (!additionalParams.user_id && userId) additionalParams.user_id = userId;
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/jumptoken/v2?client_id=").concat(clientId, "&jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), jumpTokenToDeviceRequest));
        var config = this.formEncoded();
        this.addClientIdInHeader(clientId, config);
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
       * Provides signin / signup utility via the social native headless API
       * @see {@link https://wiki.corp.adobe.com/pages/viewpage.action?pageId=1106020498 }
       * @param id_token from provider
       * @param provider_id either google, facebook or apple
       */ ImsApis.prototype.socialHeadlessSignIn = function(socialHeadlessSignInRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $3c878d6dda721bc0$var$__assign({}, $3c878d6dda721bc0$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, 'jumptoken'));
        var url = "".concat($3c878d6dda721bc0$var$Environment_1.default.baseUrlServices, "/ims/social/v2/native?jslVersion=").concat($3c878d6dda721bc0$var$Environment_1.default.jslibver);
        var data = $3c878d6dda721bc0$var$UrlHelper_1.default.uriEncodeData($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign($3c878d6dda721bc0$var$__assign({}, additionalParams), socialHeadlessSignInRequest), {
            response_type: 'implicit_jump'
        }));
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post(url, data, this.formEncoded());
    };
    /**
     * create the authorization header in case the accesToken exists
     * @param accessToken {string};
     * @returns {string}
     */ ImsApis.prototype.createAuthorizationHeader = function(accessToken) {
        var headers = {};
        if (accessToken) headers[$5Qrtd.HEADERS.AUTHORIZATION] = "Bearer ".concat(accessToken);
        return headers;
    };
    /**
     *
     * @param headers the header which will be sent to ims server on API request
     */ ImsApis.prototype.formEncoded = function(headers) {
        if (headers === void 0) headers = {};
        headers["content-type"] = this.CONTENT_FORM_ENCODED;
        return headers;
    };
    /**
     * add clientId in header
     * @param clientId {string};
     * @param headers {IDictionary};
     */ ImsApis.prototype.addClientIdInHeader = function(clientId, headers) {
        if (headers === void 0) headers = {};
        headers["client_id"] = clientId;
        return headers;
    };
    ImsApis.prototype.callCheckToken = function(data, pathSuffix) {
        var config = this.formEncoded();
        return $3c878d6dda721bc0$var$ImsXhr_1.default.post("".concat($3c878d6dda721bc0$var$Environment_1.default.checkTokenEndpoint.url, "/ims").concat(pathSuffix), data, config).catch(function(e) {
            if (!$3c878d6dda721bc0$var$Environment_1.default.checkTokenEndpoint.shouldFallbackToAdobe(e)) throw e;
            return $3c878d6dda721bc0$var$ImsXhr_1.default.post("".concat($3c878d6dda721bc0$var$Environment_1.default.checkTokenEndpoint.fallbackUrl, "/ims").concat(pathSuffix), data, config);
        });
    };
    return ImsApis;
}();
module.exports.ImsApis = $3c878d6dda721bc0$var$ImsApis;

});
parcelRegister("dBbpE", function(module, exports) {
"use strict";
var $9e679568df04bfd1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9e679568df04bfd1$var$Debouncer_1 = $9e679568df04bfd1$var$__importDefault((parcelRequire("dtYSq")));

var $9e679568df04bfd1$var$HttpErrorHandler_1 = $9e679568df04bfd1$var$__importDefault((parcelRequire("3oYUy")));

var $9e679568df04bfd1$var$Xhr_1 = $9e679568df04bfd1$var$__importDefault((parcelRequire("kfei5")));
module.exports.default = new /** @class */ (function() {
    function ImsXhr() {
        this.triggerOnError = null;
    }
    /**
     * check if the cache contains data for the same url and parameters value;
     * if true, returns the cached value otherwise make the http call
     * @param url - url used to make a POST http request
     * @param data - dat passed to the back-end
     * @param config - http configuration
    */ ImsXhr.prototype.post = function(url, data, config) {
        var _this = this;
        if (config === void 0) config = {};
        var cachedData = $9e679568df04bfd1$var$Debouncer_1.default.getCachedApiResponse(url, data);
        if (cachedData) {
            var status_1 = cachedData.status, data_1 = cachedData.data;
            return status_1 === 200 ? Promise.resolve(data_1) : Promise.reject(data_1);
        }
        return $9e679568df04bfd1$var$Xhr_1.default.post(url, data, config).then(function(response) {
            return _this.storeApiResponse(url, JSON.stringify(data), response);
        }).catch(function(ex) {
            return _this.verifyError(url, JSON.stringify(data), ex);
        });
    };
    /**
     * check if the cache contains data for the input url
     * if true, returns the cached value otherwise make the http call
     * @param url - url used to make a POST http request
     * @param config - contains xmlhttprequest headers
    */ ImsXhr.prototype.get = function(url, config) {
        var _this = this;
        if (config === void 0) config = {};
        var cachedData = $9e679568df04bfd1$var$Debouncer_1.default.getCachedApiResponse(url);
        if (cachedData) {
            var status_2 = cachedData.status, data = cachedData.data;
            return status_2 === 200 ? Promise.resolve(data) : Promise.reject(data);
        }
        return $9e679568df04bfd1$var$Xhr_1.default.get(url, config).then(function(response) {
            return _this.storeApiResponse(url, '', response);
        }).catch(function(ex) {
            return _this.verifyError(url, '', ex);
        });
    };
    /**
     *
     * @param exception {ApiResponse} - represents the back-end service
     * @param url: {string} - url used to call the api
     * @param bodyParams: {string} represents the body parameters
     */ ImsXhr.prototype.verifyError = function(url, bodyParams, exception) {
        this.storeApiResponse(url, bodyParams, exception);
        var httpErrorResponse = $9e679568df04bfd1$var$HttpErrorHandler_1.default.verify(exception, url);
        return Promise.reject(httpErrorResponse || exception.data);
    };
    /**
    *
    * @param response {any} - represents the back-end service
    * @param url url: {string} - url used to call the api
    * @param bodyParams {string} represents the body parameters
    */ ImsXhr.prototype.storeApiResponse = function(url, bodyParams, response) {
        if (bodyParams === void 0) bodyParams = '';
        $9e679568df04bfd1$var$Debouncer_1.default.storeApiResponse(url, bodyParams, response);
        return Promise.resolve(response.data);
    };
    return ImsXhr;
}());

});
parcelRegister("dtYSq", function(module, exports) {
"use strict";
/**
 * class used for caching the api calls for a second.
 * The flow is:
 * 1. make api call from ImsLib
 * 2. if the Debouncer cache already contains a response for that api/parameters -> return the cashed response
 *
 */ var $9d0d34ac181e6b46$var$__assign = module.exports && module.exports.__assign || function() {
    $9d0d34ac181e6b46$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d0d34ac181e6b46$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9d0d34ac181e6b46$var$Debouncer = /** @class */ function() {
    function Debouncer() {
        var _this = this;
        /**
         * debounce time value; one second
         */ this.DEBOUNCE_TIME = 1000;
        /**
         * dictionary with all executed methods for the last second
         */ this.cache = {};
        /**
         *
         * @param url {String} - url used to make the api
         * @param bodyParams {String} - the hash associated with the request parameters
         * @param response {ApiResponse} - data received as a http response
         */ this.storeApiResponse = function(url, bodyParams, response) {
            if (url === void 0) url = '';
            if (bodyParams === void 0) bodyParams = '';
            _this.cacheApiResponse(url, bodyParams, response);
        };
    }
    /**
     * starts to execute a specific API. if there is a cached response, it will be returned
     * @param url - api url
     * @param parameters - represents the parameters used to call the api
     */ Debouncer.prototype.getCachedApiResponse = function(url, parameters) {
        if (parameters === void 0) parameters = '';
        var hash = typeof parameters === 'string' ? parameters : JSON.stringify(parameters);
        var cachedUrlValues = this.cache[url];
        if (!cachedUrlValues) return null;
        var cachedHash = cachedUrlValues[hash];
        if (!cachedHash) return null;
        return cachedHash.data;
    };
    /**
     *
     * @param url {String} - url used to make the api
     * @param bodyParams {String} - the hash associated with the request parameters
     * @param response {ApiResponse} - data received as a http response
     */ Debouncer.prototype.cacheApiResponse = function(url, bodyParams, response) {
        if (url === void 0) url = '';
        if (bodyParams === void 0) bodyParams = '';
        var cachedUrlValues = this.cache[url];
        if (!cachedUrlValues) {
            cachedUrlValues = {};
            this.cache[url] = cachedUrlValues;
        }
        var timerId = this.createClearCachedDataTimer(url, bodyParams);
        cachedUrlValues[bodyParams] = {
            timerId: timerId,
            data: $9d0d34ac181e6b46$var$__assign({}, response)
        };
    };
    /**
     * create the timer for a url/hash
     * @param url - {string} - represents the url used to make the http call
     * @param hash {String} - the hash associated with the request parameters
     */ Debouncer.prototype.createClearCachedDataTimer = function(url, hash) {
        var _this = this;
        var timerId = setTimeout(function() {
            var cachedUrlValues = _this.cache[url] || {};
            var methodValues = cachedUrlValues[hash];
            if (!methodValues) return;
            if (methodValues && methodValues.timerId) {
                clearTimeout(methodValues.timerId);
                delete cachedUrlValues[hash];
            }
        }, this.DEBOUNCE_TIME);
        return timerId;
    };
    return Debouncer;
}();
module.exports.default = new $9d0d34ac181e6b46$var$Debouncer();

});

parcelRegister("3oYUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3pcdl = parcelRequire("3pcdl");

var $17lxq = parcelRequire("17lxq");

var $3s2dW = parcelRequire("3s2dW");
/**
 * class used to create a IHttpErrorResponse object in case the code is != 200
 */ var $27a2dca9e036da57$var$HttpErrorHandler = /** @class */ function() {
    function HttpErrorHandler() {
        this.adobeIdThinData = null;
    }
    HttpErrorHandler.prototype.verify = function(exception, url) {
        if (url === void 0) url = '';
        var status = exception.status, data = exception.data;
        if (!status) return new $3s2dW.HttpErrorResponse({
            error: 'networkError',
            message: data || ''
        });
        if (status == 401) return new $3s2dW.HttpErrorResponse({
            error: 'unauthorized'
        });
        var rideException = this.parseTokenResponseForRideErrors(data, url);
        if (rideException) return rideException;
        if (status == 409) return data;
        if (status == 429) return new $3s2dW.HttpErrorResponse({
            error: 'rate_limited',
            retryAfter: data.retryAfter ? parseInt(data.retryAfter) : 10
        });
        if (status.toString().match(/5\d{2}/g)) return new $3s2dW.HttpErrorResponse({
            error: 'server_error'
        });
        return null;
    };
    /**
        * parse the check token response to see if there are any ride errors
        * @param refreshException represents the response from check token call
        * @param url the called url; part of the PBA Expired Idle Session workaround
        * @returns a RideException or null in case that the error code is not one from RideExceptions
        */ HttpErrorHandler.prototype.parseTokenResponseForRideErrors = function(refreshException, url) {
        if (!refreshException) return null;
        var error = refreshException.error, jump = refreshException.jump;
        if (!error) return null;
        var isRideError = error.indexOf('ride_') === 0;
        if (!isRideError) {
            // the PBA Expired Idle Session workaround: If a check/token call fails
            // because the session has been idle longer that the org policy limit,
            // a `token_expired` error is returned. But it should've been a ride exception
            // so the user is redirected to SUSI. Until the fix is made in the backend
            // this workaround has been implemented
            if (error === 'token_expired' && url.indexOf('check/v6/token') >= 0) return new $17lxq.RideException('ride_pba_idle_session', '', true);
            return null;
        }
        var jumpValue = this.addRedirectUriToJump(error, jump);
        return new $17lxq.RideException(error, jumpValue);
    };
    HttpErrorHandler.prototype.addRedirectUriToJump = function(error, jump) {
        if (!jump || typeof jump !== 'string') return '';
        var jumpValue = jump;
        if (!this.adobeIdThinData) this.adobeIdThinData = new $3pcdl.AdobeIdThinData();
        var redirectUri = this.adobeIdThinData.computeRideRedirectUri(error);
        if (!redirectUri || redirectUri.length === 0) return jumpValue;
        try {
            var jumpUrl = new URL(jumpValue);
            jumpUrl.searchParams.append("redirect_uri", redirectUri);
            return jumpUrl.toString();
        } catch (e) {
            return jumpValue;
        }
    };
    /**
     * check if the exception status has the code equal 401
     * @param exception represents the exception caught during get profile method
     * @returns true if the status code is 401, otherwise false
     */ HttpErrorHandler.prototype.isUnauthorizedException = function(exception) {
        var _a = exception.status, status = _a === void 0 ? 0 : _a;
        return status === 401;
    };
    return HttpErrorHandler;
}();
module.exports.default = new $27a2dca9e036da57$var$HttpErrorHandler();

});
parcelRegister("17lxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RideException = void 0;
/**
 * class used to store the ride errors after a check token call
 */ var $0d0726e621ed5743$var$RideException = /** @class */ function() {
    function RideException(code, jump, isPbaExpiredIdleSessionWorkaround) {
        if (isPbaExpiredIdleSessionWorkaround === void 0) isPbaExpiredIdleSessionWorkaround = false;
        /**
         * new redirect url in case of a ride error
         */ this.jump = '';
        this.code = code;
        this.jump = jump;
        this.isPbaExpiredIdleSessionWorkaround = isPbaExpiredIdleSessionWorkaround;
    }
    return RideException;
}();
module.exports.RideException = $0d0726e621ed5743$var$RideException;

});

parcelRegister("3s2dW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpErrorResponse = void 0;
/**
 * class used to pass the http errors to external applications
 */ var $2835b63ac37aff61$var$HttpErrorResponse = /** @class */ function() {
    function HttpErrorResponse(data) {
        var error = data.error, _a = data.retryAfter, retryAfter = _a === void 0 ? 0 : _a, _b = data.message, message = _b === void 0 ? '' : _b;
        this.error = error;
        this.retryAfter = retryAfter;
        this.message = message;
    }
    return HttpErrorResponse;
}();
module.exports.HttpErrorResponse = $2835b63ac37aff61$var$HttpErrorResponse;

});




parcelRegister("98trQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfileException = void 0;

var $kKZ0Z = parcelRequire("kKZ0Z");
/**
 * class used to trigger profile errors
 */ var $6a6bb4377f923ed1$var$ProfileException = /** @class */ function() {
    function ProfileException(message) {
        this.message = null;
        this.errorType = $kKZ0Z.IErrorType.PROFILE_EXCEPTION;
        this.message = message;
    }
    return ProfileException;
}();
module.exports.ProfileException = $6a6bb4377f923ed1$var$ProfileException;

});
parcelRegister("kKZ0Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IErrorType = void 0;
/**
 * Enumeration values used for ims error types
 */ /**
 * Enumeration values used for ims error types
 */ var $f1c76ed11c71df04$var$IErrorType;
(function(IErrorType) {
    /**
     * error triggered in case of exception on adobe ims initialize
     */ IErrorType["INITIALIZE_ERROR"] = "initialize_error";
    /**
     * http exception type
     */ IErrorType["HTTP"] = "http";
    /**
     * fragment exception type
     */ IErrorType["FRAGMENT"] = "fragment";
    /**
     * csrf exception type
     */ IErrorType["CSRF"] = "csrf";
    /**
     * error triggered when get token method is called using a different api than the ones allowed
     */ IErrorType["NOT_ALLOWED"] = "not_allowed";
    /**
     * exception triggered when the profile api throws exception
     */ IErrorType["PROFILE_EXCEPTION"] = "profile_exception";
    /**
     * token expired error
     */ IErrorType["TOKEN_EXPIRED"] = "token_expired";
    /**
      * social providers error type
      */ IErrorType["SOCIAL_PROVIDERS"] = "SOCIAL_PROVIDERS";
    /**
    * ride exception sent to the client in case ther is no jump
    */ IErrorType["RIDE_EXCEPTION"] = "ride_exception";
    /**
     * error triggered when arkose has a loading error
     */ IErrorType["ARKOSE_ERROR"] = "arkose_error";
    /**
     * error triggered when BFP has a loading error
     */ IErrorType["BFP_ERROR"] = "bfp_error";
})($f1c76ed11c71df04$var$IErrorType || (module.exports.IErrorType = $f1c76ed11c71df04$var$IErrorType = {}));

});


parcelRegister("6eKgv", function(module, exports) {
"use strict";
var $48a7f03489f9ac1b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfileService = void 0;

var $48a7f03489f9ac1b$var$StorageFactory_1 = $48a7f03489f9ac1b$var$__importDefault((parcelRequire("kk2tv")));

var $5Qrtd = parcelRequire("5Qrtd");

var $98trQ = parcelRequire("98trQ");

var $3s2dW = parcelRequire("3s2dW");

var $enKKU = parcelRequire("enKKU");

var $48a7f03489f9ac1b$var$Log_1 = $48a7f03489f9ac1b$var$__importDefault((parcelRequire("62W4m")));
/**
 * class used to implement the profile methods
 */ var $48a7f03489f9ac1b$var$ProfileService = /** @class */ function() {
    function ProfileService(profileServiceRequest) {
        /**
         * in-memory fallback for profiles that exceed storage quota;
         * valid only for the lifetime of this ProfileService instance — not persisted on page reload
         */ this.memoryCache = new Map();
        this.profileServiceRequest = profileServiceRequest;
        this.storage = $48a7f03489f9ac1b$var$StorageFactory_1.default.getStorageByName($5Qrtd.STORAGE_MODE.SessionStorage);
    }
    /**
     *
     * @param token {string} - the string used to obtain the profile information
     */ ProfileService.prototype.getProfile = function(token) {
        var _this = this;
        var _a = this.profileServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis;
        var sessionProfile = this.getProfileFromStorage();
        if (sessionProfile) return Promise.resolve(sessionProfile);
        return imsApis.getProfile({
            client_id: clientId,
            token: token
        }).then(function(profile) {
            // const { data: profile } = response;
            if (!profile) throw new $98trQ.ProfileException('NO profile response');
            if (Object.keys(profile).length === 0) throw new $98trQ.ProfileException('NO profile value');
            _this.saveProfileToStorage(profile);
            return Promise.resolve(profile);
        }).catch(function(ex) {
            if (ex instanceof $3s2dW.HttpErrorResponse) return Promise.reject(ex);
            _this.removeProfile();
            return Promise.reject(ex);
        });
    };
    /**
    * private method used to compose the key used for storage
    * @param clientId
    * @param scope
    * @param isReAuth default false
    */ ProfileService.prototype.getProfileStorageKey = function() {
        var _a = this.profileServiceRequest, clientId = _a.clientId, scope = _a.scope;
        var isReAuth = false;
        return "".concat($5Qrtd.PROFILE_STORAGE_KEY, "/").concat(clientId, "/").concat(isReAuth, "/").concat((0, $enKKU.sortScopes)(scope));
    };
    /**
     * read the profile from session storage, fall back to memory cache
     */ ProfileService.prototype.getProfileFromStorage = function() {
        var profileStorageKey = this.getProfileStorageKey();
        var sessionProfile = this.storage.getItem(profileStorageKey);
        if (sessionProfile) try {
            return JSON.parse(sessionProfile);
        } catch (_e) {
            this.removeProfile();
        }
        return this.memoryCache.get(profileStorageKey) || null;
    };
    /**
     *
     * @param profile {Object} object containing the profile information
     * save the profile to memory cache and attempt to save to session storage
     */ ProfileService.prototype.saveProfileToStorage = function(profile) {
        var profileStorageKey = this.getProfileStorageKey();
        this.memoryCache.set(profileStorageKey, profile);
        try {
            this.storage.setItem(profileStorageKey, JSON.stringify(profile));
        } catch (_e) {
            $48a7f03489f9ac1b$var$Log_1.default.warn('profile session-storage write failed; using memory only', _e);
        }
    };
    /**
     * remove the profile value from session storage and memory cache
     */ ProfileService.prototype.removeProfile = function() {
        var profileStorageKey = this.getProfileStorageKey();
        this.storage.removeItem(profileStorageKey);
        this.memoryCache.delete(profileStorageKey);
    };
    /**
     *
     * @param userId {string} represents the user id of the new logged user
     * @returns { boolean } - true if the profile was removed, otherwise false
     */ ProfileService.prototype.removeProfileIfOtherUser = function(userId) {
        if (!userId) return;
        var profile = this.getProfileFromStorage();
        if (!profile || profile.userId === userId) return;
        this.removeProfile();
    };
    return ProfileService;
}();
module.exports.ProfileService = $48a7f03489f9ac1b$var$ProfileService;

});
parcelRegister("enKKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortScopes = $a7877b5da0317ccc$var$sortScopes;
module.exports.validateScopeInclusion = $a7877b5da0317ccc$var$validateScopeInclusion;
var $a7877b5da0317ccc$var$SCOPE_SEPARATOR = /\s|,/g;
var $a7877b5da0317ccc$var$SCOPE_GLUE = ',';
function $a7877b5da0317ccc$var$sortScopes(scopes) {
    return scopes.split($a7877b5da0317ccc$var$SCOPE_SEPARATOR).sort().join($a7877b5da0317ccc$var$SCOPE_GLUE);
}
function $a7877b5da0317ccc$var$validateScopeInclusion(requestedScope, tokenScope) {
    var tokenScopes = (tokenScope === null || tokenScope === void 0 ? void 0 : tokenScope.split($a7877b5da0317ccc$var$SCOPE_SEPARATOR)) || [];
    var requestedScopes = (requestedScope === null || requestedScope === void 0 ? void 0 : requestedScope.split($a7877b5da0317ccc$var$SCOPE_SEPARATOR)) || [];
    return requestedScopes.every(function(scope) {
        return tokenScopes.includes(scope);
    });
}

});


parcelRegister("gJKR4", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/camelcase */ var $c2f531b579b6a393$var$__assign = module.exports && module.exports.__assign || function() {
    $c2f531b579b6a393$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2f531b579b6a393$var$__assign.apply(this, arguments);
};
var $c2f531b579b6a393$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c2f531b579b6a393$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c2f531b579b6a393$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2f531b579b6a393$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenService = void 0;

var $c2f531b579b6a393$var$StorageFactory_1 = $c2f531b579b6a393$var$__importDefault((parcelRequire("kk2tv")));

var $5Qrtd = parcelRequire("5Qrtd");

var $hovA1 = parcelRequire("hovA1");

var $c2f531b579b6a393$var$FragmentHelper_1 = $c2f531b579b6a393$var$__importDefault((parcelRequire("8iphV")));

var $2XZAM = parcelRequire("2XZAM");

var $75WTM = parcelRequire("75WTM");

var $fSVUc = parcelRequire("fSVUc");

var $17lxq = parcelRequire("17lxq");

var $3qDJh = parcelRequire("3qDJh");

var $c2f531b579b6a393$var$Log_1 = $c2f531b579b6a393$var$__importDefault((parcelRequire("62W4m")));

var $3s2dW = parcelRequire("3s2dW");

var $l4OdL = parcelRequire("l4OdL");

var $Dph68 = parcelRequire("Dph68");

var $8a1xD = parcelRequire("8a1xD");

var $enKKU = parcelRequire("enKKU");

var $5aLgN = parcelRequire("5aLgN");

var $jdfZG = parcelRequire("jdfZG");

var $gqUk5 = parcelRequire("gqUk5");

var $gyCbV = parcelRequire("gyCbV");
var $c2f531b579b6a393$var$ALLOWED_FRAGMENT_APIS = [
    'authorize',
    'check_token'
];
var $c2f531b579b6a393$var$LOGOUT_API = 'logout';
var $c2f531b579b6a393$var$ONE_SECOND_MILLIS = 1000;
/**
 * class used to store the specific token methods
 */ var $c2f531b579b6a393$var$TokenService = /** @class */ function() {
    function TokenService(tokenServiceRequest, csrfService) {
        var _this = this;
        /**
         * tries to get a valid token; if there is no token, the refresh method is called
         * @param externalParameters represents the external parameters used for refresh token
         * @returns TokenProfileResponse
         */ this.getTokenAndProfile = function(externalParameters) {
            if (externalParameters === void 0) externalParameters = {};
            var tokenResponse = _this.getTokenFields();
            if (tokenResponse instanceof $Dph68.ModalSignInEvent) return Promise.reject(tokenResponse);
            if (tokenResponse instanceof $2XZAM.FragmentException) return Promise.reject(tokenResponse);
            if (tokenResponse instanceof $l4OdL.AuthorizationCode) {
                var imsApis = _this.tokenServiceRequest.imsApis;
                return imsApis.getTokenFromCode(tokenResponse, externalParameters).then(function(tokenApiResponse) {
                    var access_token = tokenApiResponse.access_token, state = tokenApiResponse.state, expires_in = tokenApiResponse.expires_in, _a = tokenApiResponse.scope, scope = _a === void 0 ? '' : _a, profile = $c2f531b579b6a393$var$__rest(tokenApiResponse, [
                        "access_token",
                        "state",
                        "expires_in",
                        "scope"
                    ]);
                    var tokenFields = new $hovA1.TokenFields({
                        scope: scope,
                        tokenValue: access_token,
                        valid: true,
                        state: state,
                        other: tokenResponse.other
                    }, new Date(new Date().getTime() + parseFloat(expires_in)));
                    return Promise.resolve(new $fSVUc.TokenProfileResponse(tokenFields, profile));
                });
            }
            if (tokenResponse instanceof $hovA1.TokenFields) {
                if (tokenResponse.fromFragment || !_this.tokenServiceRequest.autoValidateToken) return Promise.resolve(new $fSVUc.TokenProfileResponse(tokenResponse, null));
                return _this.callValidateTokenApi(tokenResponse.tokenValue, tokenResponse.isGuestToken).then(function() {
                    return new $fSVUc.TokenProfileResponse(tokenResponse, null);
                }).catch(function() {
                    return _this.callRefreshToken(externalParameters);
                });
            } else return _this.callRefreshToken(externalParameters);
        };
        var useLocalStorage = tokenServiceRequest.useLocalStorage;
        this.csrfService = csrfService;
        this.tokenServiceRequest = tokenServiceRequest;
        this.storage = $c2f531b579b6a393$var$StorageFactory_1.default.getStorageByName(useLocalStorage ? $5Qrtd.STORAGE_MODE.LocalStorage : $5Qrtd.STORAGE_MODE.SessionStorage);
    }
    /**
     *
     * @returns {TokenFields} representing the token fields from fragment or local storage
     */ TokenService.prototype.getTokenFields = function() {
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope;
        var fragmentResult = this.getTokenFromFragment();
        if (fragmentResult instanceof $Dph68.ModalSignInEvent) return fragmentResult;
        if (fragmentResult instanceof $2XZAM.FragmentException) return fragmentResult;
        if (fragmentResult instanceof $l4OdL.AuthorizationCode) return fragmentResult;
        if (fragmentResult && fragmentResult.validate(clientId, scope)) {
            fragmentResult.fromFragment = true;
            this.addTokenToStorage(fragmentResult);
            return fragmentResult;
        }
        return this.getTokenFieldsFromStorage();
    };
    /**
     * method used to validate the local storage token value
     */ TokenService.prototype.validateToken = function() {
        var tokenFields = this.getTokenFieldsFromStorage();
        if (!tokenFields) return Promise.reject(null);
        return this.callValidateTokenApi(tokenFields.tokenValue, tokenFields.isGuestToken);
    };
    /**
     * method used to retrieve the token release flags
     */ TokenService.prototype.getReleaseFlags = function() {
        var _a = this.tokenServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis;
        var tokenFields = this.getTokenFieldsFromStorage();
        if (!tokenFields) return Promise.reject(null);
        return imsApis.getReleaseFlags({
            token: tokenFields.tokenValue,
            client_id: clientId
        });
    };
    /**
     * method used to retrieve the token release flags decoded from B32
     */ TokenService.prototype.getDecodedReleaseFlags = function() {
        return this.getReleaseFlags().then(function(result) {
            return (0, $5aLgN.decodeToBitstring)(result.releaseFlags, true);
        });
    };
    /**
     * method used to call the validate token api
     * @param token {String} validate the input token value
     * @param isGuestToken {boolean} whether the token is a guest token or not
     */ TokenService.prototype.callValidateTokenApi = function(token, isGuestToken) {
        var _this = this;
        if (isGuestToken === void 0) isGuestToken = false;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope, imsApis = _a.imsApis;
        var validateTokenParameters = {
            client_id: clientId,
            token: token,
            type: isGuestToken ? 'at' : undefined
        };
        return imsApis.validateToken(validateTokenParameters).then(function(tokenResponseData) {
            $c2f531b579b6a393$var$Log_1.default.info('validateToken response', tokenResponseData);
            var tokenFields = new $hovA1.TokenFields($c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, tokenResponseData), {
                tokenValue: token
            }), new Date(parseFloat(tokenResponseData.expires_at)));
            if (tokenFields.validate(clientId, scope)) {
                _this.addTokenToStorage(tokenFields);
                return Promise.resolve(tokenFields);
            }
            throw new Error('could not validate tokenFields');
        }).catch(function(ex) {
            $c2f531b579b6a393$var$Log_1.default.error('validateToken response', ex);
            if (ex instanceof $3s2dW.HttpErrorResponse) return Promise.reject(ex);
            _this.removeTokenFromLocalStorage();
            return Promise.reject(ex);
        });
    };
    TokenService.prototype.getGuestToken = function() {
        return $c2f531b579b6a393$var$__awaiter(this, arguments, void 0, function(externalParameters, options) {
            var tokenResponse, hasToken, isGuestToken, shouldRunBotDetection, botDetectionTokens;
            if (externalParameters === void 0) externalParameters = {};
            return $c2f531b579b6a393$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenResponse = this.getTokenFields();
                        hasToken = !(tokenResponse instanceof $Dph68.ModalSignInEvent) && !(tokenResponse instanceof $l4OdL.AuthorizationCode) && tokenResponse instanceof $hovA1.TokenFields;
                        isGuestToken = hasToken && (tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.isGuestToken);
                        shouldRunBotDetection = !!options.enableGuestBotDetection && (!hasToken || isGuestToken && !tokenResponse.fdi);
                        botDetectionTokens = {};
                        if (!options.enableGuestAccounts) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!shouldRunBotDetection) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.runBotDetection(options.guestBotDetectionProvider)
                        ];
                    case 1:
                        botDetectionTokens = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (options.enableGuestTokenForceRefresh) {
                            if (tokenResponse instanceof $2XZAM.FragmentException && tokenResponse.type === $75WTM.IFragmentExceptionType.LOGOUT) return [
                                2 /*return*/ ,
                                this.callRefreshToken($c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, externalParameters), botDetectionTokens))
                            ];
                            if (isGuestToken) return [
                                2 /*return*/ ,
                                this.callRefreshToken($c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, externalParameters), botDetectionTokens))
                            ];
                        }
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            this.getTokenAndProfile($c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, externalParameters), botDetectionTokens))
                        ];
                }
            });
        });
    };
    /**
     * Runs the configured bot detection provider and returns the resulting token fields.
     * Only the key for the active provider is returned; the other provider's key is absent.
     * If no provider is set, an empty object is returned and bot detection is silently skipped.
     */ TokenService.prototype.runBotDetection = function(provider) {
        return $c2f531b579b6a393$var$__awaiter(this, void 0, void 0, function() {
            var _a, error_1, error_2;
            return $c2f531b579b6a393$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = provider;
                        switch(_a){
                            case 'bfp':
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case 'arkose':
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $gyCbV.BFPInitialization.getBFPInstance().callBFP()
                        ];
                    case 2:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _b.sent();
                        // if bfp fails continue with the check token with an empty fingerprintRequestId that IMS will ignore
                        return [
                            2 /*return*/ ,
                            {
                                fingerprintRequestId: undefined
                            }
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            {
                                fingerprintRequestId: $gyCbV.BFPInitialization.getBFPInstance().getBFPRequestId()
                            }
                        ];
                    case 5:
                        _b.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            $jdfZG.ArkoseInitialization.getArkoseInstance().callArkose()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        error_2 = _b.sent();
                        throw new $gqUk5.ArkoseException(error_2);
                    case 8:
                        return [
                            2 /*return*/ ,
                            {
                                arkoseSessionToken: $jdfZG.ArkoseInitialization.getArkoseInstance().getArkoseSessionToken()
                            }
                        ];
                    case 9:
                        $c2f531b579b6a393$var$Log_1.default.warn('enableGuestBotDetection is true but no guestBotDetectionProvider was set, skipping bot detection');
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                }
            });
        });
    };
    /**
     * @returns the object values from the url fragment
     */ TokenService.prototype.getTokenFromFragment = function(url) {
        var ignoreUrlToken = this.tokenServiceRequest.ignoreUrlToken;
        // If ignoreUrlToken is enabled, skip processing tokens from URL
        if (ignoreUrlToken) return null;
        var fragmentValues = $c2f531b579b6a393$var$FragmentHelper_1.default.fragmentToObject(url);
        if (!fragmentValues) return null;
        var token = fragmentValues.access_token, scope = fragmentValues.scope, error = fragmentValues.error, api = fragmentValues.api, _a = fragmentValues.state, state = _a === void 0 ? {} : _a, expires_in = fragmentValues.expires_in, client_id = fragmentValues.client_id, _b = fragmentValues.code, code = _b === void 0 ? '' : _b, other = $c2f531b579b6a393$var$__rest(fragmentValues, [
            "access_token",
            "scope",
            "error",
            "api",
            "state",
            "expires_in",
            "client_id",
            "code"
        ]);
        var _c = state || {}, imslibmodal = _c.imslibmodal, nonce = _c.nonce;
        if (imslibmodal === true) return new $Dph68.ModalSignInEvent(nonce);
        if ($c2f531b579b6a393$var$LOGOUT_API === api) {
            // if logout was called from another instance, or manually, 
            // remove the token from local storage
            this.removeTokenFromLocalStorage();
            return new $2XZAM.FragmentException($75WTM.IFragmentExceptionType.LOGOUT, 'logout callback');
        }
        if (!fragmentValues.from_ims) return null;
        if (client_id !== this.tokenServiceRequest.clientId) return null;
        if (error) return new $2XZAM.FragmentException($75WTM.IFragmentExceptionType.FRAGMENT, error);
        if (!$c2f531b579b6a393$var$ALLOWED_FRAGMENT_APIS.includes(api)) return new $2XZAM.FragmentException($75WTM.IFragmentExceptionType.API_NOT_ALLOWED, "api should be authorize or check token and ".concat(api, " is used"));
        var validCsrf = this.csrfService.verify(nonce);
        if (!validCsrf) return new $2XZAM.FragmentException($75WTM.IFragmentExceptionType.CSRF, 'CSRF exception');
        if (code) {
            var codeChallenge = new $8a1xD.CodeChallenge();
            var verifier = codeChallenge.getVerifierByKey(nonce);
            if (!verifier) throw new Error('no verifier value has been found');
            return new $l4OdL.AuthorizationCode($c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, fragmentValues), {
                verifier: verifier
            }));
        }
        if (!token) return null;
        var tokenFields = new $hovA1.TokenFields({
            client_id: client_id,
            scope: scope,
            tokenValue: token,
            valid: true,
            state: state,
            other: other
        }, new Date(new Date().getTime() + parseFloat(expires_in)));
        return tokenFields;
    };
    TokenService.prototype.getItemFromStorage = function(key) {
        return this.storage.getItem(key);
    };
    /**
     * @returns the TokenFields structure from local storage or null
     * @isReauth boolean value; true if token is for reauthentification
     */ TokenService.prototype.getTokenFieldsFromStorage = function(isReauth) {
        if (isReauth === void 0) isReauth = false;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope;
        var tokenStorageKey = this.getAccessTokenKey(isReauth);
        var tokenData = this.getItemFromStorage(tokenStorageKey);
        if (!tokenData) return null;
        var parsedToken = JSON.parse(tokenData);
        var expire = parsedToken.expire ? new Date(Date.parse(parsedToken.expire)) : new Date(parsedToken.expiresAtMilliseconds);
        var tokenFields = new $hovA1.TokenFields(parsedToken, expire);
        return tokenFields.validate(clientId, scope) ? tokenFields : null;
    };
    /**
     * private method used to compose the key used for storage
     * @param clientId
     * @param scope
     * @param isReAuth default false; true means that the key is for re-authentification
     */ TokenService.prototype.getAccessTokenKey = function(isReauth) {
        if (isReauth === void 0) isReauth = false;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope;
        return "".concat($5Qrtd.TOKEN_STORAGE_KEY, "/").concat(clientId, "/").concat(isReauth, "/").concat((0, $enKKU.sortScopes)(scope));
    };
    /**
     * save the token into local storage
     * @param tokenFragment - object with the values from fragment
     */ TokenService.prototype.addTokenToStorage = function(tokenFields) {
        if (!tokenFields) return;
        var isReauth = tokenFields.isReauth();
        var tokenStorageKey = this.getAccessTokenKey(isReauth);
        var clonedTokenFields = $c2f531b579b6a393$var$__assign({}, tokenFields);
        clonedTokenFields.state = {};
        clonedTokenFields.other = '{}';
        var storagePayload = JSON.stringify(clonedTokenFields);
        this.storage.setItem(tokenStorageKey, storagePayload);
    };
    /**
     * remove the token from local storage
     */ TokenService.prototype.removeTokenFromLocalStorage = function() {
        var tokenStorageKey = this.getAccessTokenKey();
        this.storage.removeItem(tokenStorageKey);
    };
    /**
     * remove the reauth token from local storage
     */ TokenService.prototype.removeReauthTokenFromLocalStorage = function() {
        var tokenStorageKey = this.getAccessTokenKey(true);
        this.storage.removeItem(tokenStorageKey);
    };
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @returns IRefreshTokenResponse containing the refresh token information
     */ TokenService.prototype.refreshToken = function(externalParameters) {
        var _this = this;
        if (externalParameters === void 0) externalParameters = {};
        var _a = this.tokenServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis, scope = _a.scope;
        var tokenFields = this.getTokenFieldsFromStorage();
        var userId = tokenFields ? tokenFields.user_id : '';
        return imsApis.checkToken({
            client_id: clientId,
            scope: scope
        }, externalParameters, userId).then(function(data) {
            if (!data) throw new Error('refresh token --> no response');
            var access_token = data.access_token, expires_in = data.expires_in, token_type = data.token_type, error = data.error, _a = data.error_description, error_description = _a === void 0 ? '' : _a, sid = data.sid, fdi = data.fdi, profileValues = $c2f531b579b6a393$var$__rest(data, [
                "access_token",
                "expires_in",
                "token_type",
                "error",
                "error_description",
                "sid",
                "fdi"
            ]);
            if (error) throw new Error("".concat(error, " ").concat(error_description));
            var profile = Object.keys(profileValues).length ? profileValues : null;
            var tokenInfo = {
                token: access_token,
                expire: new Date(Date.now() + parseFloat(expires_in)),
                token_type: token_type,
                sid: sid
            };
            var tokenFields = _this.updateToken(tokenInfo) || {};
            var refreshTokenResponse = {
                tokenInfo: $c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, tokenInfo), {
                    impersonatorId: tokenFields.impersonatorId || '',
                    isImpersonatedSession: tokenFields.isImpersonatedSession || false,
                    pbaSatisfiedPolicies: tokenFields.pbaSatisfiedPolicies || [],
                    isGuestToken: tokenFields.isGuestToken,
                    gse: tokenFields.gse,
                    fdi: tokenFields.fdi
                }),
                profile: profile
            };
            return Promise.resolve(refreshTokenResponse);
        }).catch(function(refreshTokenException) {
            if (refreshTokenException === void 0) refreshTokenException = {};
            if (refreshTokenException instanceof $3s2dW.HttpErrorResponse) return Promise.reject(refreshTokenException);
            if (refreshTokenException instanceof $17lxq.RideException) return Promise.reject(refreshTokenException);
            _this.removeTokenFromLocalStorage();
            return Promise.reject(new $3qDJh.TokenExpiredException(refreshTokenException));
        });
    };
    /**
     * function used to change the user profile
     * @param externalParameters external parameters received outside of the library
     * @param userId {String} represents the user id used to get the new token and profile
     * @returns IRefreshTokenResponse containing the refresh token information
     */ TokenService.prototype.switchProfile = function(userId, externalParameters) {
        var _this = this;
        if (externalParameters === void 0) externalParameters = {};
        var _a = this.tokenServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis, scope = _a.scope;
        return imsApis.switchProfile({
            client_id: clientId,
            scope: scope
        }, externalParameters, userId).then(function(data) {
            if (!data) throw new Error('refresh token --> no response');
            var access_token = data.access_token, expires_in = data.expires_in, token_type = data.token_type, error = data.error, _a = data.error_description, error_description = _a === void 0 ? '' : _a, sid = data.sid, profileValues = $c2f531b579b6a393$var$__rest(data, [
                "access_token",
                "expires_in",
                "token_type",
                "error",
                "error_description",
                "sid"
            ]);
            if (error) throw new Error("".concat(error, " ").concat(error_description));
            var profile = Object.keys(profileValues).length ? profileValues : null;
            var tokenInfo = {
                token: access_token,
                expire: new Date(Date.now() + parseFloat(expires_in)),
                token_type: token_type,
                sid: sid
            };
            var tokenFields = _this.updateToken(tokenInfo) || {};
            var refreshTokenResponse = {
                tokenInfo: $c2f531b579b6a393$var$__assign($c2f531b579b6a393$var$__assign({}, tokenInfo), {
                    impersonatorId: tokenFields.impersonatorId || '',
                    isImpersonatedSession: tokenFields.isImpersonatedSession || false
                }),
                profile: profile
            };
            return Promise.resolve(refreshTokenResponse);
        }).catch(function(switchTokenException) {
            if (switchTokenException === void 0) switchTokenException = {};
            return Promise.reject(switchTokenException);
        });
    };
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @returns IRefreshTokenResponse containing the refresh token information
     */ TokenService.prototype.callRefreshToken = function(externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        return this.refreshToken(externalParameters).then(function(tokenResponse) {
            var _a = tokenResponse.tokenInfo, token = _a.token, expire = _a.expire, profile = tokenResponse.profile;
            var refreshTokenFields = new $hovA1.TokenFields({
                valid: true,
                tokenValue: token
            }, expire);
            var tokenProfileResponse = new $fSVUc.TokenProfileResponse(refreshTokenFields, profile);
            return Promise.resolve(tokenProfileResponse);
        }).catch(function(ex) {
            return Promise.reject(ex);
        });
    };
    /**
     * update the token into local storage after a refresh action
     * @param tokenInfo {ITokenInformation}
     *
     */ TokenService.prototype.updateToken = function(tokenInfo) {
        var token = tokenInfo.token, expire = tokenInfo.expire;
        var tokenFields = new $hovA1.TokenFields({
            tokenValue: token
        }, expire);
        if (!tokenFields) return null;
        tokenFields.tokenValue = token;
        this.addTokenToStorage(tokenFields);
        return tokenFields;
    };
    /**
     * remove the tokens from the local storage
     */ TokenService.prototype.purge = function() {
        this.removeTokenFromLocalStorage();
        this.removeReauthTokenFromLocalStorage();
    };
    /**
     * set a new access token
     * @param tokenInfo {StandaloneToken} represents the token and expiration ms
     */ TokenService.prototype.setStandAloneToken = function(standaloneToken) {
        var token = standaloneToken.token, sid = standaloneToken.sid, _a = standaloneToken.expirems, expirems = _a === void 0 ? -1 : _a;
        var _b = this.tokenServiceRequest, clientId = _b.clientId, scope = _b.scope;
        var expire = new Date(new Date().getTime() + expirems);
        var tokenFields = new $hovA1.TokenFields({
            valid: true,
            tokenValue: token
        }, expire);
        if (!tokenFields.validate(clientId, scope)) return false;
        var tokenInfoToBeSaved = {
            expire: expire,
            token: token,
            sid: sid
        };
        this.updateToken(tokenInfoToBeSaved);
        return true;
    };
    /**
     * method used during initialization in order to get a ijt token
     * @returns {Promise<TokenProfileResponse>} ijt response
     */ TokenService.prototype.exchangeIjt = function(ijt) {
        var _this = this;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope, imsApis = _a.imsApis;
        var apiRequest = {
            client_id: clientId,
            scope: scope
        };
        return imsApis.exchangeIjt(apiRequest, ijt).then(function(ijtResponse) {
            var valid = ijtResponse.valid, access_token = ijtResponse.access_token, expires_in = ijtResponse.expires_in, profile = ijtResponse.profile;
            if (valid === false) return Promise.reject(ijtResponse);
            var expire = new Date(Date.now() + parseFloat(expires_in) * $c2f531b579b6a393$var$ONE_SECOND_MILLIS);
            var ijtTokenFields = new $hovA1.TokenFields({
                valid: true,
                tokenValue: access_token
            }, expire);
            _this.addTokenToStorage(ijtTokenFields);
            var tokenProfileResponse = new $fSVUc.TokenProfileResponse(ijtTokenFields, profile);
            return Promise.resolve(tokenProfileResponse);
        });
    };
    return TokenService;
}();
module.exports.TokenService = $c2f531b579b6a393$var$TokenService;

});
parcelRegister("hovA1", function(module, exports) {
"use strict";
var $ca9d2cad5b4785d1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenFields = void 0;

/* eslint-disable @typescript-eslint/camelcase */ var $ca9d2cad5b4785d1$var$ApiHelpers_1 = $ca9d2cad5b4785d1$var$__importDefault((parcelRequire("3zfSA")));

var $ca9d2cad5b4785d1$var$Log_1 = $ca9d2cad5b4785d1$var$__importDefault((parcelRequire("62W4m")));

var $enKKU = parcelRequire("enKKU");

var $aTSK8 = parcelRequire("aTSK8");
/**
 * class used to store the token fields obtained during validation and validate the token against values from adobeIdData
 */ var $ca9d2cad5b4785d1$var$TokenFields = /** @class */ function() {
    /**
     *
     * @param tokenProps {object} represents the server answer for a validation token request
     * @param expire {Date} represents the token expiration date
     *
     * this class is used to create a TokenFields instance based on storage object;
     * if token was saved by ImsLib v1, the token field is stored in access_token property and expiration in 'expiresAtMilliseconds',
     * otherwise, (for imsLIb v2) 'tokenValue' and 'expire' properties are used
     */ function TokenFields(tokenProps, expire) {
        var _this = this;
        this.REAUTH_SCOPE = 'reauthenticated';
        this.valid = false;
        this.isReauth = function() {
            return _this.scope.indexOf(_this.REAUTH_SCOPE) >= 0;
        };
        /**
         * represents the client id associated with this token fields
         */ this.client_id = '';
        /**
         * represents the scope used to retrieve the token
         */ this.scope = '';
        /**
         * represents the token expiration date
         */ this.expire = new Date();
        /**
         * represents the user_id associated with the token
         */ this.user_id = '';
        this.tokenValue = '';
        /**
         * represents the session identifier
         */ this.sid = '';
        this.state = null;
        /**
         * true if the token fields is created based on the fragment values and not from storage
         */ this.fromFragment = false;
        this.impersonatorId = '';
        this.isImpersonatedSession = false;
        var valid = tokenProps.valid, tokenValue = tokenProps.tokenValue, access_token = tokenProps.access_token, state = tokenProps.state, other = tokenProps.other;
        var token = tokenValue || access_token;
        var parsedToken = this.parseJwt(token);
        if (!parsedToken) throw new Error("token cannot be decoded ".concat(token));
        this.state = $ca9d2cad5b4785d1$var$ApiHelpers_1.default.toJson(state);
        var client_id = parsedToken.client_id, user_id = parsedToken.user_id, tokenScope = parsedToken.scope, sid = parsedToken.sid, imp_id = parsedToken.imp_id, imp_sid = parsedToken.imp_sid, pba = parsedToken.pba, atp = parsedToken.atp, gse = parsedToken.gse, fdi = parsedToken.fdi;
        this.atp = atp;
        this.client_id = client_id;
        this.expire = expire;
        this.user_id = user_id;
        this.scope = tokenScope;
        this.valid = valid;
        this.tokenValue = token;
        this.sid = sid;
        this.other = other;
        this.impersonatorId = imp_id || '';
        this.isImpersonatedSession = !!imp_sid;
        this.pbaSatisfiedPolicies = pba && pba.split(',') || [];
        this.isGuestToken = this.atp === $aTSK8.IAtpValues.GUEST;
        this.gse = gse;
        this.fdi = fdi;
    }
    /**
     * parse the token value
     */ TokenFields.prototype.parseJwt = function(token) {
        if (!token) return null;
        try {
            return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        } catch (ex) {
            $ca9d2cad5b4785d1$var$Log_1.default.error('error on decoding token ', token, ex);
            return null;
        }
    };
    /**
     *
     * @param adobeClientId client id provided on adobe id
     * @param adobeIdScope scope value provided in adobe id
     * @returns {boolean} true if token is valid otherwise false
     */ TokenFields.prototype.validate = function(adobeClientId, adobeIdScope) {
        var _a = this, valid = _a.valid, client_id = _a.client_id, scope = _a.scope, expire = _a.expire;
        // check if is expired
        if (expire < new Date()) {
            $ca9d2cad5b4785d1$var$Log_1.default.error('token invalid  --> expires_at', expire);
            return false;
        }
        if (valid != undefined && !valid) {
            $ca9d2cad5b4785d1$var$Log_1.default.error('token invalid  --> valid');
            return false;
        }
        if (client_id !== adobeClientId) {
            $ca9d2cad5b4785d1$var$Log_1.default.error('token invalid  --> client id', client_id, adobeClientId);
            return false;
        }
        if (!(0, $enKKU.validateScopeInclusion)(adobeIdScope, scope)) {
            $ca9d2cad5b4785d1$var$Log_1.default.error('token invalid  --> scope', ' token scope =', scope, 'vs adobeIdScope =', adobeIdScope, '.');
            return false;
        }
        return true;
    };
    return TokenFields;
}();
module.exports.TokenFields = $ca9d2cad5b4785d1$var$TokenFields;

});
parcelRegister("aTSK8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IAtpValues = void 0;
/**
 * Enum used to store the possible values of the atp field
 */ var $7ef9814dca11be66$var$IAtpValues;
(function(IAtpValues) {
    IAtpValues["GUEST"] = "guest";
})($7ef9814dca11be66$var$IAtpValues || (module.exports.IAtpValues = $7ef9814dca11be66$var$IAtpValues = {}));

});


parcelRegister("2XZAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FragmentException = void 0;
var $2290de668e0a83f3$var$FragmentException = /** @class */ function() {
    function FragmentException(type, message) {
        this.message = '';
        this.type = '';
        this.type = type;
        this.message = message;
    }
    return FragmentException;
}();
module.exports.FragmentException = $2290de668e0a83f3$var$FragmentException;

});

parcelRegister("75WTM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IFragmentExceptionType = void 0;
/**
 * Enumeration values used for defining possible fragment exception types
 *
 */ var $52a6b0186309bffc$var$IFragmentExceptionType;
(function(IFragmentExceptionType) {
    /**
     * fragment exception type
     */ IFragmentExceptionType["FRAGMENT"] = "fragment";
    /**
     * csrf exception type
     */ IFragmentExceptionType["CSRF"] = "csrf";
    IFragmentExceptionType["NOT_AUTHORIZE"] = "not_authorize";
    IFragmentExceptionType["API_NOT_ALLOWED"] = "not_allowed";
    IFragmentExceptionType["LOGOUT"] = "logout";
})($52a6b0186309bffc$var$IFragmentExceptionType || (module.exports.IFragmentExceptionType = $52a6b0186309bffc$var$IFragmentExceptionType = {}));

});

parcelRegister("fSVUc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenProfileResponse = void 0;
var $b908d0f33b0fb0c8$var$TokenProfileResponse = /** @class */ function() {
    function TokenProfileResponse(tokenFields, profile) {
        this.profile = null;
        this.tokenFields = tokenFields;
        this.profile = profile;
    }
    return TokenProfileResponse;
}();
module.exports.TokenProfileResponse = $b908d0f33b0fb0c8$var$TokenProfileResponse;

});

parcelRegister("3qDJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenExpiredException = void 0;
/**
 * class used to encapsulate the token expired message
 */ var $27f29e34037aa0e7$var$TokenExpiredException = /** @class */ function() {
    function TokenExpiredException(exception) {
        this.exception = null;
        this.exception = exception;
    }
    return TokenExpiredException;
}();
module.exports.TokenExpiredException = $27f29e34037aa0e7$var$TokenExpiredException;

});

parcelRegister("l4OdL", function(module, exports) {
"use strict";
var $f580ed8592d15a8d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthorizationCode = void 0;
/**
 * class used to store the authorization code fields
 */ var $f580ed8592d15a8d$var$AuthorizationCode = /** @class */ function() {
    /**
     * this class is used to create a AuthorizationCode instance based on authorization server response
     * @param authProps {object} represents the authorization server response
     */ function AuthorizationCode(authProps) {
        /**
         * represents the client id associated with this token fields
         */ this.client_id = '';
        /**
         * represents the scope used to retrieve the token
         */ this.scope = '';
        /**
         * represents the code recived during the authorization
         */ this.code = '';
        /**
         * represents the state used during initialize
         */ this.state = null;
        /**
         * represents the code_verifier used to generate the code_challenge (used during authorization flow)
         */ this.code_verifier = '';
        /**
         * represents the other properties from url
         */ this.other = null;
        var code = authProps.code, state = authProps.state, client_id = authProps.client_id, scope = authProps.scope, verifier = authProps.verifier, other = $f580ed8592d15a8d$var$__rest(authProps, [
            "code",
            "state",
            "client_id",
            "scope",
            "verifier"
        ]);
        this.state = state;
        this.client_id = client_id;
        this.code = code;
        this.scope = scope;
        this.code_verifier = verifier;
        this.other = other;
    }
    return AuthorizationCode;
}();
module.exports.AuthorizationCode = $f580ed8592d15a8d$var$AuthorizationCode;

});

parcelRegister("Dph68", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalSignInEvent = void 0;
/**
 * class used only by the popup window in order to know that the parent should be notified
 * it is triggered by getTokenFields if the redirect state contains imslibmodal propery
 * during imslib initialization, if this type of event is received than the parent window will be notified
 */ var $07673fad4141713d$var$ModalSignInEvent = /** @class */ function() {
    /**
     * this type of event is triggered by get token from fragment method (in case imslibmodal from fragment is true)
     * @param wndRedirectPropName {String} represents the property used by popup window to set the redirect url
     */ function ModalSignInEvent(wndRedirectPropName) {
        /**
         * represents the property used by popup window, to set the redirect url
         * this property will be used only if the popup.opener is not defined (edge bug)
         */ this.wndRedirectPropName = '';
        this.wndRedirectPropName = wndRedirectPropName;
    }
    return ModalSignInEvent;
}();
module.exports.ModalSignInEvent = $07673fad4141713d$var$ModalSignInEvent;

});

parcelRegister("5aLgN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeToBitstring = void 0;
/**
 * Base32 decoding module.
 * It uses the alphabet defined in {@link https://tools.ietf.org/html/rfc4648#page-9|RFC 4648}
*/ var $3c428dc287817fd8$var$alphabet = 'abcdefghijklmnopqrstuvwxyz234567'.split('');
var $3c428dc287817fd8$var$indexTable = $3c428dc287817fd8$var$alphabet.reduce(function(acc, curr, idx) {
    acc[curr] = idx;
    return acc;
}, {
    '=': 0
});
/**
     * Pads the string with the given char until the required length
     *
     * @param  {!string} ch The character used to pad
     * @param  {!number} num The required string length
     * @param  {!string} str The starting string to pad
     * @return {!string}
     */ var $3c428dc287817fd8$var$leftPad = function(ch, num, str) {
    var charsNeeded = num - str.length;
    if (charsNeeded > 0) // +1 here because we're using join
    str = new Array(charsNeeded + 1).join(ch) + str;
    return str;
};
/**
     * Converts a number to a string representation of it in binary and
     * pads it with 0s until it's 5 bits in length.
     *
     * @param  {!number} num The number
     * @return {!string} The padded binary string
     */ var $3c428dc287817fd8$var$toBase32PaddedBinary = function(num) {
    return $3c428dc287817fd8$var$leftPad('0', 5, num.toString(2));
};
var $3c428dc287817fd8$var$validateEncodedData = function(chars) {
    if (chars.length % 8 !== 0) throw new Error('Data length is not a multiple of 8');
    chars.forEach(function(ch) {
        if (!(ch in $3c428dc287817fd8$var$indexTable)) throw new Error('Unknown encoded character ' + ch);
    });
    var foundPaddingChar = false;
    chars.forEach(function(ch) {
        if (ch !== '=' && foundPaddingChar) throw new Error('Found padding char in the middle of the string');
        else if (ch === '=') foundPaddingChar = true;
    });
};
var $3c428dc287817fd8$var$countPadding = function(chars) {
    var idx = chars.length - 1;
    var count = 0;
    while(chars[idx] === '='){
        ++count;
        --idx;
    }
    return count;
};
/**
   * Converts every byte in a bitstring to it's least-significant-bit representation
   *
   * @example
   * var bitstring = '00000111';
   * bitstringToLSB(bitstring); // => '11100000'
   *
   * @param  {string} bitstring A string of 0s and 1s
   * @return {string} The LSB representation of the bitstring
   */ var $3c428dc287817fd8$var$bitstringToLSB = function(bitstring) {
    var BYTE_LENGTH = 8;
    var result = '';
    if (bitstring.length % 8 !== 0) throw new Error('Length must be a multiple of 8');
    for(var byteStart = 0, len = bitstring.length; byteStart < len; byteStart += BYTE_LENGTH){
        var byte = bitstring.slice(byteStart, byteStart + BYTE_LENGTH);
        result += byte.split('').reverse().join('');
    }
    return result;
};
/**
     * Decodes a base32-encoded string to a bitstring.
     *
     * The function uses the base32 alphabet defined in {@link https://tools.ietf.org/html/rfc4648#page-9|RFC 4648}.
     * This function does not take into account character aliases.
     *
     * @param  {!string} str The base32-encode data
     * @return {!string} A bitstring of the decoded data
     *
     * @throws {Error} If the data contains non-base32 characters
     *
     * @memberof module:base32
     * @public
     */ var $3c428dc287817fd8$var$decodeToBitstring = function(str, lsb) {
    /* Decoding algorithm
       * 1. validate data (length is multiple of 8, no unknown chars, padding is at the end)
       * 2. convert data to binary based on the lookup table
       * 3. remove extraneous 0s added from padding
       *   3.1. remove five 0s for each padding char =
       *   3.2. remove a 0 until data.length is a multiple of 8
       */ if (lsb === void 0) lsb = false;
    if (typeof str !== 'string') throw new Error('Data is not a string');
    var chars = str.toLowerCase().split('');
    $3c428dc287817fd8$var$validateEncodedData(chars);
    var paddingCount = $3c428dc287817fd8$var$countPadding(chars);
    var binary = [];
    chars.forEach(function(ch) {
        binary.push($3c428dc287817fd8$var$toBase32PaddedBinary($3c428dc287817fd8$var$indexTable[ch]));
    });
    var data = binary.join('');
    // remove padding:
    // five 0s for each `=`
    if (paddingCount > 0) data = data.slice(0, -5 * paddingCount);
    // remove all the 0s until data.length is dividable by 8
    if (data.length % 8 !== 0) data = data.slice(0, -1 * (data.length % 8));
    return lsb ? $3c428dc287817fd8$var$bitstringToLSB(data) : data;
};
module.exports.decodeToBitstring = $3c428dc287817fd8$var$decodeToBitstring;

});

parcelRegister("jdfZG", function(module, exports) {
"use strict";
var $dfcba3454272b18a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArkoseInitialization = void 0;

var $5Qrtd = parcelRequire("5Qrtd");

var $dfcba3454272b18a$var$Log_1 = $dfcba3454272b18a$var$__importDefault((parcelRequire("62W4m")));
/**
 * class used to store the Arkose helper functions
 */ var $dfcba3454272b18a$var$ArkoseInitialization = /** @class */ function() {
    function ArkoseInitialization() {
        this.arkoseSessionToken = null;
    }
    ArkoseInitialization.getArkoseInstance = function() {
        if (!this.arkoseInstance) ArkoseInitialization.arkoseInstance = new ArkoseInitialization();
        return ArkoseInitialization.arkoseInstance;
    };
    ArkoseInitialization.prototype.getArkoseSessionToken = function() {
        return this.arkoseSessionToken;
    };
    ArkoseInitialization.prototype.setArkoseSessionToken = function(sessionToken) {
        this.arkoseSessionToken = sessionToken;
    };
    /**
     * This method is used to add a script tag into the client page and load the Arkose script
     */ ArkoseInitialization.prototype.callArkose = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // add the init function to the window object
            // this function is called by arkose when everything is loaded and available
            window[$5Qrtd.SETUP_ARKOSE] = _this.setupArkose(resolve);
            var arkoseApiScript = document.createElement('script');
            arkoseApiScript.type = 'text/javascript';
            arkoseApiScript.src = $5Qrtd.ARKOSE_JS_ENDPOINT;
            arkoseApiScript.setAttribute('data-callback', 'setupArkose');
            arkoseApiScript.addEventListener("error", function(error) {
                $dfcba3454272b18a$var$Log_1.default.error("Arkose script failed to load", error);
                reject(error);
            });
            document.head.append(arkoseApiScript);
        });
    };
    ArkoseInitialization.prototype.setupArkose = function(resolve) {
        return function(myArkose) {
            myArkose.setConfig({
                onCompleted: function(response) {
                    $dfcba3454272b18a$var$Log_1.default.info("Arkose verification completed");
                    ArkoseInitialization.arkoseInstance.setArkoseSessionToken(response.token);
                    resolve();
                },
                onReady: function() {
                    myArkose.run();
                }
            });
        };
    };
    return ArkoseInitialization;
}();
module.exports.ArkoseInitialization = $dfcba3454272b18a$var$ArkoseInitialization;

});

parcelRegister("gqUk5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArkoseException = void 0;

var $kKZ0Z = parcelRequire("kKZ0Z");
var $bf6ac398790b6d03$var$ArkoseException = /** @class */ function() {
    function ArkoseException(message) {
        this.message = null;
        this.errorType = $kKZ0Z.IErrorType.ARKOSE_ERROR;
        this.message = message;
    }
    return ArkoseException;
}();
module.exports.ArkoseException = $bf6ac398790b6d03$var$ArkoseException;

});

parcelRegister("gyCbV", function(module, exports) {
"use strict";
var $c0dd72500a341215$var$__assign = module.exports && module.exports.__assign || function() {
    $c0dd72500a341215$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0dd72500a341215$var$__assign.apply(this, arguments);
};
var $c0dd72500a341215$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c0dd72500a341215$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c0dd72500a341215$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BFPInitialization = void 0;

var $5Qrtd = parcelRequire("5Qrtd");

var $c0dd72500a341215$var$Log_1 = $c0dd72500a341215$var$__importDefault((parcelRequire("62W4m")));
/**
 * class used to store the BFP helper functions
 */ var $c0dd72500a341215$var$BFPInitialization = /** @class */ function() {
    function BFPInitialization() {
        this.bfpRequestId = null;
    }
    BFPInitialization.getBFPInstance = function() {
        if (!this.bfpInstance) BFPInitialization.bfpInstance = new BFPInitialization();
        return BFPInitialization.bfpInstance;
    };
    BFPInitialization.prototype.getBFPRequestId = function() {
        return this.bfpRequestId;
    };
    BFPInitialization.prototype.setBFPRequestId = function(requestId) {
        this.bfpRequestId = requestId;
    };
    /**
     * Loads the BFP script, collects a fingerprint, publishes it, and stores the resulting request_id.
     */ BFPInitialization.prototype.callBFP = function() {
        return $c0dd72500a341215$var$__awaiter(this, void 0, void 0, function() {
            var BFPJS, fp, result, components, version, outputPayload, data;
            return $c0dd72500a341215$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!document.querySelector("script[src=\"".concat($5Qrtd.BFP_JS_ENDPOINT, "\"]"))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                var bfpScript = document.createElement('script');
                                bfpScript.type = 'text/javascript';
                                bfpScript.src = $5Qrtd.BFP_JS_ENDPOINT;
                                bfpScript.addEventListener('load', function() {
                                    return resolve();
                                });
                                bfpScript.addEventListener('error', function(error) {
                                    $c0dd72500a341215$var$Log_1.default.error('BFP script failed to load', error);
                                    reject(error);
                                });
                                document.head.append(bfpScript);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        BFPJS = window.BFPJS;
                        return [
                            4 /*yield*/ ,
                            BFPJS.load({
                                xApiKey: $5Qrtd.BFP_X_API_KEY,
                                env: 'prod',
                                debug: false
                            })
                        ];
                    case 3:
                        fp = _a.sent();
                        return [
                            4 /*yield*/ ,
                            fp.get()
                        ];
                    case 4:
                        result = _a.sent();
                        components = result.components, version = result.version;
                        outputPayload = $c0dd72500a341215$var$__assign($c0dd72500a341215$var$__assign({}, components), {
                            version: version
                        });
                        return [
                            4 /*yield*/ ,
                            BFPJS.publish(outputPayload)
                        ];
                    case 5:
                        data = _a.sent();
                        if (data.reason_code === 200) {
                            $c0dd72500a341215$var$Log_1.default.info('BFP fingerprint completed');
                            this.setBFPRequestId(data.request_id);
                        } else throw new Error("BFP publish failed with reason_code: ".concat(data.reason_code));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BFPInitialization;
}();
module.exports.BFPInitialization = $c0dd72500a341215$var$BFPInitialization;

});


parcelRegister("cMYyL", function(module, exports) {
"use strict";
var $94f8f19e565ec532$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $94f8f19e565ec532$var$Log_1 = $94f8f19e565ec532$var$__importDefault((parcelRequire("62W4m")));
/**
 * auto refresh minutes interval
 */ var $94f8f19e565ec532$var$ONE_MIN_MS = 60000;
var $94f8f19e565ec532$var$ONE_SECOND_MS = 1000;
var $94f8f19e565ec532$var$REFRESH_INTERVAL_BEFORE_EXPIRATION_MIN = 1;
var $94f8f19e565ec532$var$USER_INTERACTION_EVENTS = [
    'keyup',
    'mousemove'
];
/**
 * class used for automatically refresh the token.
 * the refreshToken method is automatically triggered one minute before the token expires
 * if the user interacted with the page at all after the startAutoRefreshFlow was called.
 */ var $94f8f19e565ec532$var$TokenAutoRefresh = /** @class */ function() {
    function TokenAutoRefresh() {
        var _this = this;
        /**
         * Holds the date of the last user interaction
         */ this.lastUserInteraction = Date.now();
        /**
         * Flag that the user was active at all during this refresh cycle
         */ this.userActive = false;
        /**
         * Handler for user interactions
         * Initiates the Token Refresh one minute before it expires, if any interaction is detected
         * Returns immediately if the refresh is already scheduled
         * @returns
         */ this.userInteractionHandler = function() {
            _this.lastUserInteraction = Date.now();
            _this.userActive = true;
        };
        /**
        * Initializes the event listeners for user interaction
        * The function passed must be the member bound to this instance
        */ this.initializeDomEvents = function() {
            $94f8f19e565ec532$var$USER_INTERACTION_EVENTS.forEach(function(eventName) {
                return window.addEventListener(eventName, _this.userInteractionHandler);
            });
        };
        /**
         * Clears event listeners
         */ this.clearDomEvents = function() {
            $94f8f19e565ec532$var$USER_INTERACTION_EVENTS.forEach(function(eventName) {
                return window.removeEventListener(eventName, _this.userInteractionHandler);
            });
        };
    }
    /**
     * starts the autorefresh flow
     * @param autoRefreshParameters {@link ITokenAutoRefreshParams} parameters used for auto refresh flow
     */ TokenAutoRefresh.prototype.startAutoRefreshFlow = function(autoRefreshParameters) {
        var _this = this;
        var _a;
        if (!autoRefreshParameters || !autoRefreshParameters.expire || !autoRefreshParameters.refreshTokenMethod) {
            $94f8f19e565ec532$var$Log_1.default.info('Won\'t schedule token auto-refresh', !autoRefreshParameters, !autoRefreshParameters.expire, !autoRefreshParameters.refreshTokenMethod);
            return;
        }
        this.refreshParameters = autoRefreshParameters;
        if (this.refreshTimerId) {
            $94f8f19e565ec532$var$Log_1.default.info('Auto-refresh timer already set, clearing');
            clearTimeout(this.refreshTimerId);
        }
        this.clearDomEvents();
        this.initializeDomEvents();
        var interval = this.fromNowToNMinutesBeforeDate((_a = this.refreshParameters) === null || _a === void 0 ? void 0 : _a.expire, $94f8f19e565ec532$var$REFRESH_INTERVAL_BEFORE_EXPIRATION_MIN);
        $94f8f19e565ec532$var$Log_1.default.info('Auto-refresh timer will run after (seconds)', interval / $94f8f19e565ec532$var$ONE_SECOND_MS);
        this.refreshTimerId = setTimeout(function() {
            var _a, _b;
            if (autoRefreshParameters.isGuest) {
                (_a = _this.refreshParameters) === null || _a === void 0 || _a.refreshTokenMethod({}, true);
                $94f8f19e565ec532$var$Log_1.default.info('Auto-refresh performed, guest user');
            } else if (_this.userActive) {
                var userInactiveSince = Math.floor((Date.now() - _this.lastUserInteraction) / $94f8f19e565ec532$var$ONE_SECOND_MS);
                (_b = _this.refreshParameters) === null || _b === void 0 || _b.refreshTokenMethod({
                    userInactiveSince: userInactiveSince
                }, true);
                $94f8f19e565ec532$var$Log_1.default.info('Auto-refresh performed, user was inactive for (seconds)', userInactiveSince);
            } else $94f8f19e565ec532$var$Log_1.default.info('Auto-refresh skipped, user was never active');
        }, interval);
    };
    /**
     * Returns the milliseconds interval from now to a given date minus N minutes
     * @param toDate represents the target date
     * @param nMinutes represents the number of minutes to substract from the target date
     * @returns the interval in milliseconds; if the resulting interval is <= 0,
     * this method returns nMinutes in ms
     */ TokenAutoRefresh.prototype.fromNowToNMinutesBeforeDate = function(toDate, nMinutes) {
        var interval = toDate.getTime() - Date.now() - nMinutes * $94f8f19e565ec532$var$ONE_MIN_MS;
        if (interval <= 0) return nMinutes * $94f8f19e565ec532$var$ONE_MIN_MS;
        return interval;
    };
    return TokenAutoRefresh;
}();
module.exports.default = new $94f8f19e565ec532$var$TokenAutoRefresh();

});

parcelRegister("ejqaF", function(module, exports) {
"use strict";
/**
 * Represents the type of account.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IAccountType = void 0;
var $a6b724155c4998d9$var$IAccountType;
(function(IAccountType) {
    /**
     * Represents the type of account as personal.
     */ IAccountType["TYPE1"] = "type1";
    /**
     * Represents the type of account as federated.
     */ IAccountType["TYPE3"] = "type3";
    /**
     * Represents the type of account as T2E.
     */ IAccountType["TYPE2E"] = "type2e";
    /**
     * Represents the type of account as guest.
     */ IAccountType["GUEST"] = "guest";
})($a6b724155c4998d9$var$IAccountType || (module.exports.IAccountType = $a6b724155c4998d9$var$IAccountType = {}));

});

parcelRegister("7RVR2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sanitizeException = $5baa5c54718592c3$var$sanitizeException;

var $3s2dW = parcelRequire("3s2dW");

var $17lxq = parcelRequire("17lxq");

var $2XZAM = parcelRequire("2XZAM");

var $98trQ = parcelRequire("98trQ");

var $3qDJh = parcelRequire("3qDJh");
/**
 * Sanitizes an exception object to extract only safe, non-sensitive information
 * that can be passed to external error handlers
 *
 * @param ex - The exception to sanitize (can be any type)
 * @returns A sanitized exception object with safe fields only
 *
 * @example
 * ```typescript
 * try {
 *   // some operation
 * } catch (ex) {
 *   const sanitized = sanitizeException(ex);
 *   onError(IErrorType.HTTP, "Error occurred", sanitized);
 * }
 * ```
 */ function $5baa5c54718592c3$var$sanitizeException(ex) {
    var _a;
    var sanitized = {};
    // Handle null/undefined
    if (!ex) return {
        name: 'Unknown',
        message: 'No exception details available'
    };
    // Handle HttpErrorResponse
    if (ex instanceof $3s2dW.HttpErrorResponse) {
        sanitized.name = 'HttpErrorResponse';
        sanitized.errorCode = ex.error;
        sanitized.message = ex.message || ex.error;
        sanitized.statusCode = $5baa5c54718592c3$var$getStatusCodeFromError(ex.error);
        sanitized.hint = $5baa5c54718592c3$var$getHintForHttpError(ex.error);
        if (ex.retryAfter) sanitized.hint = "".concat(sanitized.hint || '', " Retry after ").concat(ex.retryAfter, " seconds").trim();
        return sanitized;
    }
    // Handle RideException
    if (ex instanceof $17lxq.RideException) {
        sanitized.name = 'RideException';
        sanitized.errorCode = ex.code;
        sanitized.message = "RIDE error: ".concat(ex.code);
        sanitized.type = 'ride';
        sanitized.hint = ex.isPbaExpiredIdleSessionWorkaround ? 'PBA session expired - user needs to re-authenticate' : 'User needs to complete additional authentication steps';
        return sanitized;
    }
    // Handle FragmentException
    if (ex instanceof $2XZAM.FragmentException) {
        sanitized.name = 'FragmentException';
        sanitized.fragmentType = ex.type;
        sanitized.message = ex.message;
        sanitized.type = ex.type;
        sanitized.hint = $5baa5c54718592c3$var$getHintForFragmentType(ex.type);
        return sanitized;
    }
    // Handle ProfileException
    if (ex instanceof $98trQ.ProfileException) {
        sanitized.name = 'ProfileException';
        sanitized.type = 'profile_exception';
        sanitized.message = typeof ex.message === 'string' ? ex.message : 'Profile error occurred';
        sanitized.hint = 'Failed to retrieve or process user profile';
        return sanitized;
    }
    // Handle TokenExpiredException
    if (ex instanceof $3qDJh.TokenExpiredException) {
        sanitized.name = 'TokenExpiredException';
        sanitized.type = 'token_expired';
        sanitized.message = 'Access token has expired';
        sanitized.hint = 'User needs to re-authenticate or refresh token';
        return sanitized;
    }
    // Handle standard Error objects
    if (ex instanceof Error) {
        sanitized.name = ex.name || 'Error';
        sanitized.message = ex.message || 'An error occurred';
        return sanitized;
    }
    // Handle plain objects with error-like properties
    if (typeof ex === 'object') {
        var obj = ex;
        sanitized.name = obj.name || ((_a = obj.constructor) === null || _a === void 0 ? void 0 : _a.name) || 'Object';
        sanitized.message = obj.message || obj.error || obj.errorMessage || 'Unknown error';
        sanitized.type = obj.type || obj.errorType;
        sanitized.errorCode = obj.code || obj.errorCode || obj.error;
        sanitized.statusCode = obj.status || obj.statusCode;
        return sanitized;
    }
    // Handle primitive types (string, number, etc.)
    return {
        name: typeof ex,
        message: String(ex)
    };
}
/**
 * Get HTTP status code from error string
 */ function $5baa5c54718592c3$var$getStatusCodeFromError(error) {
    if (!error) return undefined;
    if (error === 'networkError') return 0;
    if (error === 'unauthorized') return 401;
    if (error === 'rate_limited') return 429;
    if (error === 'server_error') return 500;
    return undefined;
}
/**
 * Get helpful hint for HTTP errors
 */ function $5baa5c54718592c3$var$getHintForHttpError(error) {
    if (!error) return undefined;
    var hints = {
        'networkError': 'Check network connectivity',
        'unauthorized': 'Authentication required or token invalid',
        'rate_limited': 'Too many requests - please wait before retrying',
        'server_error': 'Server error - please try again later'
    };
    return hints[error];
}
/**
 * Get helpful hint for fragment exception types
 */ function $5baa5c54718592c3$var$getHintForFragmentType(type) {
    if (!type) return undefined;
    var hints = {
        'fragment': 'Invalid URL fragment parameters',
        'csrf': 'CSRF token validation failed',
        'not_authorize': 'Authorization failed',
        'not_allowed': 'Operation not allowed',
        'logout': 'User logged out'
    };
    return hints[type];
}

});

parcelRegister("5yTWj", function(module, exports) {
"use strict";
var $40cb85272b53aa8d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrganizationsService = void 0;

var $40cb85272b53aa8d$var$StorageFactory_1 = $40cb85272b53aa8d$var$__importDefault((parcelRequire("kk2tv")));

var $5Qrtd = parcelRequire("5Qrtd");

var $3s2dW = parcelRequire("3s2dW");

var $enKKU = parcelRequire("enKKU");

var $40cb85272b53aa8d$var$Log_1 = $40cb85272b53aa8d$var$__importDefault((parcelRequire("62W4m")));
/**
 * Storage key prefix for organizations cache
 */ var $40cb85272b53aa8d$var$ORGANIZATIONS_STORAGE_KEY = 'adobeims_organizations';
/**
 * Cache TTL in milliseconds (15 minutes for per-session cache)
 */ var $40cb85272b53aa8d$var$CACHE_TTL_MS = 900000;
/**
 * Required scope for organizations API
 */ var $40cb85272b53aa8d$var$REQUIRED_SCOPE = 'read_organizations';
/**
 * Service class for managing IMS Organizations data
 * Handles caching, normalization, and scope validation
 */ var $40cb85272b53aa8d$var$OrganizationsService = /** @class */ function() {
    function OrganizationsService(organizationsServiceRequest) {
        this.organizationsServiceRequest = organizationsServiceRequest;
        // Always use session storage for short-lived cache
        this.storage = $40cb85272b53aa8d$var$StorageFactory_1.default.getStorageByName($5Qrtd.STORAGE_MODE.SessionStorage);
    }
    /**
     * Get organizations for the logged-in user
     * @param token {string} - the access token with read_organizations scope
     * @returns Promise<INormalizedOrganizations>
     */ OrganizationsService.prototype.getOrganizations = function(token) {
        var _this = this;
        var _a = this.organizationsServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis, scope = _a.scope;
        // Check if token has required scope
        if (!this.hasRequiredScope(scope)) {
            $40cb85272b53aa8d$var$Log_1.default.warn('Token missing read_organizations scope');
            return Promise.reject(new Error('Token missing read_organizations scope'));
        }
        // Check cache first
        var cachedOrgs = this.getOrganizationsFromCache();
        if (cachedOrgs) {
            $40cb85272b53aa8d$var$Log_1.default.info('Returning cached organizations');
            return Promise.resolve(cachedOrgs);
        }
        // Fetch from API
        return imsApis.getOrganizations({
            client_id: clientId,
            token: token
        }).then(function(response) {
            if (!response) {
                $40cb85272b53aa8d$var$Log_1.default.warn('No organizations response');
                return Promise.reject(new Error('No organizations response received from API'));
            }
            var normalized = _this.normalizeResponse(response);
            _this.saveOrganizationsToCache(normalized);
            return normalized;
        }).catch(function(ex) {
            $40cb85272b53aa8d$var$Log_1.default.error('Get organizations error', ex);
            if (ex instanceof $3s2dW.HttpErrorResponse) // Reject for all HTTP errors
            return Promise.reject(ex);
            // For other errors, reject to allow ProfileService to handle
            return Promise.reject(ex);
        });
    };
    /**
     * Check if the scope includes read_organizations
     * @param scope {string} - the scope string from token/config
     * @returns {boolean}
     */ OrganizationsService.prototype.hasRequiredScope = function(scope) {
        if (!scope) return false;
        var scopes = scope.split(/\s|,/g);
        return scopes.includes($40cb85272b53aa8d$var$REQUIRED_SCOPE);
    };
    /**
     * Normalize the API response to a consistent structure
     * Response is always an array of organizations
     * @param response {IOrganizationsResponse}
     * @returns {INormalizedOrganizations}
     */ OrganizationsService.prototype.normalizeResponse = function(response) {
        var organizations = Array.isArray(response) ? response : response ? [
            response
        ] : [];
        var isSingleOrg = organizations.length === 1;
        return {
            organizations: organizations,
            count: organizations.length,
            isSingleOrg: isSingleOrg,
            fetchedAt: Date.now()
        };
    };
    /**
     * Get the storage key for organizations cache
     * @returns {string}
     */ OrganizationsService.prototype.getOrganizationsStorageKey = function() {
        var _a = this.organizationsServiceRequest, clientId = _a.clientId, scope = _a.scope;
        return "".concat($40cb85272b53aa8d$var$ORGANIZATIONS_STORAGE_KEY, "/").concat(clientId, "/").concat((0, $enKKU.sortScopes)(scope));
    };
    /**
     * Get organizations from cache if not expired
     * @returns {INormalizedOrganizations | null}
     */ OrganizationsService.prototype.getOrganizationsFromCache = function() {
        var storageKey = this.getOrganizationsStorageKey();
        var cachedData = this.storage.getItem(storageKey);
        if (!cachedData) return null;
        try {
            var parsed = JSON.parse(cachedData);
            // Check if cache is expired
            var now = Date.now();
            if (now - parsed.fetchedAt > $40cb85272b53aa8d$var$CACHE_TTL_MS) {
                $40cb85272b53aa8d$var$Log_1.default.info('Organizations cache expired');
                this.clearOrganizationsCache();
                return null;
            }
            return parsed;
        } catch (ex) {
            $40cb85272b53aa8d$var$Log_1.default.error('Error parsing cached organizations', ex);
            this.clearOrganizationsCache();
            return null;
        }
    };
    /**
     * Save organizations to cache
     * @param organizations {INormalizedOrganizations}
     */ OrganizationsService.prototype.saveOrganizationsToCache = function(organizations) {
        var storageKey = this.getOrganizationsStorageKey();
        this.storage.setItem(storageKey, JSON.stringify(organizations));
    };
    /**
     * Clear organizations cache
     */ OrganizationsService.prototype.clearOrganizationsCache = function() {
        var storageKey = this.getOrganizationsStorageKey();
        this.storage.removeItem(storageKey);
    };
    return OrganizationsService;
}();
module.exports.OrganizationsService = $40cb85272b53aa8d$var$OrganizationsService;

});




//# sourceMappingURL=web-src.dd548044.js.map
